export let professions = [
    {
        "id": 0,
        "name": "Animist",
        "bb": [
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    5
                ],
                "id": "13"
            },
            {
                "name": "Kateg Wahrnehmung",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    5
                ],
                "id": "14"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    5
                ],
                "id": "29"
            },
            {
                "name": "Magiepunkte entwickeln",
                "levelCosts": [
                    5
                ],
                "id": "15"
            },
            {
                "name": "Kategorie Zauber",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Kategorie Natur",
                "levelCosts": [
                    20
                ],
                "id": "16"
            },
            {
                "id": "16",
                "name": "Natur Tiere",
                "levelCosts": [
                    20
                ]
            },
            {
                "id": "17",
                "name": "Natur Umwelt",
                "levelCosts": [
                    20
                ]
            }
        ],
        "ff": [
            {
                "name": "Athletik Ausdauer",
                "levelCosts": [
                    3
                ],
                "id": "0"
            },
            {
                "name": "Spezialverteidigung",
                "levelCosts": [
                    40
                ],
                "id": "-1"
            },
            {
                "name": "Athletik Gymnastik",
                "levelCosts": [
                    3
                ],
                "id": "1"
            },
            {
                "name": "Staedtisch",
                "levelCosts": [
                    4
                ],
                "id": "22"
            },
            {
                "name": "Athletik Kraft",
                "levelCosts": [
                    4
                ],
                "id": "2"
            },
            {
                "name": "Tech Gewerbe Allgemein",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "23"
            },
            {
                "name": "Einflussnahme",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "3"
            },
            {
                "name": "Tech Gewerbe Beruflich",
                "levelCosts": [
                    5,
                    12
                ],
                "id": "24"
            },
            {
                "name": "Gezielte Sprueche",
                "levelCosts": [
                    3
                ],
                "id": "4"
            },
            {
                "name": "Tech Gewerbe Professionell",
                "levelCosts": [
                    8
                ],
                "id": "25"
            },
            {
                "name": "Handwerk",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "5"
            },
            {
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    6
                ],
                "id": "100"
            },
            {
                "name": "Kampfmanoever",
                "levelCosts": [
                    10
                ],
                "id": "6"
            },
            {
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    7
                ],
                "id": "101"
            },
            {
                "name": "Kommunikation",
                "levelCosts": [
                    2,
                    2,
                    2
                ],
                "id": "7"
            },
            {
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    9
                ],
                "id": "102"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    8
                ],
                "id": "8"
            },
            {
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    9
                ],
                "id": "103"
            },
            {
                "name": "Kunst Aktiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "9"
            },
            {
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    9
                ],
                "id": "104"
            },
            {
                "name": "Kunst Passiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    20
                ],
                "id": "106"
            },
            {
                "name": "List Angriff",
                "levelCosts": [
                    10
                ],
                "id": "10"
            },
            {
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    20
                ],
                "id": "107"
            },
            {
                "name": "List Mechanik",
                "levelCosts": [
                    8
                ],
                "id": "11"
            },
            {
                "name": "Waffenloser Kampf Schlag",
                "levelCosts": [
                    6
                ],
                "id": "-1"
            },
            {
                "name": "List Tarnung",
                "levelCosts": [
                    3
                ],
                "id": "12"
            },
            {
                "name": "Waffenloser Kampf Wurf",
                "levelCosts": [
                    6
                ],
                "id": "-1"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    4,
                    10
                ],
                "id": "13"
            },
            {
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "26"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "14"
            },
            {
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    1,
                    5
                ],
                "id": "27"
            },
            {
                "name": "Magiepunkte entwickeln",
                "levelCosts": [
                    4
                ],
                "id": "15"
            },
            {
                "name": "Wahrnehmung Unbewusst",
                "levelCosts": [
                    6
                ],
                "id": "-1"
            },
            {
                "name": "Natur Tiere",
                "levelCosts": [
                    1,
                    2
                ],
                "id": "16"
            },
            {
                "name": "Wissen Allgemein",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "28"
            },
            {
                "name": "Natur Umwelt",
                "levelCosts": [
                    1,
                    2
                ],
                "id": "17"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "29"
            },
            {
                "name": "Ruestung Leicht",
                "levelCosts": [
                    2,
                    2,
                    2
                ],
                "id": "18"
            },
            {
                "name": "Wissen Obskur",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "30"
            },
            {
                "name": "Ruestung Mittel",
                "levelCosts": [
                    10
                ],
                "id": "19"
            },
            {
                "name": "Wissen Technisch",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "31"
            },
            {
                "name": "Ruestung Schwer",
                "levelCosts": [
                    11
                ],
                "id": "20"
            },
            {
                "name": "Wissenschaft / Analytisch Allgemein",
                "levelCosts": [
                    1,
                    4
                ],
                "id": "32"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    5
                ],
                "id": "21"
            },
            {
                "name": "Wissenschaft / Analytisch Spezialisiert",
                "levelCosts": [
                    6,
                    14
                ],
                "id": "-1"
            },
            {
                "name": "Spezialangriff",
                "levelCosts": [
                    10
                ],
                "id": "-1"
            }
        ],
        "se": [
            {
                "name": "Offene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            10
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            6,
                            6,
                            6
                        ]
                    }
                ]
            },
            {
                "name": "Geschlossene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            5
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            6,
                            10
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            8,
                            8
                        ]
                    }
                ]
            },
            {
                "name": "Basislisten eigene",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            3,
                            3,
                            3
                        ]
                    }
                ]
            }
        ],
        "ap": [
            {
                "name": "Abenteurer",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Klatschtante",
                "levelCosts": [
                    18
                ]
            },
            {
                "name": "Akademiker",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Kraeuterkundiger T",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Assassine",
                "levelCosts": [
                    34
                ]
            },
            {
                "name": "Kriegsakademie",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Athlet",
                "levelCosts": [
                    34
                ]
            },
            {
                "name": "Meister des Wissens T",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Bauer",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Mutter",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Berserker",
                "levelCosts": [
                    36
                ]
            },
            {
                "name": "Philosoph",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Bettler",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Pirat",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Bibliothekar",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Professor T",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Detektiv",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Reisender",
                "levelCosts": [
                    13
                ]
            },
            {
                "name": "Diplomat",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Ritter",
                "levelCosts": [
                    40
                ]
            },
            {
                "name": "Doktor",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Schamane",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Edelmann",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Schreiber",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Eiferer",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Schwindler",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Einbrecher",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Scout T",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Entdecker",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Seemann",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Fechter",
                "levelCosts": [
                    54
                ]
            },
            {
                "name": "Sheriff",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Fuehrer",
                "levelCosts": [
                    18
                ]
            },
            {
                "name": "Soldat",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Gefolgsmann",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Soeldner",
                "levelCosts": [
                    35
                ]
            },
            {
                "name": "Gildenmitglied",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Spion",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Gladiator",
                "levelCosts": [
                    53
                ]
            },
            {
                "name": "Stadtwache",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Haendler T",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Strassenraeuber",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Handwerker",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Taschendieb",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Hobby Zauberer",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Tierarzt T",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Hostesse",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Tierfreund T",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Jaeger",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Unterhalter",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Kaemmerer",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Waffenmeister",
                "levelCosts": [
                    51
                ]
            },
            {
                "name": "Kaempe",
                "levelCosts": [
                    34
                ]
            },
            {
                "name": "Wanderer",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Kampfsportler",
                "levelCosts": [
                    35
                ]
            },
            {
                "name": "Wirt",
                "levelCosts": [
                    29
                ]
            }
        ]
    },
    {
        "id": 1,
        "name": "Barbar",
        "bb": [
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    15
                ],
                "id": "8"
            },
            {
                "name": "List Tarnung",
                "levelCosts": [
                    5
                ],
                "id": "12"
            },
            {
                "name": "Kategorie Natur",
                "levelCosts": [
                    10
                ],
                "id": "16"
            },
            {
                "name": "Kategorie Waffen",
                "levelCosts": [
                    15
                ],
                "id": "-1"
            },
            {
                "name": "Kateg Wahrnehmung",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "id": "16",
                "name": "Natur Tiere",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "17",
                "name": "Natur Umwelt",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "100",
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    15
                ]
            },
            {
                "id": "101",
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    15
                ]
            },
            {
                "id": "102",
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    15
                ]
            },
            {
                "id": "103",
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    15
                ]
            },
            {
                "id": "104",
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    15
                ]
            },
            {
                "id": "106",
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    15
                ]
            },
            {
                "id": "107",
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    15
                ]
            }
        ],
        "ff": [
            {
                "name": "Athletik Ausdauer",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "0"
            },
            {
                "name": "Spezialverteidigung",
                "levelCosts": [
                    25
                ],
                "id": "-1"
            },
            {
                "name": "Athletik Gymnastik",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "1"
            },
            {
                "name": "Staedtisch",
                "levelCosts": [
                    4
                ],
                "id": "22"
            },
            {
                "name": "Athletik Kraft",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "2"
            },
            {
                "name": "Tech Gewerbe Allgemein",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "23"
            },
            {
                "name": "Einflussnahme",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "3"
            },
            {
                "name": "Tech Gewerbe Beruflich",
                "levelCosts": [
                    5,
                    12
                ],
                "id": "24"
            },
            {
                "name": "Gezielte Sprueche",
                "levelCosts": [
                    20
                ],
                "id": "4"
            },
            {
                "name": "Tech Gewerbe Professionell",
                "levelCosts": [
                    8
                ],
                "id": "25"
            },
            {
                "name": "Handwerk",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "5"
            },
            {
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    1,
                    5
                ],
                "id": "100"
            },
            {
                "name": "Kampfmanoever",
                "levelCosts": [
                    4,
                    12
                ],
                "id": "6"
            },
            {
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "101"
            },
            {
                "name": "Kommunikation",
                "levelCosts": [
                    4,
                    4,
                    4
                ],
                "id": "7"
            },
            {
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    3,
                    8
                ],
                "id": "102"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "8"
            },
            {
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    4
                ],
                "id": "103"
            },
            {
                "name": "Kunst Aktiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "9"
            },
            {
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    4
                ],
                "id": "104"
            },
            {
                "name": "Kunst Passiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    6
                ],
                "id": "106"
            },
            {
                "name": "List Angriff",
                "levelCosts": [
                    3,
                    9
                ],
                "id": "10"
            },
            {
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    6
                ],
                "id": "107"
            },
            {
                "name": "List Mechanik",
                "levelCosts": [
                    3,
                    9
                ],
                "id": "11"
            },
            {
                "name": "Waffenloser Kampf Schlag",
                "levelCosts": [
                    3,
                    6
                ],
                "id": "-1"
            },
            {
                "name": "List Tarnung",
                "levelCosts": [
                    1,
                    4
                ],
                "id": "12"
            },
            {
                "name": "Waffenloser Kampf Wurf",
                "levelCosts": [
                    3,
                    8
                ],
                "id": "-1"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    18
                ],
                "id": "13"
            },
            {
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    1,
                    5
                ],
                "id": "26"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    8
                ],
                "id": "14"
            },
            {
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "27"
            },
            {
                "name": "Magiepunkte entwickeln",
                "levelCosts": [
                    20
                ],
                "id": "15"
            },
            {
                "name": "Wahrnehmung Unbewusst",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "-1"
            },
            {
                "name": "Natur Tiere",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "16"
            },
            {
                "name": "Wissen Allgemein",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "28"
            },
            {
                "name": "Natur Umwelt",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "17"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    6
                ],
                "id": "29"
            },
            {
                "name": "Ruestung Leicht",
                "levelCosts": [
                    2,
                    2,
                    2
                ],
                "id": "18"
            },
            {
                "name": "Wissen Obskur",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "30"
            },
            {
                "name": "Ruestung Mittel",
                "levelCosts": [
                    4,
                    4,
                    4
                ],
                "id": "19"
            },
            {
                "name": "Wissen Technisch",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "31"
            },
            {
                "name": "Ruestung Schwer",
                "levelCosts": [
                    10
                ],
                "id": "20"
            },
            {
                "name": "Wissenschaft / Analytisch Allgemein",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "32"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "21"
            },
            {
                "name": "Wissenschaft / Analytisch Spezialisiert",
                "levelCosts": [
                    15
                ],
                "id": "-1"
            },
            {
                "name": "Spezialangriff",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "-1"
            }
        ],
        "se": [
            {
                "name": "Offene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            5
                        ],
                        "costs": [
                            28
                        ]
                    }
                ]
            },
            {
                "name": "Geschlossene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            5
                        ],
                        "costs": [
                            45
                        ]
                    }
                ]
            },
            {
                "name": "Arkan offen",
                "progression": [
                    {
                        "levels": [
                            1,
                            5
                        ],
                        "costs": [
                            35
                        ]
                    }
                ]
            },
            {
                "name": "Andere Basisliste",
                "progression": [
                    {
                        "levels": [
                            1,
                            5
                        ],
                        "costs": [
                            90
                        ]
                    }
                ]
            }
        ],
        "ap": [
            {
                "name": "Abenteurer",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Klatschtante",
                "levelCosts": [
                    18
                ]
            },
            {
                "name": "Akademiker I",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Kraeuterkundiger T",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Assassine",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Kriegsakademie",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Athlet",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Meister des Wissens",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Bauer",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Mutter",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Berserker T",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Philosoph",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Bettler",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Pirat",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Bibliothekar I",
                "levelCosts": [
                    41
                ]
            },
            {
                "name": "Professor",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Detektiv",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Reisender",
                "levelCosts": [
                    14
                ]
            },
            {
                "name": "Diplomat",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Ritter I",
                "levelCosts": [
                    34
                ]
            },
            {
                "name": "Doktor",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Schamane",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Edelmann I",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Schreiber I",
                "levelCosts": [
                    33
                ]
            },
            {
                "name": "Eiferer",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Schwindler",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Einbrecher",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Scout T",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Entdecker",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Seemann",
                "levelCosts": [
                    18
                ]
            },
            {
                "name": "Fechter",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Sheriff",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Fuehrer T",
                "levelCosts": [
                    18
                ]
            },
            {
                "name": "Soldat",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Gefolgsmann",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Soeldner",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Gildenmitglied I",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Spion",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Gladiator",
                "levelCosts": [
                    39
                ]
            },
            {
                "name": "Stadtwache I",
                "levelCosts": [
                    21
                ]
            },
            {
                "name": "Haendler I",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Strassenraeuber",
                "levelCosts": [
                    16
                ]
            },
            {
                "name": "Handwerker",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Taschendieb",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Hobby Zauberer I",
                "levelCosts": [
                    36
                ]
            },
            {
                "name": "Tierarzt",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Hostesse",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Tierfreund T",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Jaeger T",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Unterhalter",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Kaemmerer I",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Waffenmeister",
                "levelCosts": [
                    34
                ]
            },
            {
                "name": "Kaempe",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Wanderer",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Kampfsportler",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Wirt I",
                "levelCosts": [
                    30
                ]
            }
        ]
    },
    {
        "id": 2,
        "name": "Barde",
        "bb": [
            {
                "name": "Einflussnahme",
                "levelCosts": [
                    5
                ],
                "id": "3"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    5
                ],
                "id": "21"
            },
            {
                "name": "Kommunikation",
                "levelCosts": [
                    5
                ],
                "id": "7"
            },
            {
                "name": "Kategorie Wahrnehmung",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    5
                ],
                "id": "8"
            },
            {
                "name": "Kategorie Waffen",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Kunst Aktiv",
                "levelCosts": [
                    5
                ],
                "id": "9"
            },
            {
                "name": "Kategorie Wissen",
                "levelCosts": [
                    10
                ],
                "id": "-1"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    5
                ],
                "id": "14"
            },
            {
                "id": "26",
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "27",
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "100",
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "101",
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "102",
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "103",
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "104",
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "106",
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "107",
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "28",
                "name": "Wissen Allgemein",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "29",
                "name": "Wissen Magisch",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "30",
                "name": "Wissen Obskur",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "31",
                "name": "Wissen Technisch",
                "levelCosts": [
                    10
                ]
            }
        ],
        "ff": [
            {
                "name": "Athletik Ausdauer",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "0"
            },
            {
                "name": "Spezialverteidigung",
                "levelCosts": [
                    20
                ],
                "id": "-1"
            },
            {
                "name": "Athletik Gymnastik",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "1"
            },
            {
                "name": "Staedtisch",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "22"
            },
            {
                "name": "Athletik Kraft",
                "levelCosts": [
                    4,
                    9
                ],
                "id": "2"
            },
            {
                "name": "Tech Gewerbe Allgemein",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "23"
            },
            {
                "name": "Einflussnahme",
                "levelCosts": [
                    1,
                    4
                ],
                "id": "3"
            },
            {
                "name": "Tech Gewerbe Beruflich",
                "levelCosts": [
                    5,
                    12
                ],
                "id": "24"
            },
            {
                "name": "Gezielte Sprueche",
                "levelCosts": [
                    10
                ],
                "id": "4"
            },
            {
                "name": "Tech Gewerbe Professionell",
                "levelCosts": [
                    8
                ],
                "id": "25"
            },
            {
                "name": "Handwerk",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "5"
            },
            {
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    3,
                    9
                ],
                "id": "100"
            },
            {
                "name": "Kampfmanoever",
                "levelCosts": [
                    6,
                    14
                ],
                "id": "6"
            },
            {
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    6
                ],
                "id": "101"
            },
            {
                "name": "Kommunikation",
                "levelCosts": [
                    1,
                    1,
                    1
                ],
                "id": "7"
            },
            {
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    7
                ],
                "id": "102"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    6,
                    14
                ],
                "id": "8"
            },
            {
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    7
                ],
                "id": "103"
            },
            {
                "name": "Kunst Aktiv",
                "levelCosts": [
                    1,
                    2
                ],
                "id": "9"
            },
            {
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    7
                ],
                "id": "104"
            },
            {
                "name": "Kunst Passiv",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "-1"
            },
            {
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    15
                ],
                "id": "106"
            },
            {
                "name": "List Angriff",
                "levelCosts": [
                    12
                ],
                "id": "10"
            },
            {
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    15
                ],
                "id": "107"
            },
            {
                "name": "List Mechanik",
                "levelCosts": [
                    4
                ],
                "id": "11"
            },
            {
                "name": "Waffenloser Kampf Schlag",
                "levelCosts": [
                    3
                ],
                "id": "-1"
            },
            {
                "name": "List Tarnung",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "12"
            },
            {
                "name": "Waffenloser Kampf Wurf",
                "levelCosts": [
                    3
                ],
                "id": "-1"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    6,
                    12
                ],
                "id": "13"
            },
            {
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "26"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    3,
                    6
                ],
                "id": "14"
            },
            {
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "27"
            },
            {
                "name": "Magiepunkte entwickeln",
                "levelCosts": [
                    8
                ],
                "id": "15"
            },
            {
                "name": "Wahrnehmung Unbewusst",
                "levelCosts": [
                    4,
                    12
                ],
                "id": "-1"
            },
            {
                "name": "Natur Tiere",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "16"
            },
            {
                "name": "Wissen Allgemein",
                "levelCosts": [
                    1,
                    2
                ],
                "id": "28"
            },
            {
                "name": "Natur Umwelt",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "17"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    1,
                    4
                ],
                "id": "29"
            },
            {
                "name": "Ruestung Leicht",
                "levelCosts": [
                    2,
                    2,
                    2
                ],
                "id": "18"
            },
            {
                "name": "Wissen Obskur",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "30"
            },
            {
                "name": "Ruestung Mittel",
                "levelCosts": [
                    3,
                    3,
                    3
                ],
                "id": "19"
            },
            {
                "name": "Wissen Technisch",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "31"
            },
            {
                "name": "Ruestung Schwer",
                "levelCosts": [
                    5,
                    5,
                    5
                ],
                "id": "20"
            },
            {
                "name": "Wissenschaft / Analytisch Allgemein",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "32"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "21"
            },
            {
                "name": "Wissenschaft / Analytisch Spezialisiert",
                "levelCosts": [
                    8
                ],
                "id": "-1"
            },
            {
                "name": "Spezialangriff",
                "levelCosts": [
                    6
                ],
                "id": "-1"
            }
        ],
        "se": [
            {
                "name": "Offene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            10
                        ],
                        "costs": [
                            8,
                            8
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            12
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            18
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            25
                        ]
                    }
                ]
            },
            {
                "name": "Geschlossene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            5
                        ],
                        "costs": [
                            10,
                            10
                        ]
                    },
                    {
                        "levels": [
                            6,
                            10
                        ],
                        "costs": [
                            12
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            25
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            40
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            60
                        ]
                    }
                ]
            },
            {
                "name": "Basislisten alle",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            6,
                            6,
                            6
                        ]
                    }
                ]
            }
        ],
        "ap": [
            {
                "name": "Abenteurer",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Klatschtante T",
                "levelCosts": [
                    12
                ]
            },
            {
                "name": "Akademiker T",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Kraeuterkundiger",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Assassine",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Kriegsakademie",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Athlet",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Meister des Wissens T",
                "levelCosts": [
                    18
                ]
            },
            {
                "name": "Bauer",
                "levelCosts": [
                    33
                ]
            },
            {
                "name": "Mutter",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Berserker",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Philosoph",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Bettler",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Pirat",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Bibliothekar",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Professor T",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Detektiv",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Reisender",
                "levelCosts": [
                    14
                ]
            },
            {
                "name": "Diplomat T",
                "levelCosts": [
                    19
                ]
            },
            {
                "name": "Ritter",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Doktor",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Schamane",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Edelmann",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Schreiber",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Eiferer T",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Schwindler T",
                "levelCosts": [
                    19
                ]
            },
            {
                "name": "Einbrecher",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Scout",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Entdecker",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Seemann T",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Fechter",
                "levelCosts": [
                    42
                ]
            },
            {
                "name": "Sheriff",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Fuehrer",
                "levelCosts": [
                    19
                ]
            },
            {
                "name": "Soldat",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Gefolgsmann",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Soeldner",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Gildenmitglied",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Spion",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Gladiator",
                "levelCosts": [
                    48
                ]
            },
            {
                "name": "Stadtwache",
                "levelCosts": [
                    21
                ]
            },
            {
                "name": "Haendler",
                "levelCosts": [
                    21
                ]
            },
            {
                "name": "Strassenraeuber",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Handwerker",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Taschendieb",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Hobby Zauberer",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Tierarzt",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Hostesse T",
                "levelCosts": [
                    16
                ]
            },
            {
                "name": "Tierfreund",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Jaeger",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Unterhalter T",
                "levelCosts": [
                    16
                ]
            },
            {
                "name": "Kaemmerer",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Waffenmeister",
                "levelCosts": [
                    43
                ]
            },
            {
                "name": "Kaempe",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Wanderer",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Kampfsportler",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Wirt T",
                "levelCosts": [
                    26
                ]
            }
        ]
    },
    {
        "id": 3,
        "name": "Dieb",
        "bb": [
            {
                "name": "Athletik Gymnastik",
                "levelCosts": [
                    5
                ],
                "id": "1"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    5
                ],
                "id": "8"
            },
            {
                "name": "Kategorie List",
                "levelCosts": [
                    15
                ],
                "id": "-1"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    5
                ],
                "id": "21"
            },
            {
                "name": "Kategorie Waffen",
                "levelCosts": [
                    10
                ],
                "id": "-1"
            },
            {
                "name": "Kategorie Wahrnehmung",
                "levelCosts": [
                    10
                ],
                "id": "-1"
            },
            {
                "id": "10",
                "name": "List Angriff",
                "levelCosts": [
                    15
                ]
            },
            {
                "id": "11",
                "name": "List Mechanik",
                "levelCosts": [
                    15
                ]
            },
            {
                "id": "12",
                "name": "List Tarnung",
                "levelCosts": [
                    15
                ]
            },
            {
                "id": "100",
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "101",
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "102",
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "103",
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "104",
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "106",
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "107",
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "26",
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "27",
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    10
                ]
            }
        ],
        "ff": [
            {
                "name": "Athletik Ausdauer",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "0"
            },
            {
                "name": "Spezialverteidigung",
                "levelCosts": [
                    35
                ],
                "id": "-1"
            },
            {
                "name": "Athletik Gymnastik",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "1"
            },
            {
                "name": "Staedtisch",
                "levelCosts": [
                    1,
                    2
                ],
                "id": "22"
            },
            {
                "name": "Athletik Kraft",
                "levelCosts": [
                    3,
                    6
                ],
                "id": "2"
            },
            {
                "name": "Tech Gewerbe Allgemein",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "23"
            },
            {
                "name": "Einflussnahme",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "3"
            },
            {
                "name": "Tech Gewerbe Beruflich",
                "levelCosts": [
                    5,
                    12
                ],
                "id": "24"
            },
            {
                "name": "Gezielte Sprueche",
                "levelCosts": [
                    20
                ],
                "id": "4"
            },
            {
                "name": "Tech Gewerbe Professionell",
                "levelCosts": [
                    8
                ],
                "id": "25"
            },
            {
                "name": "Handwerk",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "5"
            },
            {
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "100"
            },
            {
                "name": "Kampfmanoever",
                "levelCosts": [
                    4,
                    12
                ],
                "id": "6"
            },
            {
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    3,
                    8
                ],
                "id": "101"
            },
            {
                "name": "Kommunikation",
                "levelCosts": [
                    3,
                    3,
                    3
                ],
                "id": "7"
            },
            {
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    4
                ],
                "id": "102"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    5,
                    12
                ],
                "id": "8"
            },
            {
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    4
                ],
                "id": "103"
            },
            {
                "name": "Kunst Aktiv",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "9"
            },
            {
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    4
                ],
                "id": "104"
            },
            {
                "name": "Kunst Passiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    6
                ],
                "id": "106"
            },
            {
                "name": "List Angriff",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "10"
            },
            {
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    6
                ],
                "id": "107"
            },
            {
                "name": "List Mechanik",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "11"
            },
            {
                "name": "Waffenloser Kampf Schlag",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "-1"
            },
            {
                "name": "List Tarnung",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "12"
            },
            {
                "name": "Waffenloser Kampf Wurf",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "-1"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    18
                ],
                "id": "13"
            },
            {
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "26"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    6
                ],
                "id": "14"
            },
            {
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "27"
            },
            {
                "name": "Magiepunkte entwickeln",
                "levelCosts": [
                    15
                ],
                "id": "15"
            },
            {
                "name": "Wahrnehmung Unbewusst",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Natur Tiere",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "16"
            },
            {
                "name": "Wissen Allgemein",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "28"
            },
            {
                "name": "Natur Umwelt",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "17"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    5
                ],
                "id": "29"
            },
            {
                "name": "Ruestung Leicht",
                "levelCosts": [
                    2,
                    2,
                    2
                ],
                "id": "18"
            },
            {
                "name": "Wissen Obskur",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "30"
            },
            {
                "name": "Ruestung Mittel",
                "levelCosts": [
                    3,
                    3,
                    3
                ],
                "id": "19"
            },
            {
                "name": "Wissen Technisch",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "31"
            },
            {
                "name": "Ruestung Schwer",
                "levelCosts": [
                    4,
                    4,
                    4
                ],
                "id": "20"
            },
            {
                "name": "Wissenschaft / Analytisch Allg",
                "levelCosts": [
                    3,
                    6
                ],
                "id": "28"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "21"
            },
            {
                "name": "Wissenschaft / Analytisch Spezialisiert",
                "levelCosts": [
                    12
                ],
                "id": "-1"
            },
            {
                "name": "Spezialangriff",
                "levelCosts": [
                    2,
                    8
                ],
                "id": "-1"
            }
        ],
        "se": [
            {
                "name": "Offene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            5
                        ],
                        "costs": [
                            18
                        ]
                    },
                    {
                        "levels": [
                            6,
                            10
                        ],
                        "costs": [
                            36
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            54
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            72
                        ]
                    },
                    {
                        "levels": [
                            21
                        ],
                        "costs": [
                            90
                        ]
                    }
                ]
            },
            {
                "name": "Geschlossene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            5
                        ],
                        "costs": [
                            35
                        ]
                    },
                    {
                        "levels": [
                            6,
                            10
                        ],
                        "costs": [
                            70
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            105
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            140
                        ]
                    },
                    {
                        "levels": [
                            21
                        ],
                        "costs": [
                            175
                        ]
                    }
                ]
            }
        ],
        "ap": [
            {
                "name": "Abenteurer",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Klatschtante",
                "levelCosts": [
                    18
                ]
            },
            {
                "name": "Akademiker",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Kraeuterkundiger",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Assassine",
                "levelCosts": [
                    16
                ]
            },
            {
                "name": "Kriegsakademie",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Athlet",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Meister des Wissens",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Bauer",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Mutter",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Berserker",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Philosoph",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Bettler T",
                "levelCosts": [
                    16
                ]
            },
            {
                "name": "Pirat",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Bibliothekar I",
                "levelCosts": [
                    38
                ]
            },
            {
                "name": "Professor",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Detektiv",
                "levelCosts": [
                    18
                ]
            },
            {
                "name": "Reisender",
                "levelCosts": [
                    12
                ]
            },
            {
                "name": "Diplomat",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Ritter I",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Doktor",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Schamane",
                "levelCosts": [
                    33
                ]
            },
            {
                "name": "Edelmann",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Schreiber",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Eiferer",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Schwindler T",
                "levelCosts": [
                    18
                ]
            },
            {
                "name": "Einbrecher T",
                "levelCosts": [
                    16
                ]
            },
            {
                "name": "Scout T",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Entdecker",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Seemann",
                "levelCosts": [
                    19
                ]
            },
            {
                "name": "Fechter",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Sheriff I",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Fuehrer",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Soldat",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Gefolgsmann",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Soeldner",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Gildenmitglied",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Spion T",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Gladiator",
                "levelCosts": [
                    44
                ]
            },
            {
                "name": "Stadtwache I",
                "levelCosts": [
                    17
                ]
            },
            {
                "name": "Haendler",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Strassenraeuber T",
                "levelCosts": [
                    21
                ]
            },
            {
                "name": "Handwerker",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Taschendieb T",
                "levelCosts": [
                    15
                ]
            },
            {
                "name": "Hobby Zauberer",
                "levelCosts": [
                    37
                ]
            },
            {
                "name": "Tierarzt",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Hostesse",
                "levelCosts": [
                    19
                ]
            },
            {
                "name": "Tierfreund",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Jaeger",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Unterhalter",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Kaemmerer",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Waffenmeister",
                "levelCosts": [
                    34
                ]
            },
            {
                "name": "Kaempe",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Wanderer",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Kampfsportler",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Wirt",
                "levelCosts": [
                    27
                ]
            }
        ]
    },
    {
        "id": 4,
        "name": "Gelehrter",
        "bb": [
            {
                "name": "Kommunikation",
                "levelCosts": [
                    10
                ],
                "id": "7"
            },
            {
                "name": "Kategorie Wissen",
                "levelCosts": [
                    20
                ],
                "id": "-1"
            },
            {
                "name": "Kategorie Waffen",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Kategorie Wissenschaft / Anal",
                "levelCosts": [
                    10
                ],
                "id": "-1"
            },
            {
                "name": "Kat Wahrnehmung",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "id": "28",
                "name": "Wissen Allgemein",
                "levelCosts": [
                    20
                ]
            },
            {
                "id": "29",
                "name": "Wissen Magisch",
                "levelCosts": [
                    20
                ]
            },
            {
                "id": "30",
                "name": "Wissen Obskur",
                "levelCosts": [
                    20
                ]
            },
            {
                "id": "31",
                "name": "Wissen Technisch",
                "levelCosts": [
                    20
                ]
            },
            {
                "id": "100",
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "101",
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "102",
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "103",
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "104",
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "106",
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "107",
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    5
                ]
            }
        ],
        "ff": [
            {
                "name": "Athletik Ausdauer",
                "levelCosts": [
                    3,
                    6
                ],
                "id": "0"
            },
            {
                "name": "Spezialverteidigung",
                "levelCosts": [
                    40
                ],
                "id": "-1"
            },
            {
                "name": "Athletik Gymnastik",
                "levelCosts": [
                    3,
                    6
                ],
                "id": "1"
            },
            {
                "name": "Staedtisch",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "22"
            },
            {
                "name": "Athletik Kraft",
                "levelCosts": [
                    3,
                    6
                ],
                "id": "2"
            },
            {
                "name": "Tech Gewerbe Allgemein",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "23"
            },
            {
                "name": "Einflussnahme",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "3"
            },
            {
                "name": "Tech Gewerbe Beruflich",
                "levelCosts": [
                    5,
                    12
                ],
                "id": "24"
            },
            {
                "name": "Gezielte Sprueche",
                "levelCosts": [
                    15
                ],
                "id": "4"
            },
            {
                "name": "Tech Gewerbe Professionell",
                "levelCosts": [
                    8
                ],
                "id": "25"
            },
            {
                "name": "Handwerk",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "5"
            },
            {
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    3,
                    6
                ],
                "id": "100"
            },
            {
                "name": "Kampfmanoever",
                "levelCosts": [
                    6,
                    12
                ],
                "id": "6"
            },
            {
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    3,
                    8
                ],
                "id": "101"
            },
            {
                "name": "Kommunikation",
                "levelCosts": [
                    1,
                    1,
                    1
                ],
                "id": "7"
            },
            {
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    5
                ],
                "id": "102"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    5,
                    12
                ],
                "id": "8"
            },
            {
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    6
                ],
                "id": "103"
            },
            {
                "name": "Kunst Aktiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "9"
            },
            {
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    8
                ],
                "id": "104"
            },
            {
                "name": "Kunst Passiv",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "-1"
            },
            {
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    15
                ],
                "id": "106"
            },
            {
                "name": "List Angriff",
                "levelCosts": [
                    6,
                    12
                ],
                "id": "10"
            },
            {
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    15
                ],
                "id": "107"
            },
            {
                "name": "List Mechanik",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "11"
            },
            {
                "name": "Waffenloser Kampf Schlag",
                "levelCosts": [
                    4,
                    10
                ],
                "id": "-1"
            },
            {
                "name": "List Tarnung",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "12"
            },
            {
                "name": "Waffenloser Kampf Wurf",
                "levelCosts": [
                    4,
                    10
                ],
                "id": "-1"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    10
                ],
                "id": "13"
            },
            {
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "26"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    6
                ],
                "id": "14"
            },
            {
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "27"
            },
            {
                "name": "Magiepunkte entwickeln",
                "levelCosts": [
                    12
                ],
                "id": "15"
            },
            {
                "name": "Wahrnehmung Unbewusst",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "-1"
            },
            {
                "name": "Natur Tiere",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "16"
            },
            {
                "name": "Wissen Allgemein",
                "levelCosts": [
                    1,
                    2
                ],
                "id": "28"
            },
            {
                "name": "Natur Umwelt",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "17"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "29"
            },
            {
                "name": "Ruestung Leicht",
                "levelCosts": [
                    4,
                    4,
                    4
                ],
                "id": "18"
            },
            {
                "name": "Wissen Obskur",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "30"
            },
            {
                "name": "Ruestung Mittel",
                "levelCosts": [
                    10
                ],
                "id": "19"
            },
            {
                "name": "Wissen Technisch",
                "levelCosts": [
                    1,
                    4
                ],
                "id": "31"
            },
            {
                "name": "Ruestung Schwer",
                "levelCosts": [
                    11
                ],
                "id": "20"
            },
            {
                "name": "Wissenschaft / Analytisch Allg",
                "levelCosts": [
                    1,
                    2
                ],
                "id": "28"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    3
                ],
                "id": "21"
            },
            {
                "name": "Wissenschaft / Analytisch Spezialisiert",
                "levelCosts": [
                    4,
                    10
                ],
                "id": "-1"
            },
            {
                "name": "Spezialangriff",
                "levelCosts": [
                    10
                ],
                "id": "-1"
            }
        ],
        "se": [
            {
                "name": "Fremder Bereich offen",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            50
                        ]
                    }
                ]
            },
            {
                "name": "Fremder Bereich geschl",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            85
                        ]
                    }
                ]
            },
            {
                "name": "Fremder Bereich Basis",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            110
                        ]
                    }
                ]
            },
            {
                "name": "Eigener Bereich offen",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            12
                        ]
                    }
                ]
            },
            {
                "name": "Eigener Bereich geschlossen",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            20
                        ]
                    }
                ]
            },
            {
                "name": "Eigener Bereich fremde Basis",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            40
                        ]
                    }
                ]
            },
            {
                "name": "Arkan offen",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            18
                        ]
                    }
                ]
            }
        ],
        "ap": [
            {
                "name": "Abenteurer",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Klatschtante",
                "levelCosts": [
                    16
                ]
            },
            {
                "name": "Akademiker T",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Kraeuterkundiger",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Assassine",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Kriegsakademie",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Athlet",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Meister des Wissens T",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Bauer",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Mutter",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Berserker",
                "levelCosts": [
                    33
                ]
            },
            {
                "name": "Philosoph",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Bettler",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Pirat",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Bibliothekar T",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Professor T",
                "levelCosts": [
                    16
                ]
            },
            {
                "name": "Detektiv",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Reisender",
                "levelCosts": [
                    15
                ]
            },
            {
                "name": "Diplomat",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Ritter",
                "levelCosts": [
                    40
                ]
            },
            {
                "name": "Doktor",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Schamane",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Edelmann",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Schreiber T",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Eiferer",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Schwindler",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Einbrecher",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Scout",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Entdecker",
                "levelCosts": [
                    34
                ]
            },
            {
                "name": "Seemann",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Fechter",
                "levelCosts": [
                    36
                ]
            },
            {
                "name": "Sheriff",
                "levelCosts": [
                    35
                ]
            },
            {
                "name": "Fuehrer",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Soldat",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Gefolgsmann",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Soeldner",
                "levelCosts": [
                    36
                ]
            },
            {
                "name": "Gildenmitglied",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Spion",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Gladiator",
                "levelCosts": [
                    47
                ]
            },
            {
                "name": "Stadtwache",
                "levelCosts": [
                    21
                ]
            },
            {
                "name": "Haendler",
                "levelCosts": [
                    18
                ]
            },
            {
                "name": "Strassenraeuber",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Handwerker",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Taschendieb",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Hobby Zauberer",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Tierarzt",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Hostesse",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Tierfreund",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Jaeger",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Unterhalter",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Kaemmerer",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Waffenmeister",
                "levelCosts": [
                    50
                ]
            },
            {
                "name": "Kaempe",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Wanderer",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Kampfsportler",
                "levelCosts": [
                    35
                ]
            },
            {
                "name": "Wirt",
                "levelCosts": [
                    27
                ]
            }
        ]
    },
    {
        "id": 5,
        "name": "Haudegen",
        "bb": [
            {
                "name": "Kampfmanoever",
                "levelCosts": [
                    15
                ],
                "id": "6"
            },
            {
                "name": "Kommunikation",
                "levelCosts": [
                    5
                ],
                "id": "7"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    5
                ],
                "id": "8"
            },
            {
                "name": "Kategorie Ruestung",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Kategorie Waffen",
                "levelCosts": [
                    10
                ],
                "id": "-1"
            },
            {
                "name": "Kategorie Wissen",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Kat Waffenloser Kampf",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "id": "100",
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "101",
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "102",
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "103",
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "104",
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "106",
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "107",
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "28",
                "name": "Wissen Allgemein",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "29",
                "name": "Wissen Magisch",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "30",
                "name": "Wissen Obskur",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "31",
                "name": "Wissen Technisch",
                "levelCosts": [
                    5
                ]
            }
        ],
        "ff": [
            {
                "name": "Athletik Ausdauer",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "0"
            },
            {
                "name": "Spezialverteidigung",
                "levelCosts": [
                    8,
                    15
                ],
                "id": "-1"
            },
            {
                "name": "Athletik Gymnastik",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "1"
            },
            {
                "name": "Staedtisch",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "22"
            },
            {
                "name": "Athletik Kraft",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "2"
            },
            {
                "name": "Tech Gewerbe Allgemein",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "23"
            },
            {
                "name": "Einflussnahme",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "3"
            },
            {
                "name": "Tech Gewerbe Beruflich",
                "levelCosts": [
                    5,
                    12
                ],
                "id": "24"
            },
            {
                "name": "Gezielte Sprueche",
                "levelCosts": [
                    20
                ],
                "id": "4"
            },
            {
                "name": "Tech Gewerbe Professionell",
                "levelCosts": [
                    8
                ],
                "id": "25"
            },
            {
                "name": "Handwerk",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "5"
            },
            {
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "100"
            },
            {
                "name": "Kampfmanoever",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "6"
            },
            {
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "101"
            },
            {
                "name": "Kommunikation",
                "levelCosts": [
                    2,
                    2,
                    2
                ],
                "id": "7"
            },
            {
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "102"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    4,
                    10
                ],
                "id": "8"
            },
            {
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "103"
            },
            {
                "name": "Kunst Aktiv",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "9"
            },
            {
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    3,
                    8
                ],
                "id": "104"
            },
            {
                "name": "Kunst Passiv",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "-1"
            },
            {
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    3,
                    8
                ],
                "id": "106"
            },
            {
                "name": "List Angriff",
                "levelCosts": [
                    4,
                    8
                ],
                "id": "10"
            },
            {
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    3,
                    9
                ],
                "id": "107"
            },
            {
                "name": "List Mechanik",
                "levelCosts": [
                    3,
                    8
                ],
                "id": "11"
            },
            {
                "name": "Waffenloser Kampf Schlag",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "-1"
            },
            {
                "name": "List Tarnung",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "12"
            },
            {
                "name": "Waffenloser Kampf Wurf",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "-1"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    14
                ],
                "id": "13"
            },
            {
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "26"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    7
                ],
                "id": "14"
            },
            {
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "27"
            },
            {
                "name": "Magiepunkte entwickeln",
                "levelCosts": [
                    14
                ],
                "id": "15"
            },
            {
                "name": "Wahrnehmung Unbewusst",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "-1"
            },
            {
                "name": "Natur Tiere",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "16"
            },
            {
                "name": "Wissen Allgemein",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "28"
            },
            {
                "name": "Natur Umwelt",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "17"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    4
                ],
                "id": "29"
            },
            {
                "name": "Ruestung Leicht",
                "levelCosts": [
                    1,
                    1,
                    1
                ],
                "id": "18"
            },
            {
                "name": "Wissen Obskur",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "30"
            },
            {
                "name": "Ruestung Mittel",
                "levelCosts": [
                    4,
                    4,
                    4
                ],
                "id": "19"
            },
            {
                "name": "Wissen Technisch",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "31"
            },
            {
                "name": "Ruestung Schwer",
                "levelCosts": [
                    6,
                    6,
                    6
                ],
                "id": "20"
            },
            {
                "name": "Wissenschaft / Analytisch Allgemein",
                "levelCosts": [
                    3,
                    6
                ],
                "id": "32"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "21"
            },
            {
                "name": "Wissenschaft / Analytisch Spezialisiert",
                "levelCosts": [
                    12
                ],
                "id": "-1"
            },
            {
                "name": "Spezialangriff",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "-1"
            }
        ],
        "se": [
            {
                "name": "Fremder Bereich offen",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            60
                        ]
                    }
                ]
            },
            {
                "name": "Fremder Bereich geschl",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            90
                        ]
                    }
                ]
            },
            {
                "name": "Fremder Bereich Basis",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            120
                        ]
                    }
                ]
            },
            {
                "name": "Eigener Breich fremde Basis",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            50
                        ]
                    }
                ]
            },
            {
                "name": "Eigener Bereich offen",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            15
                        ]
                    }
                ]
            },
            {
                "name": "Eigener Bereich geschlossen",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            25
                        ]
                    }
                ]
            },
            {
                "name": "Arkan offen",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            20
                        ]
                    }
                ]
            }
        ],
        "ap": [
            {
                "name": "Abenteurer",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Klatschtante",
                "levelCosts": [
                    16
                ]
            },
            {
                "name": "Akademiker",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Kraeuterkundiger",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Assassine",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Kriegsakademie",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Athlet",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Meister des Wissens",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Bauer",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Mutter",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Berserker",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Philosoph",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Bettler",
                "levelCosts": [
                    18
                ]
            },
            {
                "name": "Pirat",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Bibliothekar",
                "levelCosts": [
                    35
                ]
            },
            {
                "name": "Professor",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Detektiv",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Reisender",
                "levelCosts": [
                    13
                ]
            },
            {
                "name": "Diplomat",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Ritter",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Doktor",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Schamane",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Edelmann",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Schreiber",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Eiferer",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Schwindler",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Einbrecher",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Scout",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Entdecker",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Seemann",
                "levelCosts": [
                    19
                ]
            },
            {
                "name": "Fechter",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Sheriff",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Fuehrer",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Soldat",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Gefolgsmann",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Soeldner",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Gildenmitglied",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Spion",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Gladiator",
                "levelCosts": [
                    39
                ]
            },
            {
                "name": "Stadtwache",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Haendler",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Strassenraeuber",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Handwerker",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Taschendieb",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Hobby Zauberer",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Tierarzt",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Hostesse",
                "levelCosts": [
                    19
                ]
            },
            {
                "name": "Tierfreund",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Jaeger",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Unterhalter",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Kaemmerer",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Waffenmeister",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Kaempe",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Wanderer",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Kampfsportler",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Wirt",
                "levelCosts": [
                    27
                ]
            }
        ]
    },
    {
        "id": 6,
        "name": "Heiler",
        "bb": [
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    10
                ],
                "id": "8"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    10
                ],
                "id": "21"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    5
                ],
                "id": "13"
            },
            {
                "name": "Kategorie Wahrnehmung",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    5
                ],
                "id": "14"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    5
                ],
                "id": "29"
            },
            {
                "name": "Magiepunkte entwickeln",
                "levelCosts": [
                    5
                ],
                "id": "15"
            },
            {
                "name": "Kategorie Zauber",
                "levelCosts": [
                    10
                ],
                "id": "-1"
            },
            {
                "id": "26",
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "27",
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    5
                ]
            }
        ],
        "ff": [
            {
                "name": "Athletik Ausdauer",
                "levelCosts": [
                    3
                ],
                "id": "0"
            },
            {
                "name": "Spezialverteidigung",
                "levelCosts": [
                    25
                ],
                "id": "-1"
            },
            {
                "name": "Athletik Gymnastik",
                "levelCosts": [
                    3
                ],
                "id": "1"
            },
            {
                "name": "Staedtisch",
                "levelCosts": [
                    3
                ],
                "id": "22"
            },
            {
                "name": "Athletik Kraft",
                "levelCosts": [
                    6
                ],
                "id": "2"
            },
            {
                "name": "Tech Gewerbe Allgemein",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "23"
            },
            {
                "name": "Einflussnahme",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "3"
            },
            {
                "name": "Tech Gewerbe Beruflich",
                "levelCosts": [
                    5,
                    12
                ],
                "id": "24"
            },
            {
                "name": "Gezielte Sprueche",
                "levelCosts": [
                    3
                ],
                "id": "4"
            },
            {
                "name": "Tech Gewerbe Professionell",
                "levelCosts": [
                    8
                ],
                "id": "25"
            },
            {
                "name": "Handwerk",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "5"
            },
            {
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    9
                ],
                "id": "100"
            },
            {
                "name": "Kampfmanoever",
                "levelCosts": [
                    18
                ],
                "id": "6"
            },
            {
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    20
                ],
                "id": "101"
            },
            {
                "name": "Kommunikation",
                "levelCosts": [
                    2,
                    2,
                    2
                ],
                "id": "7"
            },
            {
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    20
                ],
                "id": "102"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "8"
            },
            {
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    20
                ],
                "id": "103"
            },
            {
                "name": "Kunst Aktiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "9"
            },
            {
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    20
                ],
                "id": "104"
            },
            {
                "name": "Kunst Passiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    20
                ],
                "id": "106"
            },
            {
                "name": "List Angriff",
                "levelCosts": [
                    15
                ],
                "id": "10"
            },
            {
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    20
                ],
                "id": "107"
            },
            {
                "name": "List Mechanik",
                "levelCosts": [
                    8
                ],
                "id": "11"
            },
            {
                "name": "Waffenloser Kampf Schlag",
                "levelCosts": [
                    6
                ],
                "id": "-1"
            },
            {
                "name": "List Tarnung",
                "levelCosts": [
                    6
                ],
                "id": "12"
            },
            {
                "name": "Waffenloser Kampf Wurf",
                "levelCosts": [
                    6
                ],
                "id": "-1"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    4,
                    10
                ],
                "id": "13"
            },
            {
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "26"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "14"
            },
            {
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    3
                ],
                "id": "27"
            },
            {
                "name": "Magiepunkte entwickeln",
                "levelCosts": [
                    6
                ],
                "id": "15"
            },
            {
                "name": "Wahrnehmung Unbewusst",
                "levelCosts": [
                    6
                ],
                "id": "-1"
            },
            {
                "name": "Natur Tiere",
                "levelCosts": [
                    3
                ],
                "id": "16"
            },
            {
                "name": "Wissen Allgemein",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "28"
            },
            {
                "name": "Natur Umwelt",
                "levelCosts": [
                    3
                ],
                "id": "17"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "29"
            },
            {
                "name": "Ruestung Leicht",
                "levelCosts": [
                    4,
                    4,
                    4
                ],
                "id": "18"
            },
            {
                "name": "Wissen Obskur",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "30"
            },
            {
                "name": "Ruestung Mittel",
                "levelCosts": [
                    6,
                    6,
                    6
                ],
                "id": "19"
            },
            {
                "name": "Wissen Technisch",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "31"
            },
            {
                "name": "Ruestung Schwer",
                "levelCosts": [
                    7,
                    7,
                    7
                ],
                "id": "20"
            },
            {
                "name": "Wissenschaft / Analytisch Allgemein",
                "levelCosts": [
                    1,
                    4
                ],
                "id": "32"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "21"
            },
            {
                "name": "Wissenschaft / Analytisch Spezialisiert",
                "levelCosts": [
                    6,
                    14
                ],
                "id": "-1"
            },
            {
                "name": "Spezialangriff",
                "levelCosts": [
                    15
                ],
                "id": "-1"
            }
        ],
        "se": [
            {
                "name": "Offene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            10
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            6,
                            6,
                            6
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            8,
                            8
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            12
                        ]
                    }
                ]
            },
            {
                "name": "Geschlossene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            5
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            6,
                            10
                        ],
                        "costs": [
                            6,
                            6,
                            6
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            8,
                            8
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            10,
                            10
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            25
                        ]
                    }
                ]
            },
            {
                "name": "Basislisten eigene",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            3,
                            3,
                            3
                        ]
                    }
                ]
            }
        ],
        "ap": [
            {
                "name": "Abenteurer",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Klatschtante",
                "levelCosts": [
                    18
                ]
            },
            {
                "name": "Akademiker",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Kraeuterkundiger",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Assassine",
                "levelCosts": [
                    40
                ]
            },
            {
                "name": "Kriegsakademie",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Athlet",
                "levelCosts": [
                    33
                ]
            },
            {
                "name": "Meister des Wissens T",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Bauer",
                "levelCosts": [
                    35
                ]
            },
            {
                "name": "Mutter",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Berserker",
                "levelCosts": [
                    42
                ]
            },
            {
                "name": "Philosoph",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Bettler",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Pirat",
                "levelCosts": [
                    37
                ]
            },
            {
                "name": "Bibliothekar",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Professor T",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Detektiv",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Reisender",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Diplomat",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Ritter",
                "levelCosts": [
                    43
                ]
            },
            {
                "name": "Doktor",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Schamane",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Edelmann",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Schreiber",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Eiferer",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Schwindler",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Einbrecher",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Scout",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Entdecker",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Seemann",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Fechter",
                "levelCosts": [
                    59
                ]
            },
            {
                "name": "Sheriff",
                "levelCosts": [
                    35
                ]
            },
            {
                "name": "Fuehrer",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Soldat",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Gefolgsmann",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Soeldner",
                "levelCosts": [
                    39
                ]
            },
            {
                "name": "Gildenmitglied",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Spion",
                "levelCosts": [
                    35
                ]
            },
            {
                "name": "Gladiator",
                "levelCosts": [
                    59
                ]
            },
            {
                "name": "Stadtwache",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Haendler T",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Strassenraeuber",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Handwerker",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Taschendieb",
                "levelCosts": [
                    34
                ]
            },
            {
                "name": "Hobby Zauberer",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Tierarzt T",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Hostesse",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Tierfreund",
                "levelCosts": [
                    33
                ]
            },
            {
                "name": "Jaeger",
                "levelCosts": [
                    36
                ]
            },
            {
                "name": "Unterhalter",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Kaemmerer",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Waffenmeister",
                "levelCosts": [
                    84
                ]
            },
            {
                "name": "Kaempe",
                "levelCosts": [
                    43
                ]
            },
            {
                "name": "Wanderer",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Kampfsportler",
                "levelCosts": [
                    35
                ]
            },
            {
                "name": "Wirt",
                "levelCosts": [
                    28
                ]
            }
        ]
    },
    {
        "id": 7,
        "name": "Hexenmeister",
        "bb": [
            {
                "name": "Gezielte Sprueche",
                "levelCosts": [
                    5
                ],
                "id": "4"
            },
            {
                "name": "Magiepunkte entwickeln",
                "levelCosts": [
                    5
                ],
                "id": "15"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    15
                ],
                "id": "13"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    10
                ],
                "id": "29"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    10
                ],
                "id": "14"
            },
            {
                "name": "Kategorie Zauber",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            }
        ],
        "ff": [
            {
                "name": "Athletik Ausdauer",
                "levelCosts": [
                    3
                ],
                "id": "0"
            },
            {
                "name": "Spezialverteidigung",
                "levelCosts": [
                    40
                ],
                "id": "-1"
            },
            {
                "name": "Athletik Gymnastik",
                "levelCosts": [
                    3
                ],
                "id": "1"
            },
            {
                "name": "Staedtisch",
                "levelCosts": [
                    3
                ],
                "id": "22"
            },
            {
                "name": "Athletik Kraft",
                "levelCosts": [
                    7
                ],
                "id": "2"
            },
            {
                "name": "Tech Gewerbe Allgemein",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "23"
            },
            {
                "name": "Einflussnahme",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "3"
            },
            {
                "name": "Tech Gewerbe Beruflich",
                "levelCosts": [
                    5,
                    12
                ],
                "id": "24"
            },
            {
                "name": "Gezielte Sprueche",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "4"
            },
            {
                "name": "Tech Gewerbe Professionell",
                "levelCosts": [
                    8
                ],
                "id": "25"
            },
            {
                "name": "Handwerk",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "5"
            },
            {
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    9
                ],
                "id": "100"
            },
            {
                "name": "Kampfmanoever",
                "levelCosts": [
                    18
                ],
                "id": "6"
            },
            {
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    20
                ],
                "id": "101"
            },
            {
                "name": "Kommunikation",
                "levelCosts": [
                    2,
                    2,
                    2
                ],
                "id": "7"
            },
            {
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    20
                ],
                "id": "102"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    15
                ],
                "id": "8"
            },
            {
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    20
                ],
                "id": "103"
            },
            {
                "name": "Kunst Aktiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "9"
            },
            {
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    20
                ],
                "id": "104"
            },
            {
                "name": "Kunst Passiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    20
                ],
                "id": "106"
            },
            {
                "name": "List Angriff",
                "levelCosts": [
                    15
                ],
                "id": "10"
            },
            {
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    20
                ],
                "id": "107"
            },
            {
                "name": "List Mechanik",
                "levelCosts": [
                    7
                ],
                "id": "11"
            },
            {
                "name": "Waffenloser Kampf Schlag",
                "levelCosts": [
                    9
                ],
                "id": "-1"
            },
            {
                "name": "List Tarnung",
                "levelCosts": [
                    6
                ],
                "id": "12"
            },
            {
                "name": "Waffenloser Kampf Wurf",
                "levelCosts": [
                    9
                ],
                "id": "-1"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    4,
                    10
                ],
                "id": "13"
            },
            {
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "26"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "14"
            },
            {
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    3
                ],
                "id": "27"
            },
            {
                "name": "Magiepunkte entwickeln",
                "levelCosts": [
                    6
                ],
                "id": "15"
            },
            {
                "name": "Wahrnehmung Unbewusst",
                "levelCosts": [
                    6
                ],
                "id": "-1"
            },
            {
                "name": "Natur Tiere",
                "levelCosts": [
                    3
                ],
                "id": "16"
            },
            {
                "name": "Wissen Allgemein",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "28"
            },
            {
                "name": "Natur Umwelt",
                "levelCosts": [
                    3
                ],
                "id": "17"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "29"
            },
            {
                "name": "Ruestung Leicht",
                "levelCosts": [
                    9
                ],
                "id": "18"
            },
            {
                "name": "Wissen Obskur",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "30"
            },
            {
                "name": "Ruestung Mittel",
                "levelCosts": [
                    10
                ],
                "id": "19"
            },
            {
                "name": "Wissen Technisch",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "31"
            },
            {
                "name": "Ruestung Schwer",
                "levelCosts": [
                    11
                ],
                "id": "20"
            },
            {
                "name": "Wissenschaft / Analytisch Allgemein",
                "levelCosts": [
                    1,
                    4
                ],
                "id": "32"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    5
                ],
                "id": "21"
            },
            {
                "name": "Wissenschaft / Analytisch Spezialisiert",
                "levelCosts": [
                    6,
                    14
                ],
                "id": "-1"
            },
            {
                "name": "Spezialangriff",
                "levelCosts": [
                    15
                ],
                "id": "-1"
            }
        ],
        "se": [
            {
                "name": "Offene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            10
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            6,
                            6,
                            6
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            8,
                            8
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            12
                        ]
                    }
                ]
            },
            {
                "name": "Geschlossene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            5
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            6,
                            10
                        ],
                        "costs": [
                            6,
                            6,
                            6
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            8,
                            8
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            10,
                            10
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            25
                        ]
                    }
                ]
            },
            {
                "name": "Basislisten alle",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            3,
                            3,
                            3
                        ]
                    }
                ]
            }
        ],
        "ap": [
            {
                "name": "Abenteurer",
                "levelCosts": [
                    34
                ]
            },
            {
                "name": "Klatschtante",
                "levelCosts": [
                    18
                ]
            },
            {
                "name": "Akademiker",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Kraeuterkundiger",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Assassine",
                "levelCosts": [
                    41
                ]
            },
            {
                "name": "Kriegsakademie",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Athlet",
                "levelCosts": [
                    43
                ]
            },
            {
                "name": "Meister des Wissens T",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Bauer",
                "levelCosts": [
                    44
                ]
            },
            {
                "name": "Mutter",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Berserker",
                "levelCosts": [
                    44
                ]
            },
            {
                "name": "Philosoph",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Bettler",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Pirat",
                "levelCosts": [
                    37
                ]
            },
            {
                "name": "Bibliothekar",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Professor T",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Detektiv",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Reisender",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Diplomat",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Ritter",
                "levelCosts": [
                    46
                ]
            },
            {
                "name": "Doktor",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Schamane",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Edelmann",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Schreiber",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Eiferer",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Schwindler",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Einbrecher",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Scout",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Entdecker",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Seemann",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Fechter",
                "levelCosts": [
                    61
                ]
            },
            {
                "name": "Sheriff",
                "levelCosts": [
                    40
                ]
            },
            {
                "name": "Fuehrer",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Soldat",
                "levelCosts": [
                    37
                ]
            },
            {
                "name": "Gefolgsmann",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Soeldner",
                "levelCosts": [
                    44
                ]
            },
            {
                "name": "Gildenmitglied",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Spion",
                "levelCosts": [
                    34
                ]
            },
            {
                "name": "Gladiator",
                "levelCosts": [
                    62
                ]
            },
            {
                "name": "Stadtwache",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Haendler T",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Strassenraeuber",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Handwerker",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Taschendieb",
                "levelCosts": [
                    34
                ]
            },
            {
                "name": "Hobby Zauberer",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Tierarzt",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Hostesse",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Tierfreund",
                "levelCosts": [
                    33
                ]
            },
            {
                "name": "Jaeger",
                "levelCosts": [
                    36
                ]
            },
            {
                "name": "Unterhalter",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Kaemmerer",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Waffenmeister",
                "levelCosts": [
                    84
                ]
            },
            {
                "name": "Kaempe",
                "levelCosts": [
                    43
                ]
            },
            {
                "name": "Wanderer",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Kampfsportler",
                "levelCosts": [
                    40
                ]
            },
            {
                "name": "Wirt",
                "levelCosts": [
                    28
                ]
            }
        ]
    },
    {
        "id": 8,
        "name": "Illusionist",
        "bb": [
            {
                "name": "Gezielte Sprueche",
                "levelCosts": [
                    5
                ],
                "id": "4"
            },
            {
                "name": "Kategorie Wahrnehmung",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    10
                ],
                "id": "13"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    10
                ],
                "id": "29"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    10
                ],
                "id": "14"
            },
            {
                "name": "Kategorie Zauber",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Magiepunkte entwickeln",
                "levelCosts": [
                    5
                ],
                "id": "15"
            },
            {
                "id": "26",
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "27",
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    5
                ]
            }
        ],
        "ff": [
            {
                "name": "Athletik Ausdauer",
                "levelCosts": [
                    3
                ],
                "id": "0"
            },
            {
                "name": "Spezialverteidigung",
                "levelCosts": [
                    40
                ],
                "id": "-1"
            },
            {
                "name": "Athletik Gymnastik",
                "levelCosts": [
                    3
                ],
                "id": "1"
            },
            {
                "name": "Staedtisch",
                "levelCosts": [
                    3
                ],
                "id": "22"
            },
            {
                "name": "Athletik Kraft",
                "levelCosts": [
                    7
                ],
                "id": "2"
            },
            {
                "name": "Tech Gewerbe Allgemein",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "23"
            },
            {
                "name": "Einflussnahme",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "3"
            },
            {
                "name": "Tech Gewerbe Beruflich",
                "levelCosts": [
                    5,
                    12
                ],
                "id": "24"
            },
            {
                "name": "Gezielte Sprueche",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "4"
            },
            {
                "name": "Tech Gewerbe Professionell",
                "levelCosts": [
                    8
                ],
                "id": "25"
            },
            {
                "name": "Handwerk",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "5"
            },
            {
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    9
                ],
                "id": "100"
            },
            {
                "name": "Kampfmanoever",
                "levelCosts": [
                    18
                ],
                "id": "6"
            },
            {
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    20
                ],
                "id": "101"
            },
            {
                "name": "Kommunikation",
                "levelCosts": [
                    1,
                    1,
                    1
                ],
                "id": "7"
            },
            {
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    20
                ],
                "id": "102"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    15
                ],
                "id": "8"
            },
            {
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    20
                ],
                "id": "103"
            },
            {
                "name": "Kunst Aktiv",
                "levelCosts": [
                    1,
                    5
                ],
                "id": "9"
            },
            {
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    20
                ],
                "id": "104"
            },
            {
                "name": "Kunst Passiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    20
                ],
                "id": "106"
            },
            {
                "name": "List Angriff",
                "levelCosts": [
                    9
                ],
                "id": "10"
            },
            {
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    20
                ],
                "id": "107"
            },
            {
                "name": "List Mechanik",
                "levelCosts": [
                    8
                ],
                "id": "11"
            },
            {
                "name": "Waffenloser Kampf Schlag",
                "levelCosts": [
                    9
                ],
                "id": "-1"
            },
            {
                "name": "List Tarnung",
                "levelCosts": [
                    3
                ],
                "id": "12"
            },
            {
                "name": "Waffenloser Kampf Wurf",
                "levelCosts": [
                    9
                ],
                "id": "-1"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    4,
                    10
                ],
                "id": "13"
            },
            {
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "26"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    1,
                    4
                ],
                "id": "14"
            },
            {
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    3
                ],
                "id": "27"
            },
            {
                "name": "Magiepunkte entwickeln",
                "levelCosts": [
                    4
                ],
                "id": "15"
            },
            {
                "name": "Wahrnehmung Unbewusst",
                "levelCosts": [
                    4
                ],
                "id": "-1"
            },
            {
                "name": "Natur Tiere",
                "levelCosts": [
                    3
                ],
                "id": "16"
            },
            {
                "name": "Wissen Allgemein",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "28"
            },
            {
                "name": "Natur Umwelt",
                "levelCosts": [
                    3
                ],
                "id": "17"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    1,
                    4
                ],
                "id": "29"
            },
            {
                "name": "Ruestung Leicht",
                "levelCosts": [
                    9
                ],
                "id": "18"
            },
            {
                "name": "Wissen Obskur",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "30"
            },
            {
                "name": "Ruestung Mittel",
                "levelCosts": [
                    10
                ],
                "id": "19"
            },
            {
                "name": "Wissen Technisch",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "31"
            },
            {
                "name": "Ruestung Schwer",
                "levelCosts": [
                    11
                ],
                "id": "20"
            },
            {
                "name": "Wissenschaft / Analytisch Allgemein",
                "levelCosts": [
                    1,
                    4
                ],
                "id": "32"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    6
                ],
                "id": "21"
            },
            {
                "name": "Wissenschaft / Analytisch Spezialisiert",
                "levelCosts": [
                    6,
                    14
                ],
                "id": "-1"
            },
            {
                "name": "Spezialangriff",
                "levelCosts": [
                    15
                ],
                "id": "-1"
            }
        ],
        "se": [
            {
                "name": "Offene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            10
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            6,
                            6,
                            6
                        ]
                    }
                ]
            },
            {
                "name": "Geschlossene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            5
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            6,
                            10
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            8,
                            8
                        ]
                    }
                ]
            },
            {
                "name": "Basislisten alle",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            3,
                            3,
                            3
                        ]
                    }
                ]
            }
        ],
        "ap": [
            {
                "name": "Abenteurer",
                "levelCosts": [
                    33
                ]
            },
            {
                "name": "Klatschtante",
                "levelCosts": [
                    13
                ]
            },
            {
                "name": "Akademiker",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Kraeuterkundiger",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Assassine",
                "levelCosts": [
                    36
                ]
            },
            {
                "name": "Kriegsakademie",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Athlet",
                "levelCosts": [
                    43
                ]
            },
            {
                "name": "Meister des Wissens T",
                "levelCosts": [
                    19
                ]
            },
            {
                "name": "Bauer",
                "levelCosts": [
                    44
                ]
            },
            {
                "name": "Mutter",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Berserker",
                "levelCosts": [
                    45
                ]
            },
            {
                "name": "Philosoph",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Bettler",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Pirat",
                "levelCosts": [
                    37
                ]
            },
            {
                "name": "Bibliothekar",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Professor T",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Detektiv",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Reisender",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Diplomat",
                "levelCosts": [
                    21
                ]
            },
            {
                "name": "Ritter",
                "levelCosts": [
                    46
                ]
            },
            {
                "name": "Doktor",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Schamane",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Edelmann",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Schreiber",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Eiferer",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Schwindler",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Einbrecher",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Scout",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Entdecker",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Seemann",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Fechter",
                "levelCosts": [
                    61
                ]
            },
            {
                "name": "Sheriff",
                "levelCosts": [
                    40
                ]
            },
            {
                "name": "Fuehrer",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Soldat",
                "levelCosts": [
                    37
                ]
            },
            {
                "name": "Gefolgsmann",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Soeldner",
                "levelCosts": [
                    44
                ]
            },
            {
                "name": "Gildenmitglied",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Spion",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Gladiator",
                "levelCosts": [
                    62
                ]
            },
            {
                "name": "Stadtwache",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Haendler T",
                "levelCosts": [
                    18
                ]
            },
            {
                "name": "Strassenraeuber",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Handwerker",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Taschendieb",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Hobby Zauberer T",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Tierarzt",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Hostesse",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Tierfreund",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Jaeger",
                "levelCosts": [
                    34
                ]
            },
            {
                "name": "Unterhalter T",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Kaemmerer",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Waffenmeister",
                "levelCosts": [
                    84
                ]
            },
            {
                "name": "Kaempe",
                "levelCosts": [
                    43
                ]
            },
            {
                "name": "Wanderer",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Kampfsportler",
                "levelCosts": [
                    40
                ]
            },
            {
                "name": "Wirt",
                "levelCosts": [
                    28
                ]
            }
        ]
    },
    {
        "id": 9,
        "name": "Kleriker",
        "bb": [
            {
                "name": "Einflussnahme",
                "levelCosts": [
                    5
                ],
                "id": "3"
            },
            {
                "name": "Kategorie Waffen",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    5
                ],
                "id": "13"
            },
            {
                "name": "Kategorie Wahrnehmung",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    10
                ],
                "id": "14"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    5
                ],
                "id": "29"
            },
            {
                "name": "Magiepunkte entwickeln",
                "levelCosts": [
                    5
                ],
                "id": "15"
            },
            {
                "name": "Kategorie Zauber",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Kategorie Natur",
                "levelCosts": [
                    5
                ],
                "id": "16"
            },
            {
                "id": "100",
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "101",
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "102",
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "103",
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "104",
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "106",
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "107",
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "26",
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "27",
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "16",
                "name": "Natur Tiere",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "17",
                "name": "Natur Umwelt",
                "levelCosts": [
                    5
                ]
            }
        ],
        "ff": [
            {
                "name": "Athletik Ausdauer",
                "levelCosts": [
                    3
                ],
                "id": "0"
            },
            {
                "name": "Spezialverteidigung",
                "levelCosts": [
                    40
                ],
                "id": "-1"
            },
            {
                "name": "Athletik Gymnastik",
                "levelCosts": [
                    3
                ],
                "id": "1"
            },
            {
                "name": "Staedtisch",
                "levelCosts": [
                    3
                ],
                "id": "22"
            },
            {
                "name": "Athletik Kraft",
                "levelCosts": [
                    5
                ],
                "id": "2"
            },
            {
                "name": "Tech Gewerbe Allgemein",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "23"
            },
            {
                "name": "Einflussnahme",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "3"
            },
            {
                "name": "Tech Gewerbe Beruflich",
                "levelCosts": [
                    5,
                    12
                ],
                "id": "24"
            },
            {
                "name": "Gezielte Sprueche",
                "levelCosts": [
                    3
                ],
                "id": "4"
            },
            {
                "name": "Tech Gewerbe Professionell",
                "levelCosts": [
                    8
                ],
                "id": "25"
            },
            {
                "name": "Handwerk",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "5"
            },
            {
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    6
                ],
                "id": "100"
            },
            {
                "name": "Kampfmanoever",
                "levelCosts": [
                    10
                ],
                "id": "6"
            },
            {
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    7
                ],
                "id": "101"
            },
            {
                "name": "Kommunikation",
                "levelCosts": [
                    2,
                    2,
                    2
                ],
                "id": "7"
            },
            {
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    9
                ],
                "id": "102"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    10
                ],
                "id": "8"
            },
            {
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    9
                ],
                "id": "103"
            },
            {
                "name": "Kunst Aktiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "9"
            },
            {
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    9
                ],
                "id": "104"
            },
            {
                "name": "Kunst Passiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    20
                ],
                "id": "106"
            },
            {
                "name": "List Angriff",
                "levelCosts": [
                    15
                ],
                "id": "10"
            },
            {
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    20
                ],
                "id": "107"
            },
            {
                "name": "List Mechanik",
                "levelCosts": [
                    7
                ],
                "id": "11"
            },
            {
                "name": "Waffenloser Kampf Schlag",
                "levelCosts": [
                    6
                ],
                "id": "-1"
            },
            {
                "name": "List Tarnung",
                "levelCosts": [
                    5
                ],
                "id": "12"
            },
            {
                "name": "Waffenloser Kampf Wurf",
                "levelCosts": [
                    6
                ],
                "id": "-1"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    4,
                    10
                ],
                "id": "13"
            },
            {
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "26"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "14"
            },
            {
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "27"
            },
            {
                "name": "Magiepunkte entwickeln",
                "levelCosts": [
                    4
                ],
                "id": "15"
            },
            {
                "name": "Wahrnehmung Unbewusst",
                "levelCosts": [
                    6
                ],
                "id": "-1"
            },
            {
                "name": "Natur Tiere",
                "levelCosts": [
                    3
                ],
                "id": "16"
            },
            {
                "name": "Wissen Allgemein",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "28"
            },
            {
                "name": "Natur Umwelt",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "17"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "29"
            },
            {
                "name": "Ruestung Leicht",
                "levelCosts": [
                    2,
                    2,
                    2
                ],
                "id": "18"
            },
            {
                "name": "Wissen Obskur",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "30"
            },
            {
                "name": "Ruestung Mittel",
                "levelCosts": [
                    10
                ],
                "id": "19"
            },
            {
                "name": "Wissen Technisch",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "31"
            },
            {
                "name": "Ruestung Schwer",
                "levelCosts": [
                    11
                ],
                "id": "20"
            },
            {
                "name": "Wissenschaft / Analytisch Allgemein",
                "levelCosts": [
                    1,
                    4
                ],
                "id": "32"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    5
                ],
                "id": "21"
            },
            {
                "name": "Wissenschaft / Analytisch Spezialisiert",
                "levelCosts": [
                    6,
                    14
                ],
                "id": "-1"
            },
            {
                "name": "Spezialangriff",
                "levelCosts": [
                    10
                ],
                "id": "-1"
            }
        ],
        "se": [
            {
                "name": "Offene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            10
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            6,
                            6,
                            6
                        ]
                    }
                ]
            },
            {
                "name": "Geschlossene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            5
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            6,
                            10
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            8,
                            8
                        ]
                    }
                ]
            },
            {
                "name": "Basislisten alle",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            3,
                            3,
                            3
                        ]
                    }
                ]
            }
        ],
        "ap": [
            {
                "name": "Abenteurer",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Klatschtante",
                "levelCosts": [
                    18
                ]
            },
            {
                "name": "Akademiker",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Kraeuterkundiger",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Assassine",
                "levelCosts": [
                    38
                ]
            },
            {
                "name": "Kriegsakademie",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Athlet",
                "levelCosts": [
                    37
                ]
            },
            {
                "name": "Meister des Wissens T",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Bauer",
                "levelCosts": [
                    38
                ]
            },
            {
                "name": "Mutter",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Berserker",
                "levelCosts": [
                    36
                ]
            },
            {
                "name": "Philosoph",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Bettler",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Pirat",
                "levelCosts": [
                    34
                ]
            },
            {
                "name": "Bibliothekar",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Professor T",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Detektiv",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Reisender",
                "levelCosts": [
                    18
                ]
            },
            {
                "name": "Diplomat",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Ritter",
                "levelCosts": [
                    40
                ]
            },
            {
                "name": "Doktor",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Schamane",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Edelmann",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Schreiber",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Eiferer",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Schwindler",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Einbrecher",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Scout",
                "levelCosts": [
                    38
                ]
            },
            {
                "name": "Entdecker",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Seemann",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Fechter",
                "levelCosts": [
                    48
                ]
            },
            {
                "name": "Sheriff",
                "levelCosts": [
                    33
                ]
            },
            {
                "name": "Fuehrer",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Soldat",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Gefolgsmann",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Soeldner",
                "levelCosts": [
                    36
                ]
            },
            {
                "name": "Gildenmitglied",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Spion",
                "levelCosts": [
                    33
                ]
            },
            {
                "name": "Gladiator",
                "levelCosts": [
                    53
                ]
            },
            {
                "name": "Stadtwache",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Haendler T",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Strassenraeuber",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Handwerker",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Taschendieb",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Hobby Zauberer",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Tierarzt",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Hostesse",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Tierfreund",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Jaeger",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Unterhalter",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Kaemmerer",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Waffenmeister",
                "levelCosts": [
                    51
                ]
            },
            {
                "name": "Kaempe",
                "levelCosts": [
                    36
                ]
            },
            {
                "name": "Wanderer",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Kampfsportler",
                "levelCosts": [
                    35
                ]
            },
            {
                "name": "Wirt",
                "levelCosts": [
                    28
                ]
            }
        ]
    },
    {
        "id": 10,
        "name": "Krieger",
        "bb": [
            {
                "name": "Kampfmanoever",
                "levelCosts": [
                    10
                ],
                "id": "6"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    10
                ],
                "id": "8"
            },
            {
                "name": "Kategorie Ruestung",
                "levelCosts": [
                    10
                ],
                "id": "-1"
            },
            {
                "name": "Kategorie Waffen",
                "levelCosts": [
                    20
                ],
                "id": "-1"
            },
            {
                "id": "100",
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    20
                ]
            },
            {
                "id": "101",
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    20
                ]
            },
            {
                "id": "102",
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    20
                ]
            },
            {
                "id": "103",
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    20
                ]
            },
            {
                "id": "104",
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    20
                ]
            },
            {
                "id": "106",
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    20
                ]
            },
            {
                "id": "107",
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    20
                ]
            }
        ],
        "ff": [
            {
                "name": "Athletik Ausdauer",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "0"
            },
            {
                "name": "Spezialverteidigung",
                "levelCosts": [
                    35
                ],
                "id": "-1"
            },
            {
                "name": "Athletik Gymnastik",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "1"
            },
            {
                "name": "Staedtisch",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "22"
            },
            {
                "name": "Athletik Kraft",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "2"
            },
            {
                "name": "Tech Gewerbe Allgemein",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "23"
            },
            {
                "name": "Einflussnahme",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "3"
            },
            {
                "name": "Tech Gewerbe Beruflich",
                "levelCosts": [
                    5,
                    12
                ],
                "id": "24"
            },
            {
                "name": "Gezielte Sprueche",
                "levelCosts": [
                    20
                ],
                "id": "4"
            },
            {
                "name": "Tech Gewerbe Professionell",
                "levelCosts": [
                    8
                ],
                "id": "25"
            },
            {
                "name": "Handwerk",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "5"
            },
            {
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    1,
                    5
                ],
                "id": "100"
            },
            {
                "name": "Kampfmanoever",
                "levelCosts": [
                    3,
                    9
                ],
                "id": "6"
            },
            {
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "101"
            },
            {
                "name": "Kommunikation",
                "levelCosts": [
                    3,
                    3,
                    3
                ],
                "id": "7"
            },
            {
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "102"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "8"
            },
            {
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "103"
            },
            {
                "name": "Kunst Aktiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "9"
            },
            {
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "104"
            },
            {
                "name": "Kunst Passiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    5
                ],
                "id": "106"
            },
            {
                "name": "List Angriff",
                "levelCosts": [
                    6,
                    10
                ],
                "id": "10"
            },
            {
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    5
                ],
                "id": "107"
            },
            {
                "name": "List Mechanik",
                "levelCosts": [
                    3,
                    8
                ],
                "id": "11"
            },
            {
                "name": "Waffenloser Kampf Schlag",
                "levelCosts": [
                    3,
                    5
                ],
                "id": "-1"
            },
            {
                "name": "List Tarnung",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "12"
            },
            {
                "name": "Waffenloser Kampf Wurf",
                "levelCosts": [
                    3,
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    18
                ],
                "id": "13"
            },
            {
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "26"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    8
                ],
                "id": "14"
            },
            {
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "27"
            },
            {
                "name": "Magiepunkte entwickeln",
                "levelCosts": [
                    20
                ],
                "id": "15"
            },
            {
                "name": "Wahrnehmung Unbewusst",
                "levelCosts": [
                    2,
                    9
                ],
                "id": "-1"
            },
            {
                "name": "Natur Tiere",
                "levelCosts": [
                    1,
                    4
                ],
                "id": "16"
            },
            {
                "name": "Wissen Allgemein",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "28"
            },
            {
                "name": "Natur Umwelt",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "17"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    6
                ],
                "id": "29"
            },
            {
                "name": "Ruestung Leicht",
                "levelCosts": [
                    1,
                    1,
                    1
                ],
                "id": "18"
            },
            {
                "name": "Wissen Obskur",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "30"
            },
            {
                "name": "Ruestung Mittel",
                "levelCosts": [
                    2,
                    2,
                    2
                ],
                "id": "19"
            },
            {
                "name": "Wissen Technisch",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "31"
            },
            {
                "name": "Ruestung Schwer",
                "levelCosts": [
                    2,
                    2,
                    2
                ],
                "id": "20"
            },
            {
                "name": "Wissenschaft / Analytisch Allgemein",
                "levelCosts": [
                    3,
                    6
                ],
                "id": "32"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "21"
            },
            {
                "name": "Wissenschaft / Analytisch Spezialisiert",
                "levelCosts": [
                    12
                ],
                "id": "-1"
            },
            {
                "name": "Spezialangriff",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "-1"
            }
        ],
        "se": [
            {
                "name": "Offene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            5
                        ],
                        "costs": [
                            25
                        ]
                    },
                    {
                        "levels": [
                            6,
                            10
                        ],
                        "costs": [
                            50
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            75
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            100
                        ]
                    },
                    {
                        "levels": [
                            21
                        ],
                        "costs": [
                            125
                        ]
                    }
                ]
            },
            {
                "name": "Geschlossene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            5
                        ],
                        "costs": [
                            40
                        ]
                    },
                    {
                        "levels": [
                            6,
                            10
                        ],
                        "costs": [
                            80
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            120
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            160
                        ]
                    },
                    {
                        "levels": [
                            21
                        ],
                        "costs": [
                            200
                        ]
                    }
                ]
            }
        ],
        "ap": [
            {
                "name": "Abenteurer",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Klatschtante",
                "levelCosts": [
                    18
                ]
            },
            {
                "name": "Akademiker",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Kraeuterkundiger",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Assassine",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Kriegsakademie",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Athlet",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Meister des Wissens",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Bauer",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Mutter",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Berserker",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Philosoph",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Bettler",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Pirat",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Bibliothekar",
                "levelCosts": [
                    38
                ]
            },
            {
                "name": "Professor",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Detektiv",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Reisender",
                "levelCosts": [
                    13
                ]
            },
            {
                "name": "Diplomat",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Ritter T",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Doktor",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Schamane",
                "levelCosts": [
                    34
                ]
            },
            {
                "name": "Edelmann",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Schreiber",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Eiferer",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Schwindler",
                "levelCosts": [
                    21
                ]
            },
            {
                "name": "Einbrecher",
                "levelCosts": [
                    21
                ]
            },
            {
                "name": "Scout",
                "levelCosts": [
                    21
                ]
            },
            {
                "name": "Entdecker",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Seemann",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Fechter",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Sheriff",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Fuehrer",
                "levelCosts": [
                    19
                ]
            },
            {
                "name": "Soldat T",
                "levelCosts": [
                    15
                ]
            },
            {
                "name": "Gefolgsmann",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Soeldner",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Gildenmitglied",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Spion",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Gladiator",
                "levelCosts": [
                    37
                ]
            },
            {
                "name": "Stadtwache T",
                "levelCosts": [
                    15
                ]
            },
            {
                "name": "Haendler",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Strassenraeuber",
                "levelCosts": [
                    19
                ]
            },
            {
                "name": "Handwerker",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Taschendieb",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Hobby Zauberer",
                "levelCosts": [
                    43
                ]
            },
            {
                "name": "Tierarzt",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Hostesse",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Tierfreund",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Jaeger",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Unterhalter",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Kaemmerer",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Waffenmeister T",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Kaempe T",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Wanderer",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Kampfsportler",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Wirt",
                "levelCosts": [
                    28
                ]
            }
        ]
    },
    {
        "id": 11,
        "name": "Kriegsmoench",
        "bb": [
            {
                "name": "Athletik Gymnastik",
                "levelCosts": [
                    5
                ],
                "id": "1"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    10
                ],
                "id": "8"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    15
                ],
                "id": "21"
            },
            {
                "name": "Kategorie Waffenloser Kampf",
                "levelCosts": [
                    15
                ],
                "id": "-1"
            },
            {
                "name": "Kat Wahrnehmung",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            }
        ],
        "ff": [
            {
                "name": "Athletik Ausdauer",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "0"
            },
            {
                "name": "Spezialverteidigung",
                "levelCosts": [
                    6,
                    12
                ],
                "id": "-1"
            },
            {
                "name": "Athletik Gymnastik",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "1"
            },
            {
                "name": "Staedtisch",
                "levelCosts": [
                    3,
                    6
                ],
                "id": "22"
            },
            {
                "name": "Athletik Kraft",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "2"
            },
            {
                "name": "Tech Gewerbe Allgemein",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "23"
            },
            {
                "name": "Einflussnahme",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "3"
            },
            {
                "name": "Tech Gewerbe Beruflich",
                "levelCosts": [
                    5,
                    12
                ],
                "id": "24"
            },
            {
                "name": "Gezielte Sprueche",
                "levelCosts": [
                    20
                ],
                "id": "4"
            },
            {
                "name": "Tech Gewerbe Professionell",
                "levelCosts": [
                    8
                ],
                "id": "25"
            },
            {
                "name": "Handwerk",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "5"
            },
            {
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    4
                ],
                "id": "100"
            },
            {
                "name": "Kampfmanoever",
                "levelCosts": [
                    4,
                    9
                ],
                "id": "6"
            },
            {
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    6
                ],
                "id": "101"
            },
            {
                "name": "Kommunikation",
                "levelCosts": [
                    3,
                    3,
                    3
                ],
                "id": "7"
            },
            {
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    8
                ],
                "id": "102"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    4,
                    10
                ],
                "id": "8"
            },
            {
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    8
                ],
                "id": "103"
            },
            {
                "name": "Kunst Aktiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "9"
            },
            {
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    8
                ],
                "id": "104"
            },
            {
                "name": "Kunst Passiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    15
                ],
                "id": "106"
            },
            {
                "name": "List Angriff",
                "levelCosts": [
                    6,
                    12
                ],
                "id": "10"
            },
            {
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    15
                ],
                "id": "107"
            },
            {
                "name": "List Mechanik",
                "levelCosts": [
                    3,
                    9
                ],
                "id": "11"
            },
            {
                "name": "Waffenloser Kampf Schlag",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "-1"
            },
            {
                "name": "List Tarnung",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "12"
            },
            {
                "name": "Waffenloser Kampf Wurf",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "-1"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    14
                ],
                "id": "13"
            },
            {
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "26"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    8
                ],
                "id": "14"
            },
            {
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "27"
            },
            {
                "name": "Magiepunkte entwickeln",
                "levelCosts": [
                    15
                ],
                "id": "15"
            },
            {
                "name": "Wahrnehmung Unbewusst",
                "levelCosts": [
                    2,
                    9
                ],
                "id": "-1"
            },
            {
                "name": "Natur Tiere",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "16"
            },
            {
                "name": "Wissen Allgemein",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "28"
            },
            {
                "name": "Natur Umwelt",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "17"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    6
                ],
                "id": "29"
            },
            {
                "name": "Ruestung Leicht",
                "levelCosts": [
                    9
                ],
                "id": "18"
            },
            {
                "name": "Wissen Obskur",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "30"
            },
            {
                "name": "Ruestung Mittel",
                "levelCosts": [
                    10
                ],
                "id": "19"
            },
            {
                "name": "Wissen Technisch",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "31"
            },
            {
                "name": "Ruestung Schwer",
                "levelCosts": [
                    10
                ],
                "id": "20"
            },
            {
                "name": "Wissenschaft / Analytisch Allgemein",
                "levelCosts": [
                    3,
                    6
                ],
                "id": "32"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "21"
            },
            {
                "name": "Wissenschaft / Analytisch Spezialisiert",
                "levelCosts": [
                    12
                ],
                "id": "-1"
            },
            {
                "name": "Spezialangriff",
                "levelCosts": [
                    2,
                    10
                ],
                "id": "-1"
            }
        ],
        "se": [
            {
                "name": "Offene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            5
                        ],
                        "costs": [
                            20
                        ]
                    },
                    {
                        "levels": [
                            6,
                            10
                        ],
                        "costs": [
                            40
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            60
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            80
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            100
                        ]
                    }
                ]
            },
            {
                "name": "Geschlossene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            5
                        ],
                        "costs": [
                            30
                        ]
                    },
                    {
                        "levels": [
                            6,
                            10
                        ],
                        "costs": [
                            60
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            90
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            120
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            150
                        ]
                    }
                ]
            }
        ],
        "ap": [
            {
                "name": "Abenteurer",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Klatschtante",
                "levelCosts": [
                    18
                ]
            },
            {
                "name": "Akademiker",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Kraeuterkundiger",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Assassine",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Kriegsakademie",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Athlet",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Meister des Wissens",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Bauer",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Mutter",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Berserker",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Philosoph",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Bettler",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Pirat",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Bibliothekar",
                "levelCosts": [
                    38
                ]
            },
            {
                "name": "Professor",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Detektiv",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Reisender",
                "levelCosts": [
                    13
                ]
            },
            {
                "name": "Diplomat",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Ritter",
                "levelCosts": [
                    34
                ]
            },
            {
                "name": "Doktor",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Schamane",
                "levelCosts": [
                    33
                ]
            },
            {
                "name": "Edelmann",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Schreiber",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Eiferer",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Schwindler",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Einbrecher T",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Scout",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Entdecker",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Seemann",
                "levelCosts": [
                    19
                ]
            },
            {
                "name": "Fechter I",
                "levelCosts": [
                    35
                ]
            },
            {
                "name": "Sheriff",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Fuehrer",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Soldat",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Gefolgsmann",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Soeldner",
                "levelCosts": [
                    33
                ]
            },
            {
                "name": "Gildenmitglied",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Spion",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Gladiator",
                "levelCosts": [
                    47
                ]
            },
            {
                "name": "Stadtwache",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Haendler",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Strassenraeuber",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Handwerker",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Taschendieb",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Hobby Zauberer",
                "levelCosts": [
                    40
                ]
            },
            {
                "name": "Tierarzt",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Hostesse",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Tierfreund",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Jaeger",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Unterhalter",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Kaemmerer",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Waffenmeister I",
                "levelCosts": [
                    45
                ]
            },
            {
                "name": "Kaempe",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Wanderer",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Kampfsportler T",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Wirt",
                "levelCosts": [
                    29
                ]
            }
        ]
    },
    {
        "id": 12,
        "name": "Kundschafter",
        "bb": [
            {
                "name": "Kommunikation",
                "levelCosts": [
                    5
                ],
                "id": "7"
            },
            {
                "name": "List Tarnung",
                "levelCosts": [
                    10
                ],
                "id": "12"
            },
            {
                "name": "Kategorie Natur",
                "levelCosts": [
                    10
                ],
                "id": "16"
            },
            {
                "name": "Kategorie Ruestung",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Kategorie Waffen",
                "levelCosts": [
                    10
                ],
                "id": "-1"
            },
            {
                "name": "Kategorie Wahrnehmung",
                "levelCosts": [
                    10
                ],
                "id": "-1"
            },
            {
                "id": "16",
                "name": "Natur Tiere",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "17",
                "name": "Natur Umwelt",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "100",
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "101",
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "102",
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "103",
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "104",
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "106",
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "107",
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "26",
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "27",
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    10
                ]
            }
        ],
        "ff": [
            {
                "name": "Athletik Ausdauer",
                "levelCosts": [
                    1,
                    5
                ],
                "id": "0"
            },
            {
                "name": "Spezialverteidigung",
                "levelCosts": [
                    18
                ],
                "id": "-1"
            },
            {
                "name": "Athletik Gymnastik",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "1"
            },
            {
                "name": "Staedtisch",
                "levelCosts": [
                    3,
                    6
                ],
                "id": "22"
            },
            {
                "name": "Athletik Kraft",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "2"
            },
            {
                "name": "Tech Gewerbe Allgemein",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "23"
            },
            {
                "name": "Einflussnahme",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "3"
            },
            {
                "name": "Tech Gewerbe Beruflich",
                "levelCosts": [
                    5,
                    12
                ],
                "id": "24"
            },
            {
                "name": "Gezielte Sprueche",
                "levelCosts": [
                    20
                ],
                "id": "4"
            },
            {
                "name": "Tech Gewerbe Professionell",
                "levelCosts": [
                    8
                ],
                "id": "25"
            },
            {
                "name": "Handwerk",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "5"
            },
            {
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "100"
            },
            {
                "name": "Kampfmanoever",
                "levelCosts": [
                    4,
                    12
                ],
                "id": "6"
            },
            {
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    3,
                    9
                ],
                "id": "101"
            },
            {
                "name": "Kommunikation",
                "levelCosts": [
                    2,
                    2,
                    2
                ],
                "id": "7"
            },
            {
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    3,
                    9
                ],
                "id": "102"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    4,
                    10
                ],
                "id": "8"
            },
            {
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    4
                ],
                "id": "103"
            },
            {
                "name": "Kunst Aktiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "9"
            },
            {
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    4
                ],
                "id": "104"
            },
            {
                "name": "Kunst Passiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    6
                ],
                "id": "106"
            },
            {
                "name": "List Angriff",
                "levelCosts": [
                    3,
                    9
                ],
                "id": "10"
            },
            {
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    6
                ],
                "id": "107"
            },
            {
                "name": "List Mechanik",
                "levelCosts": [
                    3,
                    9
                ],
                "id": "11"
            },
            {
                "name": "Waffenloser Kampf Schlag",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "-1"
            },
            {
                "name": "List Tarnung",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "12"
            },
            {
                "name": "Waffenloser Kampf Wurf",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "-1"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    18
                ],
                "id": "13"
            },
            {
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    1,
                    5
                ],
                "id": "26"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    7
                ],
                "id": "14"
            },
            {
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    1,
                    5
                ],
                "id": "27"
            },
            {
                "name": "Magiepunkte entwickeln",
                "levelCosts": [
                    15
                ],
                "id": "15"
            },
            {
                "name": "Wahrnehmung Unbewusst",
                "levelCosts": [
                    1,
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Natur Tiere",
                "levelCosts": [
                    1,
                    4
                ],
                "id": "16"
            },
            {
                "name": "Wissen Allgemein",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "28"
            },
            {
                "name": "Natur Umwelt",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "17"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    4
                ],
                "id": "29"
            },
            {
                "name": "Ruestung Leicht",
                "levelCosts": [
                    1,
                    1,
                    1
                ],
                "id": "18"
            },
            {
                "name": "Wissen Obskur",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "30"
            },
            {
                "name": "Ruestung Mittel",
                "levelCosts": [
                    3,
                    3,
                    3
                ],
                "id": "19"
            },
            {
                "name": "Wissen Technisch",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "31"
            },
            {
                "name": "Ruestung Schwer",
                "levelCosts": [
                    4,
                    4,
                    4
                ],
                "id": "20"
            },
            {
                "name": "Wissenschaft / Analytisch Allgemein",
                "levelCosts": [
                    3,
                    6
                ],
                "id": "32"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "21"
            },
            {
                "name": "Wissenschaft / Analytisch Spezialisiert",
                "levelCosts": [
                    12
                ],
                "id": "-1"
            },
            {
                "name": "Spezialangriff",
                "levelCosts": [
                    2,
                    8
                ],
                "id": "-1"
            }
        ],
        "se": [
            {
                "name": "Fremder Bereich offen",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            80
                        ]
                    }
                ]
            },
            {
                "name": "Fremder Bereich geschl",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            100
                        ]
                    }
                ]
            },
            {
                "name": "Fremder Bereich Basis",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            120
                        ]
                    }
                ]
            },
            {
                "name": "Eigener Breich fremde Basis",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            70
                        ]
                    }
                ]
            },
            {
                "name": "Eigener Bereich offen",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            18
                        ]
                    }
                ]
            },
            {
                "name": "Eigener Bereich geschlossen",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            35
                        ]
                    }
                ]
            },
            {
                "name": "Arkan offen",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            25
                        ]
                    }
                ]
            }
        ],
        "ap": [
            {
                "name": "Abenteurer",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Klatschtante",
                "levelCosts": [
                    16
                ]
            },
            {
                "name": "Akademiker",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Kraeuterkundiger",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Assassine",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Kriegsakademie",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Athlet",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Meister des Wissens",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Bauer",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Mutter",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Berserker",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Philosoph",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Bettler",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Pirat",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Bibliothekar",
                "levelCosts": [
                    36
                ]
            },
            {
                "name": "Professor",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Detektiv",
                "levelCosts": [
                    16
                ]
            },
            {
                "name": "Reisender",
                "levelCosts": [
                    13
                ]
            },
            {
                "name": "Diplomat",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Ritter",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Doktor",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Schamane",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Edelmann",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Schreiber",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Eiferer",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Schwindler",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Einbrecher",
                "levelCosts": [
                    21
                ]
            },
            {
                "name": "Scout T",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Entdecker",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Seemann",
                "levelCosts": [
                    16
                ]
            },
            {
                "name": "Fechter",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Sheriff",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Fuehrer T",
                "levelCosts": [
                    19
                ]
            },
            {
                "name": "Soldat",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Gefolgsmann",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Soeldner",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Gildenmitglied",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Spion T",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Gladiator",
                "levelCosts": [
                    41
                ]
            },
            {
                "name": "Stadtwache",
                "levelCosts": [
                    19
                ]
            },
            {
                "name": "Haendler",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Strassenraeuber",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Handwerker",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Taschendieb",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Hobby Zauberer",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Tierarzt",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Hostesse",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Tierfreund",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Jaeger",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Unterhalter",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Kaemmerer",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Waffenmeister",
                "levelCosts": [
                    35
                ]
            },
            {
                "name": "Kaempe",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Wanderer",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Kampfsportler",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Wirt",
                "levelCosts": [
                    29
                ]
            }
        ]
    },
    {
        "id": 13,
        "name": "Laie",
        "bb": [
            {
                "name": "Kategorie Athletik",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Kategorie Natur",
                "levelCosts": [
                    5
                ],
                "id": "16"
            },
            {
                "name": "Handwerk",
                "levelCosts": [
                    5
                ],
                "id": "5"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    5
                ],
                "id": "21"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    5
                ],
                "id": "8"
            },
            {
                "name": "Kategorie Tech Gewerbe",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    5
                ],
                "id": "13"
            },
            {
                "name": "Kategorie Waffen",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    5
                ],
                "id": "14"
            },
            {
                "name": "Kategorie Wahrnehmung",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "id": "0",
                "name": "Athletik Ausdauer",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "1",
                "name": "Athletik Gymnastik",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "2",
                "name": "Athletik Kraft",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "16",
                "name": "Natur Tiere",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "17",
                "name": "Natur Umwelt",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "100",
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "101",
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "102",
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "103",
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "104",
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "106",
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "107",
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "26",
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "27",
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    5
                ]
            }
        ],
        "ff": [
            {
                "name": "Athletik Ausdauer",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "0"
            },
            {
                "name": "Spezialverteidigung",
                "levelCosts": [
                    30
                ],
                "id": "-1"
            },
            {
                "name": "Athletik Gymnastik",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "1"
            },
            {
                "name": "Staedtisch",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "22"
            },
            {
                "name": "Athletik Kraft",
                "levelCosts": [
                    3,
                    6
                ],
                "id": "2"
            },
            {
                "name": "Tech Gewerbe Allgemein",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "23"
            },
            {
                "name": "Einflussnahme",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "3"
            },
            {
                "name": "Tech Gewerbe Beruflich",
                "levelCosts": [
                    5,
                    12
                ],
                "id": "24"
            },
            {
                "name": "Gezielte Sprueche",
                "levelCosts": [
                    3,
                    6
                ],
                "id": "4"
            },
            {
                "name": "Tech Gewerbe Professionell",
                "levelCosts": [
                    8
                ],
                "id": "25"
            },
            {
                "name": "Handwerk",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "5"
            },
            {
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    3,
                    6
                ],
                "id": "100"
            },
            {
                "name": "Kampfmanoever",
                "levelCosts": [
                    4,
                    12
                ],
                "id": "6"
            },
            {
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    3,
                    6
                ],
                "id": "101"
            },
            {
                "name": "Kommunikation",
                "levelCosts": [
                    2,
                    2,
                    2
                ],
                "id": "7"
            },
            {
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    4
                ],
                "id": "102"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    4,
                    12
                ],
                "id": "8"
            },
            {
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    4
                ],
                "id": "103"
            },
            {
                "name": "Kunst Aktiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "9"
            },
            {
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    6
                ],
                "id": "104"
            },
            {
                "name": "Kunst Passiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    7
                ],
                "id": "106"
            },
            {
                "name": "List Angriff",
                "levelCosts": [
                    6,
                    12
                ],
                "id": "10"
            },
            {
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    7
                ],
                "id": "107"
            },
            {
                "name": "List Mechanik",
                "levelCosts": [
                    3,
                    6
                ],
                "id": "11"
            },
            {
                "name": "Waffenloser Kampf Schlag",
                "levelCosts": [
                    3
                ],
                "id": "-1"
            },
            {
                "name": "List Tarnung",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "12"
            },
            {
                "name": "Waffenloser Kampf Wurf",
                "levelCosts": [
                    3
                ],
                "id": "-1"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    8
                ],
                "id": "13"
            },
            {
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "26"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    4,
                    7
                ],
                "id": "14"
            },
            {
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "27"
            },
            {
                "name": "Magiepunkte entwickeln",
                "levelCosts": [
                    10
                ],
                "id": "15"
            },
            {
                "name": "Wahrnehmung Unbewusst",
                "levelCosts": [
                    3,
                    10
                ],
                "id": "-1"
            },
            {
                "name": "Natur Tiere",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "16"
            },
            {
                "name": "Wissen Allgemein",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "28"
            },
            {
                "name": "Natur Umwelt",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "17"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    3
                ],
                "id": "29"
            },
            {
                "name": "Ruestung Leicht",
                "levelCosts": [
                    2,
                    2,
                    2
                ],
                "id": "18"
            },
            {
                "name": "Wissen Obskur",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "30"
            },
            {
                "name": "Ruestung Mittel",
                "levelCosts": [
                    3,
                    3,
                    3
                ],
                "id": "19"
            },
            {
                "name": "Wissen Technisch",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "31"
            },
            {
                "name": "Ruestung Schwer",
                "levelCosts": [
                    4,
                    4,
                    4
                ],
                "id": "20"
            },
            {
                "name": "Wissenschaft / Analytisch Allgemein",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "32"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "21"
            },
            {
                "name": "Wissenschaft / Analytisch Spezialisiert",
                "levelCosts": [
                    8
                ],
                "id": "-1"
            },
            {
                "name": "Spezialangriff",
                "levelCosts": [
                    5,
                    11
                ],
                "id": "-1"
            }
        ],
        "se": [
            {
                "name": "Offene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            5
                        ],
                        "costs": [
                            10
                        ]
                    },
                    {
                        "levels": [
                            6,
                            10
                        ],
                        "costs": [
                            20
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            30
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            40
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            50
                        ]
                    }
                ]
            },
            {
                "name": "Geschlossene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            5
                        ],
                        "costs": [
                            15
                        ]
                    },
                    {
                        "levels": [
                            6,
                            10
                        ],
                        "costs": [
                            30
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            45
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            60
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            75
                        ]
                    }
                ]
            }
        ],
        "ap": [
            {
                "name": "Abenteurer",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Klatschtante T",
                "levelCosts": [
                    16
                ]
            },
            {
                "name": "Akademiker",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Kraeuterkundiger",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Assassine",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Kriegsakademie",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Athlet",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Meister des Wissens",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Bauer",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Mutter",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Berserker",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Philosoph",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Bettler",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Pirat",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Bibliothekar",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Professor",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Detektiv",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Reisender",
                "levelCosts": [
                    14
                ]
            },
            {
                "name": "Diplomat",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Ritter",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Doktor",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Schamane",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Edelmann",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Schreiber",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Eiferer T",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Schwindler",
                "levelCosts": [
                    21
                ]
            },
            {
                "name": "Einbrecher",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Scout",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Entdecker",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Seemann T",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Fechter",
                "levelCosts": [
                    43
                ]
            },
            {
                "name": "Sheriff",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Fuehrer",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Soldat",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Gefolgsmann",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Soeldner",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Gildenmitglied",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Spion",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Gladiator",
                "levelCosts": [
                    45
                ]
            },
            {
                "name": "Stadtwache T",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Haendler T",
                "levelCosts": [
                    21
                ]
            },
            {
                "name": "Strassenraeuber",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Handwerker T",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Taschendieb",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Hobby Zauberer",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Tierarzt",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Hostesse",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Tierfreund",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Jaeger",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Unterhalter",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Kaemmerer",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Waffenmeister",
                "levelCosts": [
                    36
                ]
            },
            {
                "name": "Kaempe",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Wanderer",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Kampfsportler",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Wirt T",
                "levelCosts": [
                    27
                ]
            }
        ]
    },
    {
        "id": 14,
        "name": "Magent",
        "bb": [
            {
                "name": "Einflussnahme",
                "levelCosts": [
                    5
                ],
                "id": "3"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    5
                ],
                "id": "14"
            },
            {
                "name": "Kommunikation",
                "levelCosts": [
                    5
                ],
                "id": "7"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    10
                ],
                "id": "21"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    5
                ],
                "id": "8"
            },
            {
                "name": "Kategorie Waffen",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Kategorie List",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Kategorie Wahrnehmung",
                "levelCosts": [
                    10
                ],
                "id": "-1"
            },
            {
                "id": "100",
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "101",
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "102",
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "103",
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "104",
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "106",
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "107",
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "10",
                "name": "List Angriff",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "11",
                "name": "List Mechanik",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "12",
                "name": "List Tarnung",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "26",
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "27",
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    10
                ]
            }
        ],
        "ff": [
            {
                "name": "Athletik Ausdauer",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "0"
            },
            {
                "name": "Spezialverteidigung",
                "levelCosts": [
                    20
                ],
                "id": "-1"
            },
            {
                "name": "Athletik Gymnastik",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "1"
            },
            {
                "name": "Staedtisch",
                "levelCosts": [
                    1,
                    4
                ],
                "id": "22"
            },
            {
                "name": "Athletik Kraft",
                "levelCosts": [
                    3,
                    9
                ],
                "id": "2"
            },
            {
                "name": "Tech Gewerbe Allgemein",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "23"
            },
            {
                "name": "Einflussnahme",
                "levelCosts": [
                    1,
                    5
                ],
                "id": "3"
            },
            {
                "name": "Tech Gewerbe Beruflich",
                "levelCosts": [
                    5,
                    12
                ],
                "id": "24"
            },
            {
                "name": "Gezielte Sprueche",
                "levelCosts": [
                    10
                ],
                "id": "4"
            },
            {
                "name": "Tech Gewerbe Professionell",
                "levelCosts": [
                    8
                ],
                "id": "25"
            },
            {
                "name": "Handwerk",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "5"
            },
            {
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "100"
            },
            {
                "name": "Kampfmanoever",
                "levelCosts": [
                    6,
                    14
                ],
                "id": "6"
            },
            {
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    4
                ],
                "id": "101"
            },
            {
                "name": "Kommunikation",
                "levelCosts": [
                    1,
                    1,
                    1
                ],
                "id": "7"
            },
            {
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    6
                ],
                "id": "102"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    6,
                    14
                ],
                "id": "8"
            },
            {
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    7
                ],
                "id": "103"
            },
            {
                "name": "Kunst Aktiv",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "9"
            },
            {
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    8
                ],
                "id": "104"
            },
            {
                "name": "Kunst Passiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    9
                ],
                "id": "106"
            },
            {
                "name": "List Angriff",
                "levelCosts": [
                    5,
                    10
                ],
                "id": "10"
            },
            {
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    10
                ],
                "id": "107"
            },
            {
                "name": "List Mechanik",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "11"
            },
            {
                "name": "Waffenloser Kampf Schlag",
                "levelCosts": [
                    3
                ],
                "id": "-1"
            },
            {
                "name": "List Tarnung",
                "levelCosts": [
                    1,
                    4
                ],
                "id": "12"
            },
            {
                "name": "Waffenloser Kampf Wurf",
                "levelCosts": [
                    3
                ],
                "id": "-1"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    6,
                    12
                ],
                "id": "13"
            },
            {
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "26"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "14"
            },
            {
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    1,
                    5
                ],
                "id": "27"
            },
            {
                "name": "Magiepunkte entwickeln",
                "levelCosts": [
                    8
                ],
                "id": "15"
            },
            {
                "name": "Wahrnehmung Unbewusst",
                "levelCosts": [
                    3,
                    10
                ],
                "id": "-1"
            },
            {
                "name": "Natur Tiere",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "16"
            },
            {
                "name": "Wissen Allgemein",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "28"
            },
            {
                "name": "Natur Umwelt",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "17"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    3,
                    6
                ],
                "id": "29"
            },
            {
                "name": "Ruestung Leicht",
                "levelCosts": [
                    2,
                    2,
                    2
                ],
                "id": "18"
            },
            {
                "name": "Wissen Obskur",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "30"
            },
            {
                "name": "Ruestung Mittel",
                "levelCosts": [
                    4,
                    4,
                    4
                ],
                "id": "19"
            },
            {
                "name": "Wissen Technisch",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "31"
            },
            {
                "name": "Ruestung Schwer",
                "levelCosts": [
                    6,
                    6,
                    6
                ],
                "id": "20"
            },
            {
                "name": "Wissenschaft / Analytisch Allgemein",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "32"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "21"
            },
            {
                "name": "Wissenschaft / Analytisch Spezialisiert",
                "levelCosts": [
                    8
                ],
                "id": "-1"
            },
            {
                "name": "Spezialangriff",
                "levelCosts": [
                    4
                ],
                "id": "-1"
            }
        ],
        "se": [
            {
                "name": "Offene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            10
                        ],
                        "costs": [
                            8,
                            8
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            12
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            18
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            25
                        ]
                    }
                ]
            },
            {
                "name": "Geschlossene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            5
                        ],
                        "costs": [
                            10,
                            10
                        ]
                    },
                    {
                        "levels": [
                            6,
                            10
                        ],
                        "costs": [
                            12
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            25
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            40
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            60
                        ]
                    }
                ]
            },
            {
                "name": "Basislisten alle",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            6,
                            6,
                            6
                        ]
                    }
                ]
            }
        ],
        "ap": [
            {
                "name": "Abenteurer",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Klatschtante",
                "levelCosts": [
                    13
                ]
            },
            {
                "name": "Akademiker",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Kraeuterkundiger",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Assassine T",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Kriegsakademie",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Athlet",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Meister des Wissens",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Bauer",
                "levelCosts": [
                    33
                ]
            },
            {
                "name": "Mutter",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Berserker",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Philosoph",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Bettler",
                "levelCosts": [
                    16
                ]
            },
            {
                "name": "Pirat",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Bibliothekar",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Professor",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Detektiv T",
                "levelCosts": [
                    19
                ]
            },
            {
                "name": "Reisender",
                "levelCosts": [
                    13
                ]
            },
            {
                "name": "Diplomat T",
                "levelCosts": [
                    18
                ]
            },
            {
                "name": "Ritter",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Doktor",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Schamane",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Edelmann",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Schreiber",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Eiferer T",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Schwindler T",
                "levelCosts": [
                    14
                ]
            },
            {
                "name": "Einbrecher",
                "levelCosts": [
                    21
                ]
            },
            {
                "name": "Scout",
                "levelCosts": [
                    21
                ]
            },
            {
                "name": "Entdecker",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Seemann",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Fechter",
                "levelCosts": [
                    45
                ]
            },
            {
                "name": "Sheriff",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Fuehrer",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Soldat",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Gefolgsmann",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Soeldner",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Gildenmitglied",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Spion",
                "levelCosts": [
                    18
                ]
            },
            {
                "name": "Gladiator",
                "levelCosts": [
                    47
                ]
            },
            {
                "name": "Stadtwache",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Haendler",
                "levelCosts": [
                    21
                ]
            },
            {
                "name": "Strassenraeuber",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Handwerker",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Taschendieb T",
                "levelCosts": [
                    18
                ]
            },
            {
                "name": "Hobby Zauberer",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Tierarzt",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Hostesse",
                "levelCosts": [
                    16
                ]
            },
            {
                "name": "Tierfreund",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Jaeger",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Unterhalter T",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Kaemmerer",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Waffenmeister",
                "levelCosts": [
                    39
                ]
            },
            {
                "name": "Kaempe",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Wanderer",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Kampfsportler",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Wirt",
                "levelCosts": [
                    25
                ]
            }
        ]
    },
    {
        "id": 15,
        "name": "Magier",
        "bb": [
            {
                "name": "Gezielte Sprueche",
                "levelCosts": [
                    10
                ],
                "id": "4"
            },
            {
                "name": "Magiepunkte entwickeln",
                "levelCosts": [
                    5
                ],
                "id": "15"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    10
                ],
                "id": "13"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    10
                ],
                "id": "29"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    10
                ],
                "id": "14"
            },
            {
                "name": "Kategorie Zauber",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            }
        ],
        "ff": [
            {
                "name": "Athletik Ausdauer",
                "levelCosts": [
                    3
                ],
                "id": "0"
            },
            {
                "name": "Spezialverteidigung",
                "levelCosts": [
                    40
                ],
                "id": "-1"
            },
            {
                "name": "Athletik Gymnastik",
                "levelCosts": [
                    3
                ],
                "id": "1"
            },
            {
                "name": "Staedtisch",
                "levelCosts": [
                    3
                ],
                "id": "22"
            },
            {
                "name": "Athletik Kraft",
                "levelCosts": [
                    6
                ],
                "id": "2"
            },
            {
                "name": "Tech Gewerbe Allgemein",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "23"
            },
            {
                "name": "Einflussnahme",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "3"
            },
            {
                "name": "Tech Gewerbe Beruflich",
                "levelCosts": [
                    5,
                    12
                ],
                "id": "24"
            },
            {
                "name": "Gezielte Sprueche",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "4"
            },
            {
                "name": "Tech Gewerbe Professionell",
                "levelCosts": [
                    8
                ],
                "id": "25"
            },
            {
                "name": "Handwerk",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "5"
            },
            {
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    9
                ],
                "id": "100"
            },
            {
                "name": "Kampfmanoever",
                "levelCosts": [
                    18
                ],
                "id": "6"
            },
            {
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    20
                ],
                "id": "101"
            },
            {
                "name": "Kommunikation",
                "levelCosts": [
                    2,
                    2,
                    2
                ],
                "id": "7"
            },
            {
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    20
                ],
                "id": "102"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    15
                ],
                "id": "8"
            },
            {
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    20
                ],
                "id": "103"
            },
            {
                "name": "Kunst Aktiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "9"
            },
            {
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    20
                ],
                "id": "104"
            },
            {
                "name": "Kunst Passiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    20
                ],
                "id": "106"
            },
            {
                "name": "List Angriff",
                "levelCosts": [
                    15
                ],
                "id": "10"
            },
            {
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    20
                ],
                "id": "107"
            },
            {
                "name": "List Mechanik",
                "levelCosts": [
                    7
                ],
                "id": "11"
            },
            {
                "name": "Waffenloser Kampf Schlag",
                "levelCosts": [
                    9
                ],
                "id": "-1"
            },
            {
                "name": "List Tarnung",
                "levelCosts": [
                    5
                ],
                "id": "12"
            },
            {
                "name": "Waffenloser Kampf Wurf",
                "levelCosts": [
                    9
                ],
                "id": "-1"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    4,
                    10
                ],
                "id": "13"
            },
            {
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "26"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    1,
                    4
                ],
                "id": "14"
            },
            {
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    3
                ],
                "id": "27"
            },
            {
                "name": "Magiepunkte entwickeln",
                "levelCosts": [
                    4
                ],
                "id": "15"
            },
            {
                "name": "Wahrnehmung Unbewusst",
                "levelCosts": [
                    6
                ],
                "id": "-1"
            },
            {
                "name": "Natur Tiere",
                "levelCosts": [
                    3
                ],
                "id": "16"
            },
            {
                "name": "Wissen Allgemein",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "28"
            },
            {
                "name": "Natur Umwelt",
                "levelCosts": [
                    3
                ],
                "id": "17"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    1,
                    4
                ],
                "id": "29"
            },
            {
                "name": "Ruestung Leicht",
                "levelCosts": [
                    9
                ],
                "id": "18"
            },
            {
                "name": "Wissen Obskur",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "30"
            },
            {
                "name": "Ruestung Mittel",
                "levelCosts": [
                    10
                ],
                "id": "19"
            },
            {
                "name": "Wissen Technisch",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "31"
            },
            {
                "name": "Ruestung Schwer",
                "levelCosts": [
                    11
                ],
                "id": "20"
            },
            {
                "name": "Wissenschaft / Analytisch Allgemein",
                "levelCosts": [
                    1,
                    4
                ],
                "id": "32"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    6
                ],
                "id": "21"
            },
            {
                "name": "Wissenschaft / Analytisch Spezialisiert",
                "levelCosts": [
                    6,
                    14
                ],
                "id": "-1"
            },
            {
                "name": "Spezialangriff",
                "levelCosts": [
                    15
                ],
                "id": "-1"
            }
        ],
        "se": [
            {
                "name": "Offene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            10
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            6,
                            6,
                            6
                        ]
                    }
                ]
            },
            {
                "name": "Geschlossene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            5
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            6,
                            10
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            8,
                            8
                        ]
                    }
                ]
            },
            {
                "name": "Basislisten alle",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            3,
                            3,
                            3
                        ]
                    }
                ]
            }
        ],
        "ap": [
            {
                "name": "Abenteurer",
                "levelCosts": [
                    34
                ]
            },
            {
                "name": "Klatschtante",
                "levelCosts": [
                    18
                ]
            },
            {
                "name": "Akademiker",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Kraeuterkundiger",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Assassine",
                "levelCosts": [
                    40
                ]
            },
            {
                "name": "Kriegsakademie",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Athlet",
                "levelCosts": [
                    42
                ]
            },
            {
                "name": "Meister des Wissens T",
                "levelCosts": [
                    19
                ]
            },
            {
                "name": "Bauer",
                "levelCosts": [
                    44
                ]
            },
            {
                "name": "Mutter",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Berserker",
                "levelCosts": [
                    45
                ]
            },
            {
                "name": "Philosoph",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Bettler",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Pirat",
                "levelCosts": [
                    37
                ]
            },
            {
                "name": "Bibliothekar",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Professor T",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Detektiv",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Reisender",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Diplomat",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Ritter",
                "levelCosts": [
                    46
                ]
            },
            {
                "name": "Doktor",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Schamane",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Edelmann",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Schreiber",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Eiferer",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Schwindler",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Einbrecher",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Scout",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Entdecker",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Seemann",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Fechter",
                "levelCosts": [
                    53
                ]
            },
            {
                "name": "Sheriff",
                "levelCosts": [
                    40
                ]
            },
            {
                "name": "Fuehrer",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Soldat",
                "levelCosts": [
                    37
                ]
            },
            {
                "name": "Gefolgsmann",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Soeldner",
                "levelCosts": [
                    44
                ]
            },
            {
                "name": "Gildenmitglied",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Spion",
                "levelCosts": [
                    33
                ]
            },
            {
                "name": "Gladiator",
                "levelCosts": [
                    61
                ]
            },
            {
                "name": "Stadtwache",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Haendler T",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Strassenraeuber",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Handwerker",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Taschendieb",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Hobby Zauberer T",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Tierarzt",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Hostesse",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Tierfreund",
                "levelCosts": [
                    33
                ]
            },
            {
                "name": "Jaeger",
                "levelCosts": [
                    36
                ]
            },
            {
                "name": "Unterhalter",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Kaemmerer",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Waffenmeister",
                "levelCosts": [
                    84
                ]
            },
            {
                "name": "Kaempe",
                "levelCosts": [
                    43
                ]
            },
            {
                "name": "Wanderer",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Kampfsportler",
                "levelCosts": [
                    40
                ]
            },
            {
                "name": "Wirt",
                "levelCosts": [
                    28
                ]
            }
        ]
    },
    {
        "id": 16,
        "name": "Mentalist",
        "bb": [
            {
                "name": "Einflussnahme",
                "levelCosts": [
                    10
                ],
                "id": "3"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    5
                ],
                "id": "21"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    5
                ],
                "id": "8"
            },
            {
                "name": "Kategorie Wahrnehmung",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    5
                ],
                "id": "13"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    5
                ],
                "id": "29"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    5
                ],
                "id": "14"
            },
            {
                "name": "Kategorie Zauber",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Magiepunkte entwickeln",
                "levelCosts": [
                    5
                ],
                "id": "15"
            },
            {
                "id": "26",
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "27",
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    5
                ]
            }
        ],
        "ff": [
            {
                "name": "Athletik Ausdauer",
                "levelCosts": [
                    3
                ],
                "id": "0"
            },
            {
                "name": "Spezialverteidigung",
                "levelCosts": [
                    25
                ],
                "id": "-1"
            },
            {
                "name": "Athletik Gymnastik",
                "levelCosts": [
                    3,
                    9
                ],
                "id": "1"
            },
            {
                "name": "Staedtisch",
                "levelCosts": [
                    3
                ],
                "id": "22"
            },
            {
                "name": "Athletik Kraft",
                "levelCosts": [
                    5
                ],
                "id": "2"
            },
            {
                "name": "Tech Gewerbe Allgemein",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "23"
            },
            {
                "name": "Einflussnahme",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "3"
            },
            {
                "name": "Tech Gewerbe Beruflich",
                "levelCosts": [
                    5,
                    12
                ],
                "id": "24"
            },
            {
                "name": "Gezielte Sprueche",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "4"
            },
            {
                "name": "Tech Gewerbe Professionell",
                "levelCosts": [
                    8
                ],
                "id": "25"
            },
            {
                "name": "Handwerk",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "5"
            },
            {
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    6
                ],
                "id": "100"
            },
            {
                "name": "Kampfmanoever",
                "levelCosts": [
                    14
                ],
                "id": "6"
            },
            {
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    8
                ],
                "id": "101"
            },
            {
                "name": "Kommunikation",
                "levelCosts": [
                    2,
                    2,
                    2
                ],
                "id": "7"
            },
            {
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    15
                ],
                "id": "102"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    12
                ],
                "id": "8"
            },
            {
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    20
                ],
                "id": "103"
            },
            {
                "name": "Kunst Aktiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "9"
            },
            {
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    20
                ],
                "id": "104"
            },
            {
                "name": "Kunst Passiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    20
                ],
                "id": "106"
            },
            {
                "name": "List Angriff",
                "levelCosts": [
                    15
                ],
                "id": "10"
            },
            {
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    20
                ],
                "id": "107"
            },
            {
                "name": "List Mechanik",
                "levelCosts": [
                    7
                ],
                "id": "11"
            },
            {
                "name": "Waffenloser Kampf Schlag",
                "levelCosts": [
                    3
                ],
                "id": "-1"
            },
            {
                "name": "List Tarnung",
                "levelCosts": [
                    5
                ],
                "id": "12"
            },
            {
                "name": "Waffenloser Kampf Wurf",
                "levelCosts": [
                    3
                ],
                "id": "-1"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    4,
                    10
                ],
                "id": "13"
            },
            {
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "26"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "14"
            },
            {
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    3
                ],
                "id": "27"
            },
            {
                "name": "Magiepunkte entwickeln",
                "levelCosts": [
                    4
                ],
                "id": "15"
            },
            {
                "name": "Wahrnehmung Unbewusst",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Natur Tiere",
                "levelCosts": [
                    3
                ],
                "id": "16"
            },
            {
                "name": "Wissen Allgemein",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "28"
            },
            {
                "name": "Natur Umwelt",
                "levelCosts": [
                    3
                ],
                "id": "17"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "29"
            },
            {
                "name": "Ruestung Leicht",
                "levelCosts": [
                    4,
                    4,
                    4
                ],
                "id": "18"
            },
            {
                "name": "Wissen Obskur",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "30"
            },
            {
                "name": "Ruestung Mittel",
                "levelCosts": [
                    6,
                    6,
                    6
                ],
                "id": "19"
            },
            {
                "name": "Wissen Technisch",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "31"
            },
            {
                "name": "Ruestung Schwer",
                "levelCosts": [
                    7,
                    7,
                    7
                ],
                "id": "20"
            },
            {
                "name": "Wissenschaft / Analytisch Allgemein",
                "levelCosts": [
                    1,
                    4
                ],
                "id": "32"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    3
                ],
                "id": "21"
            },
            {
                "name": "Wissenschaft / Analytisch Spezialisiert",
                "levelCosts": [
                    6,
                    14
                ],
                "id": "-1"
            },
            {
                "name": "Spezialangriff",
                "levelCosts": [
                    12
                ],
                "id": "-1"
            }
        ],
        "se": [
            {
                "name": "Offene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            10
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            6,
                            6,
                            6
                        ]
                    }
                ]
            },
            {
                "name": "Geschlossene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            5
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            6,
                            10
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            8,
                            8
                        ]
                    }
                ]
            },
            {
                "name": "Basislisten alle",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            3,
                            3,
                            3
                        ]
                    }
                ]
            }
        ],
        "ap": [
            {
                "name": "Abenteurer",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Klatschtante",
                "levelCosts": [
                    18
                ]
            },
            {
                "name": "Akademiker",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Kraeuterkundiger",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Assassine",
                "levelCosts": [
                    37
                ]
            },
            {
                "name": "Kriegsakademie",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Athlet",
                "levelCosts": [
                    38
                ]
            },
            {
                "name": "Meister des Wissens T",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Bauer",
                "levelCosts": [
                    41
                ]
            },
            {
                "name": "Mutter",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Berserker",
                "levelCosts": [
                    34
                ]
            },
            {
                "name": "Philosoph",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Bettler",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Pirat",
                "levelCosts": [
                    35
                ]
            },
            {
                "name": "Bibliothekar",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Professor T",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Detektiv",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Reisender",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Diplomat",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Ritter",
                "levelCosts": [
                    40
                ]
            },
            {
                "name": "Doktor",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Schamane",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Edelmann",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Schreiber",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Eiferer T",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Schwindler",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Einbrecher",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Scout",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Entdecker",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Seemann",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Fechter",
                "levelCosts": [
                    49
                ]
            },
            {
                "name": "Sheriff",
                "levelCosts": [
                    35
                ]
            },
            {
                "name": "Fuehrer",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Soldat",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Gefolgsmann",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Soeldner",
                "levelCosts": [
                    38
                ]
            },
            {
                "name": "Gildenmitglied",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Spion",
                "levelCosts": [
                    33
                ]
            },
            {
                "name": "Gladiator",
                "levelCosts": [
                    56
                ]
            },
            {
                "name": "Stadtwache",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Haendler T",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Strassenraeuber",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Handwerker",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Taschendieb",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Hobby Zauberer",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Tierarzt",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Hostesse",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Tierfreund",
                "levelCosts": [
                    33
                ]
            },
            {
                "name": "Jaeger",
                "levelCosts": [
                    35
                ]
            },
            {
                "name": "Unterhalter",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Kaemmerer",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Waffenmeister",
                "levelCosts": [
                    61
                ]
            },
            {
                "name": "Kaempe",
                "levelCosts": [
                    38
                ]
            },
            {
                "name": "Wanderer",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Kampfsportler",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Wirt",
                "levelCosts": [
                    28
                ]
            }
        ]
    },
    {
        "id": 17,
        "name": "Moench",
        "bb": [
            {
                "name": "Athletik Gymnastik",
                "levelCosts": [
                    5
                ],
                "id": "1"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    10
                ],
                "id": "21"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    5
                ],
                "id": "8"
            },
            {
                "name": "Kategorie Waffen",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "List Tarnung",
                "levelCosts": [
                    5
                ],
                "id": "12"
            },
            {
                "name": "Kategorie Waffenloser Kampf",
                "levelCosts": [
                    10
                ],
                "id": "-1"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    5
                ],
                "id": "14"
            },
            {
                "name": "Kategorie Wahrnehmung",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "id": "100",
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "101",
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "102",
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "103",
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "104",
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "106",
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "107",
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "26",
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "27",
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    5
                ]
            }
        ],
        "ff": [
            {
                "name": "Athletik Ausdauer",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "0"
            },
            {
                "name": "Spezialverteidigung",
                "levelCosts": [
                    10
                ],
                "id": "-1"
            },
            {
                "name": "Athletik Gymnastik",
                "levelCosts": [
                    1,
                    5
                ],
                "id": "1"
            },
            {
                "name": "Staedtisch",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "22"
            },
            {
                "name": "Athletik Kraft",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "2"
            },
            {
                "name": "Tech Gewerbe Allgemein",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "23"
            },
            {
                "name": "Einflussnahme",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "3"
            },
            {
                "name": "Tech Gewerbe Beruflich",
                "levelCosts": [
                    5,
                    12
                ],
                "id": "24"
            },
            {
                "name": "Gezielte Sprueche",
                "levelCosts": [
                    9
                ],
                "id": "4"
            },
            {
                "name": "Tech Gewerbe Professionell",
                "levelCosts": [
                    8
                ],
                "id": "25"
            },
            {
                "name": "Handwerk",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "5"
            },
            {
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    5
                ],
                "id": "100"
            },
            {
                "name": "Kampfmanoever",
                "levelCosts": [
                    5,
                    12
                ],
                "id": "6"
            },
            {
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    8
                ],
                "id": "101"
            },
            {
                "name": "Kommunikation",
                "levelCosts": [
                    3,
                    3,
                    3
                ],
                "id": "7"
            },
            {
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    8
                ],
                "id": "102"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    6,
                    14
                ],
                "id": "8"
            },
            {
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    8
                ],
                "id": "103"
            },
            {
                "name": "Kunst Aktiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "9"
            },
            {
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    15
                ],
                "id": "104"
            },
            {
                "name": "Kunst Passiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    15
                ],
                "id": "106"
            },
            {
                "name": "List Angriff",
                "levelCosts": [
                    8
                ],
                "id": "10"
            },
            {
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    15
                ],
                "id": "107"
            },
            {
                "name": "List Mechanik",
                "levelCosts": [
                    4
                ],
                "id": "11"
            },
            {
                "name": "Waffenloser Kampf Schlag",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "-1"
            },
            {
                "name": "List Tarnung",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "12"
            },
            {
                "name": "Waffenloser Kampf Wurf",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    6,
                    12
                ],
                "id": "13"
            },
            {
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "26"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "14"
            },
            {
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "27"
            },
            {
                "name": "Magiepunkte entwickeln",
                "levelCosts": [
                    8
                ],
                "id": "15"
            },
            {
                "name": "Wahrnehmung Unbewusst",
                "levelCosts": [
                    4,
                    14
                ],
                "id": "-1"
            },
            {
                "name": "Natur Tiere",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "16"
            },
            {
                "name": "Wissen Allgemein",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "28"
            },
            {
                "name": "Natur Umwelt",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "17"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    3,
                    6
                ],
                "id": "29"
            },
            {
                "name": "Ruestung Leicht",
                "levelCosts": [
                    9
                ],
                "id": "18"
            },
            {
                "name": "Wissen Obskur",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "30"
            },
            {
                "name": "Ruestung Mittel",
                "levelCosts": [
                    10
                ],
                "id": "19"
            },
            {
                "name": "Wissen Technisch",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "31"
            },
            {
                "name": "Ruestung Schwer",
                "levelCosts": [
                    11
                ],
                "id": "20"
            },
            {
                "name": "Wissenschaft / Analytisch Allgemein",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "32"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "21"
            },
            {
                "name": "Wissenschaft / Analytisch Spezialisiert",
                "levelCosts": [
                    8
                ],
                "id": "-1"
            },
            {
                "name": "Spezialangriff",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            }
        ],
        "se": [
            {
                "name": "Offene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            10
                        ],
                        "costs": [
                            8,
                            8
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            12
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            18
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            25
                        ]
                    }
                ]
            },
            {
                "name": "Geschlossene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            5
                        ],
                        "costs": [
                            10,
                            10
                        ]
                    },
                    {
                        "levels": [
                            6,
                            10
                        ],
                        "costs": [
                            12
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            25
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            40
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            60
                        ]
                    }
                ]
            },
            {
                "name": "Basislisten alle",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            6,
                            6,
                            6
                        ]
                    }
                ]
            }
        ],
        "ap": [
            {
                "name": "Abenteurer",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Klatschtante",
                "levelCosts": [
                    19
                ]
            },
            {
                "name": "Akademiker",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Kraeuterkundiger",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Assassine",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Kriegsakademie",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Athlet",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Meister des Wissens",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Bauer",
                "levelCosts": [
                    33
                ]
            },
            {
                "name": "Mutter",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Berserker",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Philosoph",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Bettler",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Pirat",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Bibliothekar",
                "levelCosts": [
                    34
                ]
            },
            {
                "name": "Professor",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Detektiv",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Reisender",
                "levelCosts": [
                    13
                ]
            },
            {
                "name": "Diplomat",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Ritter",
                "levelCosts": [
                    36
                ]
            },
            {
                "name": "Doktor",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Schamane",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Edelmann",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Schreiber",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Eiferer T",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Schwindler",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Einbrecher",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Scout",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Entdecker",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Seemann T",
                "levelCosts": [
                    19
                ]
            },
            {
                "name": "Fechter",
                "levelCosts": [
                    49
                ]
            },
            {
                "name": "Sheriff",
                "levelCosts": [
                    34
                ]
            },
            {
                "name": "Fuehrer",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Soldat",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Gefolgsmann",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Soeldner",
                "levelCosts": [
                    35
                ]
            },
            {
                "name": "Gildenmitglied",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Spion",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Gladiator",
                "levelCosts": [
                    49
                ]
            },
            {
                "name": "Stadtwache",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Haendler",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Strassenraeuber",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Handwerker",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Taschendieb",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Hobby Zauberer",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Tierarzt",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Hostesse",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Tierfreund",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Jaeger",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Unterhalter",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Kaemmerer",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Waffenmeister",
                "levelCosts": [
                    49
                ]
            },
            {
                "name": "Kaempe",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Wanderer",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Kampfsportler T",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Wirt",
                "levelCosts": [
                    28
                ]
            }
        ]
    },
    {
        "id": 18,
        "name": "Mystiker",
        "bb": [
            {
                "name": "Einflussnahme",
                "levelCosts": [
                    5
                ],
                "id": "3"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    5
                ],
                "id": "21"
            },
            {
                "name": "List Tarnung",
                "levelCosts": [
                    5
                ],
                "id": "12"
            },
            {
                "name": "Kategorie Wahrnehmung",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    5
                ],
                "id": "13"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    5
                ],
                "id": "29"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    10
                ],
                "id": "14"
            },
            {
                "name": "Kategorie Zauber",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Magiepunkte entwickeln",
                "levelCosts": [
                    5
                ],
                "id": "15"
            },
            {
                "id": "26",
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "27",
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    5
                ]
            }
        ],
        "ff": [
            {
                "name": "Athletik Ausdauer",
                "levelCosts": [
                    3
                ],
                "id": "0"
            },
            {
                "name": "Spezialverteidigung",
                "levelCosts": [
                    25
                ],
                "id": "-1"
            },
            {
                "name": "Athletik Gymnastik",
                "levelCosts": [
                    3
                ],
                "id": "1"
            },
            {
                "name": "Staedtisch",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "22"
            },
            {
                "name": "Athletik Kraft",
                "levelCosts": [
                    7
                ],
                "id": "2"
            },
            {
                "name": "Tech Gewerbe Allgemein",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "23"
            },
            {
                "name": "Einflussnahme",
                "levelCosts": [
                    1,
                    4
                ],
                "id": "3"
            },
            {
                "name": "Tech Gewerbe Beruflich",
                "levelCosts": [
                    5,
                    12
                ],
                "id": "24"
            },
            {
                "name": "Gezielte Sprueche",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "4"
            },
            {
                "name": "Tech Gewerbe Professionell",
                "levelCosts": [
                    8
                ],
                "id": "25"
            },
            {
                "name": "Handwerk",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "5"
            },
            {
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    9
                ],
                "id": "100"
            },
            {
                "name": "Kampfmanoever",
                "levelCosts": [
                    18
                ],
                "id": "6"
            },
            {
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    20
                ],
                "id": "101"
            },
            {
                "name": "Kommunikation",
                "levelCosts": [
                    1,
                    1,
                    1
                ],
                "id": "7"
            },
            {
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    20
                ],
                "id": "102"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    15
                ],
                "id": "8"
            },
            {
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    20
                ],
                "id": "103"
            },
            {
                "name": "Kunst Aktiv",
                "levelCosts": [
                    1,
                    4
                ],
                "id": "9"
            },
            {
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    20
                ],
                "id": "104"
            },
            {
                "name": "Kunst Passiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    20
                ],
                "id": "106"
            },
            {
                "name": "List Angriff",
                "levelCosts": [
                    15
                ],
                "id": "10"
            },
            {
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    20
                ],
                "id": "107"
            },
            {
                "name": "List Mechanik",
                "levelCosts": [
                    7
                ],
                "id": "11"
            },
            {
                "name": "Waffenloser Kampf Schlag",
                "levelCosts": [
                    6
                ],
                "id": "-1"
            },
            {
                "name": "List Tarnung",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "12"
            },
            {
                "name": "Waffenloser Kampf Wurf",
                "levelCosts": [
                    6
                ],
                "id": "-1"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    4,
                    10
                ],
                "id": "13"
            },
            {
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "26"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "14"
            },
            {
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "27"
            },
            {
                "name": "Magiepunkte entwickeln",
                "levelCosts": [
                    6
                ],
                "id": "15"
            },
            {
                "name": "Wahrnehmung Unbewusst",
                "levelCosts": [
                    3
                ],
                "id": "-1"
            },
            {
                "name": "Natur Tiere",
                "levelCosts": [
                    3
                ],
                "id": "16"
            },
            {
                "name": "Wissen Allgemein",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "28"
            },
            {
                "name": "Natur Umwelt",
                "levelCosts": [
                    3
                ],
                "id": "17"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "29"
            },
            {
                "name": "Ruestung Leicht",
                "levelCosts": [
                    4,
                    4,
                    4
                ],
                "id": "18"
            },
            {
                "name": "Wissen Obskur",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "30"
            },
            {
                "name": "Ruestung Mittel",
                "levelCosts": [
                    6,
                    6,
                    6
                ],
                "id": "19"
            },
            {
                "name": "Wissen Technisch",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "31"
            },
            {
                "name": "Ruestung Schwer",
                "levelCosts": [
                    7,
                    7,
                    7
                ],
                "id": "20"
            },
            {
                "name": "Wissenschaft / Analytisch Allgemein",
                "levelCosts": [
                    1,
                    4
                ],
                "id": "32"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    5
                ],
                "id": "21"
            },
            {
                "name": "Wissenschaft / Analytisch Spezialisiert",
                "levelCosts": [
                    6,
                    14
                ],
                "id": "-1"
            },
            {
                "name": "Spezialangriff",
                "levelCosts": [
                    15
                ],
                "id": "-1"
            }
        ],
        "se": [
            {
                "name": "Offene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            10
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            6,
                            6,
                            6
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            8,
                            8
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            12
                        ]
                    }
                ]
            },
            {
                "name": "Geschlossene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            5
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            6,
                            10
                        ],
                        "costs": [
                            6,
                            6,
                            6
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            8,
                            8
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            10,
                            10
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            25
                        ]
                    }
                ]
            },
            {
                "name": "Basislisten alle",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            3,
                            3,
                            3
                        ]
                    }
                ]
            }
        ],
        "ap": [
            {
                "name": "Abenteurer",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Klatschtante",
                "levelCosts": [
                    11
                ]
            },
            {
                "name": "Akademiker",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Kraeuterkundiger",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Assassine",
                "levelCosts": [
                    37
                ]
            },
            {
                "name": "Kriegsakademie",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Athlet",
                "levelCosts": [
                    43
                ]
            },
            {
                "name": "Meister des Wissens T",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Bauer",
                "levelCosts": [
                    44
                ]
            },
            {
                "name": "Mutter",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Berserker",
                "levelCosts": [
                    44
                ]
            },
            {
                "name": "Philosoph T",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Bettler",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Pirat",
                "levelCosts": [
                    37
                ]
            },
            {
                "name": "Bibliothekar",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Professor T",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Detektiv",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Reisender",
                "levelCosts": [
                    19
                ]
            },
            {
                "name": "Diplomat T",
                "levelCosts": [
                    19
                ]
            },
            {
                "name": "Ritter",
                "levelCosts": [
                    43
                ]
            },
            {
                "name": "Doktor",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Schamane",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Edelmann",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Schreiber",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Eiferer T",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Schwindler T",
                "levelCosts": [
                    19
                ]
            },
            {
                "name": "Einbrecher",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Scout",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Entdecker",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Seemann",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Fechter",
                "levelCosts": [
                    61
                ]
            },
            {
                "name": "Sheriff",
                "levelCosts": [
                    34
                ]
            },
            {
                "name": "Fuehrer",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Soldat",
                "levelCosts": [
                    34
                ]
            },
            {
                "name": "Gefolgsmann",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Soeldner",
                "levelCosts": [
                    40
                ]
            },
            {
                "name": "Gildenmitglied",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Spion T",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Gladiator",
                "levelCosts": [
                    61
                ]
            },
            {
                "name": "Stadtwache",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Haendler T",
                "levelCosts": [
                    18
                ]
            },
            {
                "name": "Strassenraeuber",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Handwerker",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Taschendieb",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Hobby Zauberer",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Tierarzt",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Hostesse",
                "levelCosts": [
                    16
                ]
            },
            {
                "name": "Tierfreund",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Jaeger",
                "levelCosts": [
                    33
                ]
            },
            {
                "name": "Unterhalter T",
                "levelCosts": [
                    18
                ]
            },
            {
                "name": "Kaemmerer",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Waffenmeister",
                "levelCosts": [
                    84
                ]
            },
            {
                "name": "Kaempe",
                "levelCosts": [
                    41
                ]
            },
            {
                "name": "Wanderer",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Kampfsportler",
                "levelCosts": [
                    35
                ]
            },
            {
                "name": "Wirt",
                "levelCosts": [
                    26
                ]
            }
        ]
    },
    {
        "id": 19,
        "name": "Paladin",
        "bb": [
            {
                "name": "Kategorie Athletik",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Kategorie Ruestung",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Kampfmanoever",
                "levelCosts": [
                    10
                ],
                "id": "6"
            },
            {
                "name": "Kategorie Waffen",
                "levelCosts": [
                    10
                ],
                "id": "-1"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    10
                ],
                "id": "8"
            },
            {
                "name": "Kategorie Wahrnehmung",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    5
                ],
                "id": "13"
            },
            {
                "id": "0",
                "name": "Athletik Ausdauer",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "1",
                "name": "Athletik Gymnastik",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "2",
                "name": "Athletik Kraft",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "100",
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "101",
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "102",
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "103",
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "104",
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "106",
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "107",
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "26",
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "27",
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    5
                ]
            }
        ],
        "ff": [
            {
                "name": "Athletik Ausdauer",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "0"
            },
            {
                "name": "Spezialverteidigung",
                "levelCosts": [
                    40
                ],
                "id": "-1"
            },
            {
                "name": "Athletik Gymnastik",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "1"
            },
            {
                "name": "Staedtisch",
                "levelCosts": [
                    4
                ],
                "id": "22"
            },
            {
                "name": "Athletik Kraft",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "2"
            },
            {
                "name": "Tech Gewerbe Allgemein",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "23"
            },
            {
                "name": "Einflussnahme",
                "levelCosts": [
                    1,
                    5
                ],
                "id": "3"
            },
            {
                "name": "Tech Gewerbe Beruflich",
                "levelCosts": [
                    5,
                    12
                ],
                "id": "24"
            },
            {
                "name": "Gezielte Sprueche",
                "levelCosts": [
                    20
                ],
                "id": "4"
            },
            {
                "name": "Tech Gewerbe Professionell",
                "levelCosts": [
                    8
                ],
                "id": "25"
            },
            {
                "name": "Handwerk",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "5"
            },
            {
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "100"
            },
            {
                "name": "Kampfmanoever",
                "levelCosts": [
                    4,
                    10
                ],
                "id": "6"
            },
            {
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    3,
                    8
                ],
                "id": "101"
            },
            {
                "name": "Kommunikation",
                "levelCosts": [
                    3,
                    3,
                    3
                ],
                "id": "7"
            },
            {
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    4
                ],
                "id": "102"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    4,
                    10
                ],
                "id": "8"
            },
            {
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    4
                ],
                "id": "103"
            },
            {
                "name": "Kunst Aktiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "9"
            },
            {
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    4
                ],
                "id": "104"
            },
            {
                "name": "Kunst Passiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    6
                ],
                "id": "106"
            },
            {
                "name": "List Angriff",
                "levelCosts": [
                    15
                ],
                "id": "10"
            },
            {
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    6
                ],
                "id": "107"
            },
            {
                "name": "List Mechanik",
                "levelCosts": [
                    7
                ],
                "id": "11"
            },
            {
                "name": "Waffenloser Kampf Schlag",
                "levelCosts": [
                    6
                ],
                "id": "-1"
            },
            {
                "name": "List Tarnung",
                "levelCosts": [
                    5
                ],
                "id": "12"
            },
            {
                "name": "Waffenloser Kampf Wurf",
                "levelCosts": [
                    6
                ],
                "id": "-1"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    6,
                    12
                ],
                "id": "13"
            },
            {
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "26"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    6
                ],
                "id": "14"
            },
            {
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "27"
            },
            {
                "name": "Magiepunkte entwickeln",
                "levelCosts": [
                    8
                ],
                "id": "15"
            },
            {
                "name": "Wahrnehmung Unbewusst",
                "levelCosts": [
                    5,
                    14
                ],
                "id": "-1"
            },
            {
                "name": "Natur Tiere",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "16"
            },
            {
                "name": "Wissen Allgemein",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "28"
            },
            {
                "name": "Natur Umwelt",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "17"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    3,
                    6
                ],
                "id": "29"
            },
            {
                "name": "Ruestung Leicht",
                "levelCosts": [
                    1,
                    1,
                    1
                ],
                "id": "18"
            },
            {
                "name": "Wissen Obskur",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "30"
            },
            {
                "name": "Ruestung Mittel",
                "levelCosts": [
                    2,
                    2,
                    2
                ],
                "id": "19"
            },
            {
                "name": "Wissen Technisch",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "31"
            },
            {
                "name": "Ruestung Schwer",
                "levelCosts": [
                    3,
                    3,
                    3
                ],
                "id": "20"
            },
            {
                "name": "Wissenschaft / Analytisch Allgemein",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "32"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "21"
            },
            {
                "name": "Wissenschaft / Analytisch Spezialisiert",
                "levelCosts": [
                    8
                ],
                "id": "-1"
            },
            {
                "name": "Spezialangriff",
                "levelCosts": [
                    2,
                    8
                ],
                "id": "-1"
            }
        ],
        "se": [
            {
                "name": "Offene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            10
                        ],
                        "costs": [
                            8,
                            8
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            12
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            18
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            25
                        ]
                    }
                ]
            },
            {
                "name": "Geschlossene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            5
                        ],
                        "costs": [
                            10,
                            10
                        ]
                    },
                    {
                        "levels": [
                            6,
                            10
                        ],
                        "costs": [
                            12
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            25
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            40
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            60
                        ]
                    }
                ]
            },
            {
                "name": "Basislisten alle",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            6,
                            6,
                            6
                        ]
                    }
                ]
            }
        ],
        "ap": [
            {
                "name": "Abenteurer",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Klatschtante",
                "levelCosts": [
                    16
                ]
            },
            {
                "name": "Akademiker",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Kraeuterkundiger",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Assassine I",
                "levelCosts": [
                    34
                ]
            },
            {
                "name": "Kriegsakademie",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Athlet",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Meister des Wissens",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Bauer",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Mutter",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Berserker I",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Philosoph",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Bettler",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Pirat I",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Bibliothekar",
                "levelCosts": [
                    34
                ]
            },
            {
                "name": "Professor",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Detektiv",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Reisender",
                "levelCosts": [
                    15
                ]
            },
            {
                "name": "Diplomat",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Ritter T",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Doktor",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Schamane",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Edelmann T",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Schreiber",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Eiferer T",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Schwindler I",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Einbrecher I",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Scout",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Entdecker",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Seemann T",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Fechter",
                "levelCosts": [
                    34
                ]
            },
            {
                "name": "Sheriff",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Fuehrer",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Soldat T",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Gefolgsmann",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Soeldner I",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Gildenmitglied",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Spion I",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Gladiator",
                "levelCosts": [
                    47
                ]
            },
            {
                "name": "Stadtwache T",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Haendler",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Strassenraeuber I",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Handwerker",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Taschendieb I",
                "levelCosts": [
                    33
                ]
            },
            {
                "name": "Hobby Zauberer I",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Tierarzt",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Hostesse I",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Tierfreund",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Jaeger",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Unterhalter",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Kaemmerer",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Waffenmeister",
                "levelCosts": [
                    34
                ]
            },
            {
                "name": "Kaempe T",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Wanderer",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Kampfsportler I",
                "levelCosts": [
                    35
                ]
            },
            {
                "name": "Wirt",
                "levelCosts": [
                    28
                ]
            }
        ]
    },
    {
        "id": 20,
        "name": "Schurke",
        "bb": [
            {
                "name": "Athletik Gymnastik",
                "levelCosts": [
                    5
                ],
                "id": "1"
            },
            {
                "name": "Kampfmanoever",
                "levelCosts": [
                    5
                ],
                "id": "6"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    5
                ],
                "id": "8"
            },
            {
                "name": "Kategorie List",
                "levelCosts": [
                    10
                ],
                "id": "-1"
            },
            {
                "name": "Kategorie Ruestung",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Kategorie Waffen",
                "levelCosts": [
                    15
                ],
                "id": "-1"
            },
            {
                "name": "Kategorie Wahrnehmung",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "id": "10",
                "name": "List Angriff",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "11",
                "name": "List Mechanik",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "12",
                "name": "List Tarnung",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "100",
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    15
                ]
            },
            {
                "id": "101",
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    15
                ]
            },
            {
                "id": "102",
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    15
                ]
            },
            {
                "id": "103",
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    15
                ]
            },
            {
                "id": "104",
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    15
                ]
            },
            {
                "id": "106",
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    15
                ]
            },
            {
                "id": "107",
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    15
                ]
            },
            {
                "id": "26",
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "27",
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    5
                ]
            }
        ],
        "ff": [
            {
                "name": "Athletik Ausdauer",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "0"
            },
            {
                "name": "Spezialverteidigung",
                "levelCosts": [
                    35
                ],
                "id": "-1"
            },
            {
                "name": "Athletik Gymnastik",
                "levelCosts": [
                    1,
                    5
                ],
                "id": "1"
            },
            {
                "name": "Staedtisch",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "22"
            },
            {
                "name": "Athletik Kraft",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "2"
            },
            {
                "name": "Tech Gewerbe Allgemein",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "23"
            },
            {
                "name": "Einflussnahme",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "3"
            },
            {
                "name": "Tech Gewerbe Beruflich",
                "levelCosts": [
                    5,
                    12
                ],
                "id": "24"
            },
            {
                "name": "Gezielte Sprueche",
                "levelCosts": [
                    20
                ],
                "id": "4"
            },
            {
                "name": "Tech Gewerbe Professionell",
                "levelCosts": [
                    8
                ],
                "id": "25"
            },
            {
                "name": "Handwerk",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "5"
            },
            {
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "100"
            },
            {
                "name": "Kampfmanoever",
                "levelCosts": [
                    4,
                    10
                ],
                "id": "6"
            },
            {
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    3,
                    8
                ],
                "id": "101"
            },
            {
                "name": "Kommunikation",
                "levelCosts": [
                    3,
                    3,
                    3
                ],
                "id": "7"
            },
            {
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    3,
                    9
                ],
                "id": "102"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    3,
                    9
                ],
                "id": "8"
            },
            {
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    3,
                    9
                ],
                "id": "103"
            },
            {
                "name": "Kunst Aktiv",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "9"
            },
            {
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    3,
                    9
                ],
                "id": "104"
            },
            {
                "name": "Kunst Passiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    6
                ],
                "id": "106"
            },
            {
                "name": "List Angriff",
                "levelCosts": [
                    4,
                    8
                ],
                "id": "10"
            },
            {
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    6
                ],
                "id": "107"
            },
            {
                "name": "List Mechanik",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "11"
            },
            {
                "name": "Waffenloser Kampf Schlag",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "-1"
            },
            {
                "name": "List Tarnung",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "12"
            },
            {
                "name": "Waffenloser Kampf Wurf",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "-1"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    12
                ],
                "id": "13"
            },
            {
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "26"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    7
                ],
                "id": "14"
            },
            {
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    1,
                    5
                ],
                "id": "27"
            },
            {
                "name": "Magiepunkte entwickeln",
                "levelCosts": [
                    12
                ],
                "id": "15"
            },
            {
                "name": "Wahrnehmung Unbewusst",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "-1"
            },
            {
                "name": "Natur Tiere",
                "levelCosts": [
                    1,
                    5
                ],
                "id": "16"
            },
            {
                "name": "Wissen Allgemein",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "28"
            },
            {
                "name": "Natur Umwelt",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "17"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    4
                ],
                "id": "29"
            },
            {
                "name": "Ruestung Leicht",
                "levelCosts": [
                    1,
                    1,
                    1
                ],
                "id": "18"
            },
            {
                "name": "Wissen Obskur",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "30"
            },
            {
                "name": "Ruestung Mittel",
                "levelCosts": [
                    2,
                    2,
                    2
                ],
                "id": "19"
            },
            {
                "name": "Wissen Technisch",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "31"
            },
            {
                "name": "Ruestung Schwer",
                "levelCosts": [
                    3,
                    3,
                    3
                ],
                "id": "20"
            },
            {
                "name": "Wissenschaft / Analytisch Allgemein",
                "levelCosts": [
                    3,
                    6
                ],
                "id": "32"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "21"
            },
            {
                "name": "Wissenschaft / Analytisch Spezialisiert",
                "levelCosts": [
                    12
                ],
                "id": "-1"
            },
            {
                "name": "Spezialangriff",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "-1"
            }
        ],
        "se": [
            {
                "name": "Offene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            5
                        ],
                        "costs": [
                            15
                        ]
                    },
                    {
                        "levels": [
                            6,
                            10
                        ],
                        "costs": [
                            30
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            45
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            60
                        ]
                    },
                    {
                        "levels": [
                            21
                        ],
                        "costs": [
                            75
                        ]
                    }
                ]
            },
            {
                "name": "Geschlossene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            5
                        ],
                        "costs": [
                            25
                        ]
                    },
                    {
                        "levels": [
                            6,
                            10
                        ],
                        "costs": [
                            50
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            75
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            100
                        ]
                    },
                    {
                        "levels": [
                            21
                        ],
                        "costs": [
                            125
                        ]
                    }
                ]
            }
        ],
        "ap": [
            {
                "name": "Abenteurer",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Klatschtante",
                "levelCosts": [
                    18
                ]
            },
            {
                "name": "Akademiker",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Kraeuterkundiger",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Assassine",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Kriegsakademie",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Athlet",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Meister des Wissens",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Bauer",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Mutter",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Berserker",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Philosoph",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Bettler",
                "levelCosts": [
                    16
                ]
            },
            {
                "name": "Pirat",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Bibliothekar",
                "levelCosts": [
                    37
                ]
            },
            {
                "name": "Professor",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Detektiv",
                "levelCosts": [
                    18
                ]
            },
            {
                "name": "Reisender",
                "levelCosts": [
                    10
                ]
            },
            {
                "name": "Diplomat",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Ritter",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Doktor",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Schamane",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Edelmann",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Schreiber",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Eiferer",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Schwindler",
                "levelCosts": [
                    18
                ]
            },
            {
                "name": "Einbrecher",
                "levelCosts": [
                    19
                ]
            },
            {
                "name": "Scout",
                "levelCosts": [
                    19
                ]
            },
            {
                "name": "Entdecker",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Seemann",
                "levelCosts": [
                    19
                ]
            },
            {
                "name": "Fechter",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Sheriff",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Fuehrer",
                "levelCosts": [
                    19
                ]
            },
            {
                "name": "Soldat",
                "levelCosts": [
                    19
                ]
            },
            {
                "name": "Gefolgsmann",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Soeldner",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Gildenmitglied",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Spion",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Gladiator",
                "levelCosts": [
                    40
                ]
            },
            {
                "name": "Stadtwache",
                "levelCosts": [
                    16
                ]
            },
            {
                "name": "Haendler",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Strassenraeuber",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Handwerker",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Taschendieb",
                "levelCosts": [
                    15
                ]
            },
            {
                "name": "Hobby Zauberer",
                "levelCosts": [
                    36
                ]
            },
            {
                "name": "Tierarzt",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Hostesse",
                "levelCosts": [
                    19
                ]
            },
            {
                "name": "Tierfreund",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Jaeger",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Unterhalter",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Kaemmerer",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Waffenmeister",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Kaempe",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Wanderer",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Kampfsportler",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Wirt",
                "levelCosts": [
                    27
                ]
            }
        ]
    },
    {
        "id": 21,
        "name": "Trickser",
        "bb": [
            {
                "name": "Einflussnahme",
                "levelCosts": [
                    5
                ],
                "id": "3"
            },
            {
                "name": "Staedtisch",
                "levelCosts": [
                    5
                ],
                "id": "22"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    5
                ],
                "id": "8"
            },
            {
                "name": "Kategorie Waffen",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Kategorie List",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Kategorie Wahrnehmung",
                "levelCosts": [
                    10
                ],
                "id": "-1"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    5
                ],
                "id": "13"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    5
                ],
                "id": "29"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    5
                ],
                "id": "14"
            },
            {
                "id": "100",
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "101",
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "102",
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "103",
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "104",
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "106",
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "107",
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "10",
                "name": "List Angriff",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "11",
                "name": "List Mechanik",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "12",
                "name": "List Tarnung",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "26",
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "27",
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    10
                ]
            }
        ],
        "ff": [
            {
                "name": "Athletik Ausdauer",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "0"
            },
            {
                "name": "Spezialverteidigung",
                "levelCosts": [
                    40
                ],
                "id": "-1"
            },
            {
                "name": "Athletik Gymnastik",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "1"
            },
            {
                "name": "Staedtisch",
                "levelCosts": [
                    1,
                    5
                ],
                "id": "22"
            },
            {
                "name": "Athletik Kraft",
                "levelCosts": [
                    3,
                    9
                ],
                "id": "2"
            },
            {
                "name": "Tech Gewerbe Allgemein",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "23"
            },
            {
                "name": "Einflussnahme",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "3"
            },
            {
                "name": "Tech Gewerbe Beruflich",
                "levelCosts": [
                    5,
                    12
                ],
                "id": "24"
            },
            {
                "name": "Gezielte Sprueche",
                "levelCosts": [
                    5
                ],
                "id": "4"
            },
            {
                "name": "Tech Gewerbe Professionell",
                "levelCosts": [
                    8
                ],
                "id": "25"
            },
            {
                "name": "Handwerk",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "5"
            },
            {
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    3,
                    9
                ],
                "id": "100"
            },
            {
                "name": "Kampfmanoever",
                "levelCosts": [
                    6,
                    14
                ],
                "id": "6"
            },
            {
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    6
                ],
                "id": "101"
            },
            {
                "name": "Kommunikation",
                "levelCosts": [
                    2,
                    2,
                    2
                ],
                "id": "7"
            },
            {
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    7
                ],
                "id": "102"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    6,
                    14
                ],
                "id": "8"
            },
            {
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    8
                ],
                "id": "103"
            },
            {
                "name": "Kunst Aktiv",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "9"
            },
            {
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    10
                ],
                "id": "104"
            },
            {
                "name": "Kunst Passiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    15
                ],
                "id": "106"
            },
            {
                "name": "List Angriff",
                "levelCosts": [
                    6,
                    12
                ],
                "id": "10"
            },
            {
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    15
                ],
                "id": "107"
            },
            {
                "name": "List Mechanik",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "11"
            },
            {
                "name": "Waffenloser Kampf Schlag",
                "levelCosts": [
                    4
                ],
                "id": "-1"
            },
            {
                "name": "List Tarnung",
                "levelCosts": [
                    1,
                    5
                ],
                "id": "12"
            },
            {
                "name": "Waffenloser Kampf Wurf",
                "levelCosts": [
                    4
                ],
                "id": "-1"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    6,
                    12
                ],
                "id": "13"
            },
            {
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "26"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "14"
            },
            {
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "27"
            },
            {
                "name": "Magiepunkte entwickeln",
                "levelCosts": [
                    8
                ],
                "id": "15"
            },
            {
                "name": "Wahrnehmung Unbewusst",
                "levelCosts": [
                    4,
                    12
                ],
                "id": "-1"
            },
            {
                "name": "Natur Tiere",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "16"
            },
            {
                "name": "Wissen Allgemein",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "28"
            },
            {
                "name": "Natur Umwelt",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "17"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "29"
            },
            {
                "name": "Ruestung Leicht",
                "levelCosts": [
                    5,
                    5,
                    5
                ],
                "id": "18"
            },
            {
                "name": "Wissen Obskur",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "30"
            },
            {
                "name": "Ruestung Mittel",
                "levelCosts": [
                    10
                ],
                "id": "19"
            },
            {
                "name": "Wissen Technisch",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "31"
            },
            {
                "name": "Ruestung Schwer",
                "levelCosts": [
                    11
                ],
                "id": "20"
            },
            {
                "name": "Wissenschaft / Analytisch Allgemein",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "32"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "21"
            },
            {
                "name": "Wissenschaft / Analytisch Spezialisiert",
                "levelCosts": [
                    8
                ],
                "id": "-1"
            },
            {
                "name": "Spezialangriff",
                "levelCosts": [
                    6
                ],
                "id": "-1"
            }
        ],
        "se": [
            {
                "name": "Offene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            10
                        ],
                        "costs": [
                            8,
                            8
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            12
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            18
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            25
                        ]
                    }
                ]
            },
            {
                "name": "Geschlossene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            5
                        ],
                        "costs": [
                            10,
                            10
                        ]
                    },
                    {
                        "levels": [
                            6,
                            10
                        ],
                        "costs": [
                            12
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            25
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            40
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            60
                        ]
                    }
                ]
            },
            {
                "name": "Basislisten alle",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            6,
                            6,
                            6
                        ]
                    }
                ]
            }
        ],
        "ap": [
            {
                "name": "Abenteurer",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Klatschtante",
                "levelCosts": [
                    18
                ]
            },
            {
                "name": "Akademiker",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Kraeuterkundiger",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Assassine",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Kriegsakademie",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Athlet",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Meister des Wissens T",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Bauer",
                "levelCosts": [
                    33
                ]
            },
            {
                "name": "Mutter",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Berserker",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Philosoph",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Bettler",
                "levelCosts": [
                    16
                ]
            },
            {
                "name": "Pirat",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Bibliothekar",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Professor",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Detektiv",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Reisender",
                "levelCosts": [
                    14
                ]
            },
            {
                "name": "Diplomat",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Ritter",
                "levelCosts": [
                    36
                ]
            },
            {
                "name": "Doktor",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Schamane",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Edelmann",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Schreiber",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Eiferer T",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Schwindler T",
                "levelCosts": [
                    19
                ]
            },
            {
                "name": "Einbrecher",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Scout",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Entdecker",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Seemann T",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Fechter",
                "levelCosts": [
                    41
                ]
            },
            {
                "name": "Sheriff",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Fuehrer",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Soldat",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Gefolgsmann",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Soeldner",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Gildenmitglied",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Spion",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Gladiator",
                "levelCosts": [
                    49
                ]
            },
            {
                "name": "Stadtwache T",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Haendler",
                "levelCosts": [
                    21
                ]
            },
            {
                "name": "Strassenraeuber",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Handwerker",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Taschendieb T",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Hobby Zauberer",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Tierarzt",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Hostesse",
                "levelCosts": [
                    19
                ]
            },
            {
                "name": "Tierfreund",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Jaeger",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Unterhalter",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Kaemmerer",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Waffenmeister",
                "levelCosts": [
                    43
                ]
            },
            {
                "name": "Kaempe",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Wanderer",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Kampfsportler",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Wirt",
                "levelCosts": [
                    26
                ]
            }
        ]
    },
    {
        "id": 22,
        "name": "Waldlaeufer",
        "bb": [
            {
                "name": "Kategorie Athletik",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Kategorie Natur",
                "levelCosts": [
                    20
                ],
                "id": "16"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    5
                ],
                "id": "8"
            },
            {
                "name": "Kategorie Waffen",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "List Tarnung",
                "levelCosts": [
                    5
                ],
                "id": "12"
            },
            {
                "name": "Kategorie Wahrnehmung",
                "levelCosts": [
                    10
                ],
                "id": "-1"
            },
            {
                "id": "0",
                "name": "Athletik Ausdauer",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "1",
                "name": "Athletik Gymnastik",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "2",
                "name": "Athletik Kraft",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "16",
                "name": "Natur Tiere",
                "levelCosts": [
                    20
                ]
            },
            {
                "id": "17",
                "name": "Natur Umwelt",
                "levelCosts": [
                    20
                ]
            },
            {
                "id": "100",
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "101",
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "102",
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "103",
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "104",
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "106",
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "107",
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "26",
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "27",
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    10
                ]
            }
        ],
        "ff": [
            {
                "name": "Athletik Ausdauer",
                "levelCosts": [
                    1,
                    5
                ],
                "id": "0"
            },
            {
                "name": "Spezialverteidigung",
                "levelCosts": [
                    40
                ],
                "id": "-1"
            },
            {
                "name": "Athletik Gymnastik",
                "levelCosts": [
                    3,
                    6
                ],
                "id": "1"
            },
            {
                "name": "Staedtisch",
                "levelCosts": [
                    3,
                    6
                ],
                "id": "22"
            },
            {
                "name": "Athletik Kraft",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "2"
            },
            {
                "name": "Tech Gewerbe Allgemein",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "23"
            },
            {
                "name": "Einflussnahme",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "3"
            },
            {
                "name": "Tech Gewerbe Beruflich",
                "levelCosts": [
                    5,
                    12
                ],
                "id": "24"
            },
            {
                "name": "Gezielte Sprueche",
                "levelCosts": [
                    15
                ],
                "id": "4"
            },
            {
                "name": "Tech Gewerbe Professionell",
                "levelCosts": [
                    8
                ],
                "id": "25"
            },
            {
                "name": "Handwerk",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "5"
            },
            {
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "100"
            },
            {
                "name": "Kampfmanoever",
                "levelCosts": [
                    5,
                    12
                ],
                "id": "6"
            },
            {
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    4
                ],
                "id": "101"
            },
            {
                "name": "Kommunikation",
                "levelCosts": [
                    3,
                    3,
                    3
                ],
                "id": "7"
            },
            {
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    6
                ],
                "id": "102"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    4,
                    12
                ],
                "id": "8"
            },
            {
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    6
                ],
                "id": "103"
            },
            {
                "name": "Kunst Aktiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "9"
            },
            {
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    6
                ],
                "id": "104"
            },
            {
                "name": "Kunst Passiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    9
                ],
                "id": "106"
            },
            {
                "name": "List Angriff",
                "levelCosts": [
                    6
                ],
                "id": "10"
            },
            {
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    9
                ],
                "id": "107"
            },
            {
                "name": "List Mechanik",
                "levelCosts": [
                    4
                ],
                "id": "11"
            },
            {
                "name": "Waffenloser Kampf Schlag",
                "levelCosts": [
                    4
                ],
                "id": "-1"
            },
            {
                "name": "List Tarnung",
                "levelCosts": [
                    1,
                    5
                ],
                "id": "12"
            },
            {
                "name": "Waffenloser Kampf Wurf",
                "levelCosts": [
                    4
                ],
                "id": "-1"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    6,
                    12
                ],
                "id": "13"
            },
            {
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "26"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    5
                ],
                "id": "14"
            },
            {
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    1,
                    4
                ],
                "id": "27"
            },
            {
                "name": "Magiepunkte entwickeln",
                "levelCosts": [
                    8
                ],
                "id": "15"
            },
            {
                "name": "Wahrnehmung Unbewusst",
                "levelCosts": [
                    3,
                    12
                ],
                "id": "-1"
            },
            {
                "name": "Natur Tiere",
                "levelCosts": [
                    1,
                    5
                ],
                "id": "16"
            },
            {
                "name": "Wissen Allgemein",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "28"
            },
            {
                "name": "Natur Umwelt",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "17"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    3,
                    6
                ],
                "id": "29"
            },
            {
                "name": "Ruestung Leicht",
                "levelCosts": [
                    2,
                    2,
                    2
                ],
                "id": "18"
            },
            {
                "name": "Wissen Obskur",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "30"
            },
            {
                "name": "Ruestung Mittel",
                "levelCosts": [
                    4,
                    4,
                    4
                ],
                "id": "19"
            },
            {
                "name": "Wissen Technisch",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "31"
            },
            {
                "name": "Ruestung Schwer",
                "levelCosts": [
                    5,
                    5,
                    5
                ],
                "id": "20"
            },
            {
                "name": "Wissenschaft / Analytisch Allgemein",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "32"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "21"
            },
            {
                "name": "Wissenschaft / Analytisch Spezialisiert",
                "levelCosts": [
                    8
                ],
                "id": "-1"
            },
            {
                "name": "Spezialangriff",
                "levelCosts": [
                    3,
                    9
                ],
                "id": "-1"
            }
        ],
        "se": [
            {
                "name": "Offene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            10
                        ],
                        "costs": [
                            8,
                            8
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            12
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            18
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            25
                        ]
                    }
                ]
            },
            {
                "name": "Geschlossene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            5
                        ],
                        "costs": [
                            10,
                            10
                        ]
                    },
                    {
                        "levels": [
                            6,
                            10
                        ],
                        "costs": [
                            12
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            25
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            40
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            60
                        ]
                    }
                ]
            },
            {
                "name": "Basislisten alle",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            6,
                            6,
                            6
                        ]
                    }
                ]
            }
        ],
        "ap": [
            {
                "name": "Abenteurer",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Klatschtante",
                "levelCosts": [
                    18
                ]
            },
            {
                "name": "Akademiker",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Kraeuterkundiger T",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Assassine",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Kriegsakademie",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Athlet",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Meister des Wissens",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Bauer",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Mutter",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Berserker",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Philosoph",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Bettler",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Pirat",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Bibliothekar",
                "levelCosts": [
                    34
                ]
            },
            {
                "name": "Professor",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Detektiv",
                "levelCosts": [
                    21
                ]
            },
            {
                "name": "Reisender",
                "levelCosts": [
                    10
                ]
            },
            {
                "name": "Diplomat",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Ritter",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Doktor",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Schamane",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Edelmann",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Schreiber",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Eiferer",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Schwindler",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Einbrecher",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Scout T",
                "levelCosts": [
                    16
                ]
            },
            {
                "name": "Entdecker T",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Seemann T",
                "levelCosts": [
                    18
                ]
            },
            {
                "name": "Fechter",
                "levelCosts": [
                    37
                ]
            },
            {
                "name": "Sheriff T",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Fuehrer T",
                "levelCosts": [
                    18
                ]
            },
            {
                "name": "Soldat",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Gefolgsmann",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Soeldner",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Gildenmitglied",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Spion",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Gladiator",
                "levelCosts": [
                    47
                ]
            },
            {
                "name": "Stadtwache",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Haendler",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Strassenraeuber",
                "levelCosts": [
                    18
                ]
            },
            {
                "name": "Handwerker",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Taschendieb",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Hobby Zauberer",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Tierarzt T",
                "levelCosts": [
                    21
                ]
            },
            {
                "name": "Hostesse",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Tierfreund T",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Jaeger T",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Unterhalter",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Kaemmerer",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Waffenmeister",
                "levelCosts": [
                    39
                ]
            },
            {
                "name": "Kaempe",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Wanderer",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Kampfsportler",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Wirt",
                "levelCosts": [
                    28
                ]
            }
        ]
    },
    {
        "id": 23,
        "name": "Wundheiler",
        "bb": [
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    10
                ],
                "id": "8"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    5
                ],
                "id": "21"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    5
                ],
                "id": "13"
            },
            {
                "name": "Kategorie Wahrnehmung",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    5
                ],
                "id": "14"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    5
                ],
                "id": "29"
            },
            {
                "name": "Magiepunkte entwickeln",
                "levelCosts": [
                    5
                ],
                "id": "15"
            },
            {
                "name": "Kategorie Zauber",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "id": "26",
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "27",
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    5
                ]
            }
        ],
        "ff": [
            {
                "name": "Athletik Ausdauer",
                "levelCosts": [
                    3
                ],
                "id": "0"
            },
            {
                "name": "Spezialverteidigung",
                "levelCosts": [
                    25
                ],
                "id": "-1"
            },
            {
                "name": "Athletik Gymnastik",
                "levelCosts": [
                    3,
                    9
                ],
                "id": "1"
            },
            {
                "name": "Staedtisch",
                "levelCosts": [
                    3
                ],
                "id": "22"
            },
            {
                "name": "Athletik Kraft",
                "levelCosts": [
                    6
                ],
                "id": "2"
            },
            {
                "name": "Tech Gewerbe Allgemein",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "23"
            },
            {
                "name": "Einflussnahme",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "3"
            },
            {
                "name": "Tech Gewerbe Beruflich",
                "levelCosts": [
                    5,
                    12
                ],
                "id": "24"
            },
            {
                "name": "Gezielte Sprueche",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "4"
            },
            {
                "name": "Tech Gewerbe Professionell",
                "levelCosts": [
                    8
                ],
                "id": "25"
            },
            {
                "name": "Handwerk",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "5"
            },
            {
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    6
                ],
                "id": "100"
            },
            {
                "name": "Kampfmanoever",
                "levelCosts": [
                    14
                ],
                "id": "6"
            },
            {
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    8
                ],
                "id": "101"
            },
            {
                "name": "Kommunikation",
                "levelCosts": [
                    2,
                    2,
                    2
                ],
                "id": "7"
            },
            {
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    15
                ],
                "id": "102"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    12
                ],
                "id": "8"
            },
            {
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    20
                ],
                "id": "103"
            },
            {
                "name": "Kunst Aktiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "9"
            },
            {
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    20
                ],
                "id": "104"
            },
            {
                "name": "Kunst Passiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    20
                ],
                "id": "106"
            },
            {
                "name": "List Angriff",
                "levelCosts": [
                    15
                ],
                "id": "10"
            },
            {
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    20
                ],
                "id": "107"
            },
            {
                "name": "List Mechanik",
                "levelCosts": [
                    8
                ],
                "id": "11"
            },
            {
                "name": "Waffenloser Kampf Schlag",
                "levelCosts": [
                    3
                ],
                "id": "-1"
            },
            {
                "name": "List Tarnung",
                "levelCosts": [
                    6
                ],
                "id": "12"
            },
            {
                "name": "Waffenloser Kampf Wurf",
                "levelCosts": [
                    3
                ],
                "id": "-1"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    4,
                    10
                ],
                "id": "13"
            },
            {
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "26"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "14"
            },
            {
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    3
                ],
                "id": "27"
            },
            {
                "name": "Magiepunkte entwickeln",
                "levelCosts": [
                    4
                ],
                "id": "15"
            },
            {
                "name": "Wahrnehmung Unbewusst",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Natur Tiere",
                "levelCosts": [
                    3
                ],
                "id": "16"
            },
            {
                "name": "Wissen Allgemein",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "28"
            },
            {
                "name": "Natur Umwelt",
                "levelCosts": [
                    3
                ],
                "id": "17"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "29"
            },
            {
                "name": "Ruestung Leicht",
                "levelCosts": [
                    2,
                    2,
                    2
                ],
                "id": "18"
            },
            {
                "name": "Wissen Obskur",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "30"
            },
            {
                "name": "Ruestung Mittel",
                "levelCosts": [
                    4,
                    4,
                    4
                ],
                "id": "19"
            },
            {
                "name": "Wissen Technisch",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "31"
            },
            {
                "name": "Ruestung Schwer",
                "levelCosts": [
                    5,
                    5,
                    5
                ],
                "id": "20"
            },
            {
                "name": "Wissenschaft / Analytisch Allgemein",
                "levelCosts": [
                    1,
                    4
                ],
                "id": "32"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    3
                ],
                "id": "21"
            },
            {
                "name": "Wissenschaft / Analytisch Spezialisiert",
                "levelCosts": [
                    6,
                    14
                ],
                "id": "-1"
            },
            {
                "name": "Spezialangriff",
                "levelCosts": [
                    12
                ],
                "id": "-1"
            }
        ],
        "se": [
            {
                "name": "Offene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            10
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            6,
                            6,
                            6
                        ]
                    }
                ]
            },
            {
                "name": "Geschlossene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            5
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            6,
                            10
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            8,
                            8
                        ]
                    }
                ]
            },
            {
                "name": "Basislisten alle",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            3,
                            3,
                            3
                        ]
                    }
                ]
            }
        ],
        "ap": [
            {
                "name": "Abenteurer",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Klatschtante",
                "levelCosts": [
                    18
                ]
            },
            {
                "name": "Akademiker",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Kraeuterkundiger T",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Assassine",
                "levelCosts": [
                    38
                ]
            },
            {
                "name": "Kriegsakademie",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Athlet",
                "levelCosts": [
                    40
                ]
            },
            {
                "name": "Meister des Wissens T",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Bauer",
                "levelCosts": [
                    42
                ]
            },
            {
                "name": "Mutter",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Berserker",
                "levelCosts": [
                    34
                ]
            },
            {
                "name": "Philosoph",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Bettler",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Pirat",
                "levelCosts": [
                    35
                ]
            },
            {
                "name": "Bibliothekar",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Professor T",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Detektiv",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Reisender",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Diplomat",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Ritter",
                "levelCosts": [
                    38
                ]
            },
            {
                "name": "Doktor T",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Schamane",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Edelmann",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Schreiber",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Eiferer T",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Schwindler",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Einbrecher",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Scout",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Entdecker",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Seemann",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Fechter",
                "levelCosts": [
                    57
                ]
            },
            {
                "name": "Sheriff",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Fuehrer",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Soldat",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Gefolgsmann",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Soeldner",
                "levelCosts": [
                    38
                ]
            },
            {
                "name": "Gildenmitglied",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Spion",
                "levelCosts": [
                    35
                ]
            },
            {
                "name": "Gladiator",
                "levelCosts": [
                    56
                ]
            },
            {
                "name": "Stadtwache",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Haendler T",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Strassenraeuber",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Handwerker",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Taschendieb",
                "levelCosts": [
                    33
                ]
            },
            {
                "name": "Hobby Zauberer",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Tierarzt T",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Hostesse",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Tierfreund",
                "levelCosts": [
                    33
                ]
            },
            {
                "name": "Jaeger",
                "levelCosts": [
                    35
                ]
            },
            {
                "name": "Unterhalter",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Kaemmerer",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Waffenmeister",
                "levelCosts": [
                    61
                ]
            },
            {
                "name": "Kaempe",
                "levelCosts": [
                    38
                ]
            },
            {
                "name": "Wanderer",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Kampfsportler",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Wirt",
                "levelCosts": [
                    28
                ]
            }
        ]
    },
    {
        "id": 24,
        "name": "Beschwoerer",
        "bb": [
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    10
                ],
                "id": "13"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    10
                ],
                "id": "29"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    10
                ],
                "id": "14"
            },
            {
                "name": "Wissen Obskur",
                "levelCosts": [
                    10
                ],
                "id": "30"
            },
            {
                "name": "Magiepunkte entwickeln",
                "levelCosts": [
                    5
                ],
                "id": "15"
            },
            {
                "name": "Kategorie Zauber",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            }
        ],
        "ff": [
            {
                "name": "Athletik Ausdauer",
                "levelCosts": [
                    3
                ],
                "id": "0"
            },
            {
                "name": "Spezialverteidigung",
                "levelCosts": [
                    40
                ],
                "id": "-1"
            },
            {
                "name": "Athletik Gymnastik",
                "levelCosts": [
                    3
                ],
                "id": "1"
            },
            {
                "name": "Staedtisch",
                "levelCosts": [
                    3
                ],
                "id": "22"
            },
            {
                "name": "Athletik Kraft",
                "levelCosts": [
                    7
                ],
                "id": "2"
            },
            {
                "name": "Tech Gewerbe Allgemein",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "23"
            },
            {
                "name": "Einflussnahme",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "3"
            },
            {
                "name": "Tech Gewerbe Beruflich",
                "levelCosts": [
                    5,
                    12
                ],
                "id": "24"
            },
            {
                "name": "Gezielte Sprueche",
                "levelCosts": [
                    3
                ],
                "id": "4"
            },
            {
                "name": "Tech Gewerbe Professionell",
                "levelCosts": [
                    8
                ],
                "id": "25"
            },
            {
                "name": "Handwerk",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "5"
            },
            {
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    9
                ],
                "id": "100"
            },
            {
                "name": "Kampfmanoever",
                "levelCosts": [
                    18
                ],
                "id": "6"
            },
            {
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    20
                ],
                "id": "101"
            },
            {
                "name": "Kommunikation",
                "levelCosts": [
                    2,
                    2,
                    2
                ],
                "id": "7"
            },
            {
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    20
                ],
                "id": "102"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    15
                ],
                "id": "8"
            },
            {
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    20
                ],
                "id": "103"
            },
            {
                "name": "Kunst Aktiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "9"
            },
            {
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    20
                ],
                "id": "104"
            },
            {
                "name": "Kunst Passiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    20
                ],
                "id": "106"
            },
            {
                "name": "List Angriff",
                "levelCosts": [
                    15
                ],
                "id": "10"
            },
            {
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    20
                ],
                "id": "107"
            },
            {
                "name": "List Mechanik",
                "levelCosts": [
                    7
                ],
                "id": "11"
            },
            {
                "name": "Waffenloser Kampf Schlag",
                "levelCosts": [
                    9
                ],
                "id": "-1"
            },
            {
                "name": "List Tarnung",
                "levelCosts": [
                    6
                ],
                "id": "12"
            },
            {
                "name": "Waffenloser Kampf Wurf",
                "levelCosts": [
                    9
                ],
                "id": "-1"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    4,
                    10
                ],
                "id": "13"
            },
            {
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "26"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "14"
            },
            {
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    3
                ],
                "id": "27"
            },
            {
                "name": "Magiepunkte entwickeln",
                "levelCosts": [
                    6
                ],
                "id": "15"
            },
            {
                "name": "Wahrnehmung Unbewusst",
                "levelCosts": [
                    6
                ],
                "id": "-1"
            },
            {
                "name": "Natur Tiere",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "16"
            },
            {
                "name": "Wissen Allgemein",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "28"
            },
            {
                "name": "Natur Umwelt",
                "levelCosts": [
                    3
                ],
                "id": "17"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "29"
            },
            {
                "name": "Ruestung Leicht",
                "levelCosts": [
                    9
                ],
                "id": "18"
            },
            {
                "name": "Wissen Obskur",
                "levelCosts": [
                    3,
                    5
                ],
                "id": "30"
            },
            {
                "name": "Ruestung Mittel",
                "levelCosts": [
                    10
                ],
                "id": "19"
            },
            {
                "name": "Wissen Technisch",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "31"
            },
            {
                "name": "Ruestung Schwer",
                "levelCosts": [
                    11
                ],
                "id": "20"
            },
            {
                "name": "Wissenschaft / Analytisch Allgemein",
                "levelCosts": [
                    1,
                    4
                ],
                "id": "32"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    6
                ],
                "id": "21"
            },
            {
                "name": "Wissenschaft / Analytisch Spezialisiert",
                "levelCosts": [
                    6,
                    14
                ],
                "id": "-1"
            },
            {
                "name": "Spezialangriff",
                "levelCosts": [
                    15
                ],
                "id": "-1"
            }
        ],
        "se": [
            {
                "name": "Offene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            10
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            6,
                            6,
                            6
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            8,
                            8
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            12
                        ]
                    }
                ]
            },
            {
                "name": "Geschlossene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            5
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            6,
                            10
                        ],
                        "costs": [
                            6,
                            6,
                            6
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            8,
                            8
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            10,
                            10
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            25
                        ]
                    }
                ]
            },
            {
                "name": "Basislisten eigene",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            3,
                            3,
                            3
                        ]
                    }
                ]
            }
        ],
        "ap": [
            {
                "name": "Abenteurer",
                "levelCosts": [
                    46
                ]
            },
            {
                "name": "Klatschtante",
                "levelCosts": [
                    16
                ]
            },
            {
                "name": "Akademiker",
                "levelCosts": [
                    36
                ]
            },
            {
                "name": "Kraeuterkundiger",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Assassine",
                "levelCosts": [
                    51
                ]
            },
            {
                "name": "Kriegsakademie",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Athlet",
                "levelCosts": [
                    38
                ]
            },
            {
                "name": "Meister des Wissens",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Bauer",
                "levelCosts": [
                    39
                ]
            },
            {
                "name": "Mutter",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Berserker",
                "levelCosts": [
                    59
                ]
            },
            {
                "name": "Philosoph",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Bettler",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Pirat",
                "levelCosts": [
                    37
                ]
            },
            {
                "name": "Bibliothekar",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Professor",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Detektiv",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Reisender",
                "levelCosts": [
                    19
                ]
            },
            {
                "name": "Diplomat",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Ritter",
                "levelCosts": [
                    56
                ]
            },
            {
                "name": "Doktor",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Schamane",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Edelmann",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Schreiber",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Eiferer",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Schwindler",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Einbrecher",
                "levelCosts": [
                    35
                ]
            },
            {
                "name": "Scout",
                "levelCosts": [
                    36
                ]
            },
            {
                "name": "Entdecker",
                "levelCosts": [
                    37
                ]
            },
            {
                "name": "Seemann",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Fechter",
                "levelCosts": [
                    60
                ]
            },
            {
                "name": "Sheriff",
                "levelCosts": [
                    55
                ]
            },
            {
                "name": "Fuehrer",
                "levelCosts": [
                    21
                ]
            },
            {
                "name": "Soldat",
                "levelCosts": [
                    50
                ]
            },
            {
                "name": "Gefolgsmann",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Soeldner",
                "levelCosts": [
                    56
                ]
            },
            {
                "name": "Gildenmitglied",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Spion",
                "levelCosts": [
                    43
                ]
            },
            {
                "name": "Gladiator",
                "levelCosts": [
                    64
                ]
            },
            {
                "name": "Stadtwache",
                "levelCosts": [
                    39
                ]
            },
            {
                "name": "Haendler",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Strassenraeuber",
                "levelCosts": [
                    36
                ]
            },
            {
                "name": "Handwerker",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Taschendieb",
                "levelCosts": [
                    42
                ]
            },
            {
                "name": "Hobby Zauberer",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Tierarzt",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Hostesse",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Tierfreund",
                "levelCosts": [
                    39
                ]
            },
            {
                "name": "Jaeger",
                "levelCosts": [
                    48
                ]
            },
            {
                "name": "Unterhalter",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Kaemmerer",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Waffenmeister",
                "levelCosts": [
                    73
                ]
            },
            {
                "name": "Kaempe",
                "levelCosts": [
                    43
                ]
            },
            {
                "name": "Wanderer",
                "levelCosts": [
                    33
                ]
            },
            {
                "name": "Kampfsportler",
                "levelCosts": [
                    54
                ]
            },
            {
                "name": "Wirt",
                "levelCosts": [
                    29
                ]
            }
        ]
    },
    {
        "id": 25,
        "name": "Dervish",
        "bb": [
            {
                "name": "Kategorie Athletik",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    10
                ],
                "id": "21"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    5
                ],
                "id": "8"
            },
            {
                "name": "Kategorie Waffenl Kampf",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Kunst Aktiv",
                "levelCosts": [
                    10
                ],
                "id": "9"
            },
            {
                "name": "Kategorie Wahrnehmung",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    5
                ],
                "id": "14"
            },
            {
                "id": "0",
                "name": "Athletik Ausdauer",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "1",
                "name": "Athletik Gymnastik",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "2",
                "name": "Athletik Kraft",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "26",
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "27",
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    5
                ]
            }
        ],
        "ff": [
            {
                "name": "Athletik Ausdauer",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "0"
            },
            {
                "name": "Spezialverteidigung",
                "levelCosts": [
                    6
                ],
                "id": "-1"
            },
            {
                "name": "Athletik Gymnastik",
                "levelCosts": [
                    1,
                    5
                ],
                "id": "1"
            },
            {
                "name": "Staedtisch",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "22"
            },
            {
                "name": "Athletik Kraft",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "2"
            },
            {
                "name": "Tech Gewerbe Allgemein",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "23"
            },
            {
                "name": "Einflussnahme",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "3"
            },
            {
                "name": "Tech Gewerbe Beruflich",
                "levelCosts": [
                    5,
                    12
                ],
                "id": "24"
            },
            {
                "name": "Gezielte Sprueche",
                "levelCosts": [
                    15
                ],
                "id": "4"
            },
            {
                "name": "Tech Gewerbe Professionell",
                "levelCosts": [
                    8
                ],
                "id": "25"
            },
            {
                "name": "Handwerk",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "5"
            },
            {
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    3,
                    9
                ],
                "id": "100"
            },
            {
                "name": "Kampfmanoever",
                "levelCosts": [
                    6,
                    14
                ],
                "id": "6"
            },
            {
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    6
                ],
                "id": "101"
            },
            {
                "name": "Kommunikation",
                "levelCosts": [
                    3,
                    3,
                    3
                ],
                "id": "7"
            },
            {
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    8
                ],
                "id": "102"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    6,
                    14
                ],
                "id": "8"
            },
            {
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    8
                ],
                "id": "103"
            },
            {
                "name": "Kunst Aktiv",
                "levelCosts": [
                    1,
                    2
                ],
                "id": "9"
            },
            {
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    15
                ],
                "id": "104"
            },
            {
                "name": "Kunst Passiv",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "-1"
            },
            {
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    15
                ],
                "id": "106"
            },
            {
                "name": "List Angriff",
                "levelCosts": [
                    8
                ],
                "id": "10"
            },
            {
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    15
                ],
                "id": "107"
            },
            {
                "name": "List Mechanik",
                "levelCosts": [
                    4
                ],
                "id": "11"
            },
            {
                "name": "Waffenloser Kampf Schlag",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "-1"
            },
            {
                "name": "List Tarnung",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "12"
            },
            {
                "name": "Waffenloser Kampf Wurf",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "-1"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    6,
                    12
                ],
                "id": "13"
            },
            {
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "26"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "14"
            },
            {
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "27"
            },
            {
                "name": "Magiepunkte entwickeln",
                "levelCosts": [
                    8
                ],
                "id": "15"
            },
            {
                "name": "Wahrnehmung Unbewusst",
                "levelCosts": [
                    4,
                    12
                ],
                "id": "-1"
            },
            {
                "name": "Natur Tiere",
                "levelCosts": [
                    2,
                    7
                ],
                "id": "16"
            },
            {
                "name": "Wissen Allgemein",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "28"
            },
            {
                "name": "Natur Umwelt",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "17"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    3,
                    6
                ],
                "id": "29"
            },
            {
                "name": "Ruestung Leicht",
                "levelCosts": [
                    5,
                    5,
                    5
                ],
                "id": "18"
            },
            {
                "name": "Wissen Obskur",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "30"
            },
            {
                "name": "Ruestung Mittel",
                "levelCosts": [
                    10
                ],
                "id": "19"
            },
            {
                "name": "Wissen Technisch",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "31"
            },
            {
                "name": "Ruestung Schwer",
                "levelCosts": [
                    11
                ],
                "id": "20"
            },
            {
                "name": "Wissenschaft / Analytisch Allgemein",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "32"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "21"
            },
            {
                "name": "Wissenschaft / Analytisch Spezialisiert",
                "levelCosts": [
                    8
                ],
                "id": "-1"
            },
            {
                "name": "Spezialangriff",
                "levelCosts": [
                    6
                ],
                "id": "-1"
            }
        ],
        "se": [
            {
                "name": "Offene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            10
                        ],
                        "costs": [
                            8,
                            8
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            12
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            18
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            25
                        ]
                    }
                ]
            },
            {
                "name": "Geschlossene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            5
                        ],
                        "costs": [
                            10,
                            10
                        ]
                    },
                    {
                        "levels": [
                            6,
                            10
                        ],
                        "costs": [
                            12
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            25
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            40
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            60
                        ]
                    }
                ]
            },
            {
                "name": "Basislisten alle",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            6,
                            6,
                            6
                        ]
                    }
                ]
            }
        ],
        "ap": [
            {
                "name": "Abenteurer",
                "levelCosts": [
                    35
                ]
            },
            {
                "name": "Klatschtante",
                "levelCosts": [
                    14
                ]
            },
            {
                "name": "Akademiker",
                "levelCosts": [
                    34
                ]
            },
            {
                "name": "Kraeuterkundiger",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Assassine",
                "levelCosts": [
                    34
                ]
            },
            {
                "name": "Kriegsakademie",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Athlet",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Meister des Wissens",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Bauer",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Mutter",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Berserker",
                "levelCosts": [
                    42
                ]
            },
            {
                "name": "Philosoph",
                "levelCosts": [
                    37
                ]
            },
            {
                "name": "Bettler",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Pirat",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Bibliothekar",
                "levelCosts": [
                    34
                ]
            },
            {
                "name": "Professor",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Detektiv",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Reisender",
                "levelCosts": [
                    13
                ]
            },
            {
                "name": "Diplomat",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Ritter",
                "levelCosts": [
                    49
                ]
            },
            {
                "name": "Doktor",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Schamane",
                "levelCosts": [
                    33
                ]
            },
            {
                "name": "Edelmann",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Schreiber",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Eiferer",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Schwindler",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Einbrecher",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Scout",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Entdecker",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Seemann",
                "levelCosts": [
                    19
                ]
            },
            {
                "name": "Fechter",
                "levelCosts": [
                    47
                ]
            },
            {
                "name": "Sheriff",
                "levelCosts": [
                    47
                ]
            },
            {
                "name": "Fuehrer",
                "levelCosts": [
                    19
                ]
            },
            {
                "name": "Soldat",
                "levelCosts": [
                    33
                ]
            },
            {
                "name": "Gefolgsmann",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Soeldner",
                "levelCosts": [
                    46
                ]
            },
            {
                "name": "Gildenmitglied",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Spion",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Gladiator",
                "levelCosts": [
                    50
                ]
            },
            {
                "name": "Stadtwache",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Haendler",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Strassenraeuber",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Handwerker",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Taschendieb",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Hobby Zauberer",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Tierarzt",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Hostesse",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Tierfreund",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Jaeger",
                "levelCosts": [
                    35
                ]
            },
            {
                "name": "Unterhalter",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Kaemmerer",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Waffenmeister",
                "levelCosts": [
                    57
                ]
            },
            {
                "name": "Kaempe",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Wanderer",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Kampfsportler",
                "levelCosts": [
                    35
                ]
            },
            {
                "name": "Wirt",
                "levelCosts": [
                    28
                ]
            }
        ]
    },
    {
        "id": 26,
        "name": "Hexer",
        "bb": [
            {
                "name": "Einflussnahme",
                "levelCosts": [
                    5
                ],
                "id": "3"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    5
                ],
                "id": "21"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    10
                ],
                "id": "13"
            },
            {
                "name": "Kategorie Wahrnehmung",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    10
                ],
                "id": "14"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    5
                ],
                "id": "29"
            },
            {
                "name": "Magiepunkte entwickeln",
                "levelCosts": [
                    5
                ],
                "id": "15"
            },
            {
                "name": "Kategorie Zauber",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "id": "26",
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "27",
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    5
                ]
            }
        ],
        "ff": [
            {
                "name": "Athletik Ausdauer",
                "levelCosts": [
                    3
                ],
                "id": "0"
            },
            {
                "name": "Spezialverteidigung",
                "levelCosts": [
                    35
                ],
                "id": "-1"
            },
            {
                "name": "Athletik Gymnastik",
                "levelCosts": [
                    3
                ],
                "id": "1"
            },
            {
                "name": "Staedtisch",
                "levelCosts": [
                    3
                ],
                "id": "22"
            },
            {
                "name": "Athletik Kraft",
                "levelCosts": [
                    7
                ],
                "id": "2"
            },
            {
                "name": "Tech Gewerbe Allgemein",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "23"
            },
            {
                "name": "Einflussnahme",
                "levelCosts": [
                    1,
                    4
                ],
                "id": "3"
            },
            {
                "name": "Tech Gewerbe Beruflich",
                "levelCosts": [
                    5,
                    12
                ],
                "id": "24"
            },
            {
                "name": "Gezielte Sprueche",
                "levelCosts": [
                    3
                ],
                "id": "4"
            },
            {
                "name": "Tech Gewerbe Professionell",
                "levelCosts": [
                    8
                ],
                "id": "25"
            },
            {
                "name": "Handwerk",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "5"
            },
            {
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    9
                ],
                "id": "100"
            },
            {
                "name": "Kampfmanoever",
                "levelCosts": [
                    18
                ],
                "id": "6"
            },
            {
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    20
                ],
                "id": "101"
            },
            {
                "name": "Kommunikation",
                "levelCosts": [
                    2,
                    2,
                    2
                ],
                "id": "7"
            },
            {
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    20
                ],
                "id": "102"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    15
                ],
                "id": "8"
            },
            {
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    20
                ],
                "id": "103"
            },
            {
                "name": "Kunst Aktiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "9"
            },
            {
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    20
                ],
                "id": "104"
            },
            {
                "name": "Kunst Passiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    20
                ],
                "id": "106"
            },
            {
                "name": "List Angriff",
                "levelCosts": [
                    15
                ],
                "id": "10"
            },
            {
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    20
                ],
                "id": "107"
            },
            {
                "name": "List Mechanik",
                "levelCosts": [
                    7
                ],
                "id": "11"
            },
            {
                "name": "Waffenloser Kampf Schlag",
                "levelCosts": [
                    6
                ],
                "id": "-1"
            },
            {
                "name": "List Tarnung",
                "levelCosts": [
                    5
                ],
                "id": "12"
            },
            {
                "name": "Waffenloser Kampf Wurf",
                "levelCosts": [
                    6
                ],
                "id": "-1"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    4,
                    10
                ],
                "id": "13"
            },
            {
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "26"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "14"
            },
            {
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    3
                ],
                "id": "27"
            },
            {
                "name": "Magiepunkte entwickeln",
                "levelCosts": [
                    6
                ],
                "id": "15"
            },
            {
                "name": "Wahrnehmung Unbewusst",
                "levelCosts": [
                    4
                ],
                "id": "-1"
            },
            {
                "name": "Natur Tiere",
                "levelCosts": [
                    3
                ],
                "id": "16"
            },
            {
                "name": "Wissen Allgemein",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "28"
            },
            {
                "name": "Natur Umwelt",
                "levelCosts": [
                    3
                ],
                "id": "17"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "29"
            },
            {
                "name": "Ruestung Leicht",
                "levelCosts": [
                    4,
                    4,
                    4
                ],
                "id": "18"
            },
            {
                "name": "Wissen Obskur",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "30"
            },
            {
                "name": "Ruestung Mittel",
                "levelCosts": [
                    6,
                    6,
                    6
                ],
                "id": "19"
            },
            {
                "name": "Wissen Technisch",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "31"
            },
            {
                "name": "Ruestung Schwer",
                "levelCosts": [
                    7,
                    7,
                    7
                ],
                "id": "20"
            },
            {
                "name": "Wissenschaft / Analytisch Allgemein",
                "levelCosts": [
                    1,
                    4
                ],
                "id": "32"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    5
                ],
                "id": "21"
            },
            {
                "name": "Wissenschaft / Analytisch Spezialisiert",
                "levelCosts": [
                    6,
                    14
                ],
                "id": "-1"
            },
            {
                "name": "Spezialangriff",
                "levelCosts": [
                    14
                ],
                "id": "-1"
            }
        ],
        "se": [
            {
                "name": "Offene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            10
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            6,
                            6,
                            6
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            8,
                            8
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            12
                        ]
                    }
                ]
            },
            {
                "name": "Geschlossene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            5
                        ],
                        "costs": [
                            4,
                            4,
                            4
                        ]
                    },
                    {
                        "levels": [
                            6,
                            10
                        ],
                        "costs": [
                            6,
                            6,
                            6
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            8,
                            8
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            10,
                            10
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            25
                        ]
                    }
                ]
            },
            {
                "name": "Basislisten eigene",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            3,
                            3,
                            3
                        ]
                    }
                ]
            }
        ],
        "ap": [
            {
                "name": "Abenteurer",
                "levelCosts": [
                    45
                ]
            },
            {
                "name": "Klatschtante",
                "levelCosts": [
                    14
                ]
            },
            {
                "name": "Akademiker",
                "levelCosts": [
                    34
                ]
            },
            {
                "name": "Kraeuterkundiger",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Assassine",
                "levelCosts": [
                    50
                ]
            },
            {
                "name": "Kriegsakademie",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Athlet",
                "levelCosts": [
                    37
                ]
            },
            {
                "name": "Meister des Wissens",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Bauer",
                "levelCosts": [
                    41
                ]
            },
            {
                "name": "Mutter",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Berserker",
                "levelCosts": [
                    59
                ]
            },
            {
                "name": "Philosoph",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Bettler",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Pirat",
                "levelCosts": [
                    37
                ]
            },
            {
                "name": "Bibliothekar",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Professor",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Detektiv",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Reisender",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Diplomat",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Ritter",
                "levelCosts": [
                    55
                ]
            },
            {
                "name": "Doktor",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Schamane",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Edelmann",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Schreiber",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Eiferer",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Schwindler",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Einbrecher",
                "levelCosts": [
                    34
                ]
            },
            {
                "name": "Scout",
                "levelCosts": [
                    37
                ]
            },
            {
                "name": "Entdecker",
                "levelCosts": [
                    37
                ]
            },
            {
                "name": "Seemann",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Fechter",
                "levelCosts": [
                    61
                ]
            },
            {
                "name": "Sheriff",
                "levelCosts": [
                    53
                ]
            },
            {
                "name": "Fuehrer",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Soldat",
                "levelCosts": [
                    46
                ]
            },
            {
                "name": "Gefolgsmann",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Soeldner",
                "levelCosts": [
                    55
                ]
            },
            {
                "name": "Gildenmitglied",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Spion",
                "levelCosts": [
                    41
                ]
            },
            {
                "name": "Gladiator",
                "levelCosts": [
                    63
                ]
            },
            {
                "name": "Stadtwache",
                "levelCosts": [
                    39
                ]
            },
            {
                "name": "Haendler",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Strassenraeuber",
                "levelCosts": [
                    35
                ]
            },
            {
                "name": "Handwerker",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Taschendieb",
                "levelCosts": [
                    41
                ]
            },
            {
                "name": "Hobby Zauberer",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Tierarzt",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Hostesse",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Tierfreund",
                "levelCosts": [
                    41
                ]
            },
            {
                "name": "Jaeger",
                "levelCosts": [
                    48
                ]
            },
            {
                "name": "Unterhalter",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Kaemmerer",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Waffenmeister",
                "levelCosts": [
                    73
                ]
            },
            {
                "name": "Kaempe",
                "levelCosts": [
                    41
                ]
            },
            {
                "name": "Wanderer",
                "levelCosts": [
                    34
                ]
            },
            {
                "name": "Kampfsportler",
                "levelCosts": [
                    49
                ]
            },
            {
                "name": "Wirt",
                "levelCosts": [
                    27
                ]
            }
        ]
    },
    {
        "id": 27,
        "name": "Phantom Paladin",
        "bb": [
            {
                "name": "Kategorie Athletik",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    5
                ],
                "id": "21"
            },
            {
                "name": "Einflussnahme",
                "levelCosts": [
                    5
                ],
                "id": "3"
            },
            {
                "name": "Staedtisch",
                "levelCosts": [
                    5
                ],
                "id": "22"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    5
                ],
                "id": "8"
            },
            {
                "name": "Kategorie Waffen",
                "levelCosts": [
                    10
                ],
                "id": "-1"
            },
            {
                "name": "List Tarnung",
                "levelCosts": [
                    10
                ],
                "id": "12"
            },
            {
                "name": "Kategorie Wahrnehmung",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "id": "0",
                "name": "Athletik Ausdauer",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "1",
                "name": "Athletik Gymnastik",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "2",
                "name": "Athletik Kraft",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "100",
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "101",
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "102",
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "103",
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "104",
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "106",
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "107",
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    10
                ]
            },
            {
                "id": "26",
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    5
                ]
            },
            {
                "id": "27",
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    5
                ]
            }
        ],
        "ff": [
            {
                "name": "Athletik Ausdauer",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "0"
            },
            {
                "name": "Spezialverteidigung",
                "levelCosts": [
                    40
                ],
                "id": "-1"
            },
            {
                "name": "Athletik Gymnastik",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "1"
            },
            {
                "name": "Staedtisch",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "22"
            },
            {
                "name": "Athletik Kraft",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "2"
            },
            {
                "name": "Tech Gewerbe Allgemein",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "23"
            },
            {
                "name": "Einflussnahme",
                "levelCosts": [
                    1,
                    4
                ],
                "id": "3"
            },
            {
                "name": "Tech Gewerbe Beruflich",
                "levelCosts": [
                    5,
                    12
                ],
                "id": "24"
            },
            {
                "name": "Gezielte Sprueche",
                "levelCosts": [
                    20
                ],
                "id": "4"
            },
            {
                "name": "Tech Gewerbe Professionell",
                "levelCosts": [
                    8
                ],
                "id": "25"
            },
            {
                "name": "Handwerk",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "5"
            },
            {
                "name": "Waffen Gruppe 1",
                "levelCosts": [
                    3,
                    9
                ],
                "id": "100"
            },
            {
                "name": "Kampfmanoever",
                "levelCosts": [
                    5,
                    12
                ],
                "id": "6"
            },
            {
                "name": "Waffen Gruppe 2",
                "levelCosts": [
                    5,
                    8
                ],
                "id": "101"
            },
            {
                "name": "Kommunikation",
                "levelCosts": [
                    3,
                    3,
                    3
                ],
                "id": "7"
            },
            {
                "name": "Waffen Gruppe 3",
                "levelCosts": [
                    6
                ],
                "id": "102"
            },
            {
                "name": "Koerperentwicklung",
                "levelCosts": [
                    4,
                    12
                ],
                "id": "8"
            },
            {
                "name": "Waffen Gruppe 4",
                "levelCosts": [
                    6
                ],
                "id": "103"
            },
            {
                "name": "Kunst Aktiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "9"
            },
            {
                "name": "Waffen Gruppe 5",
                "levelCosts": [
                    6
                ],
                "id": "104"
            },
            {
                "name": "Kunst Passiv",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Waffen Gruppe 6",
                "levelCosts": [
                    9
                ],
                "id": "106"
            },
            {
                "name": "List Angriff",
                "levelCosts": [
                    6,
                    12
                ],
                "id": "10"
            },
            {
                "name": "Waffen Gruppe 7",
                "levelCosts": [
                    9
                ],
                "id": "107"
            },
            {
                "name": "List Mechanik",
                "levelCosts": [
                    2,
                    8
                ],
                "id": "11"
            },
            {
                "name": "Waffenloser Kampf Schlag",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "List Tarnung",
                "levelCosts": [
                    2,
                    4
                ],
                "id": "12"
            },
            {
                "name": "Waffenloser Kampf Wurf",
                "levelCosts": [
                    5
                ],
                "id": "-1"
            },
            {
                "name": "Machtmanipulation",
                "levelCosts": [
                    6,
                    12
                ],
                "id": "13"
            },
            {
                "name": "Wahrnehmung Sinne",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "26"
            },
            {
                "name": "Machtwahrnehmung",
                "levelCosts": [
                    5
                ],
                "id": "14"
            },
            {
                "name": "Wahrnehmung Suchen",
                "levelCosts": [
                    1,
                    4
                ],
                "id": "27"
            },
            {
                "name": "Magiepunkte entwickeln",
                "levelCosts": [
                    8
                ],
                "id": "15"
            },
            {
                "name": "Wahrnehmung Unbewusst",
                "levelCosts": [
                    3,
                    10
                ],
                "id": "-1"
            },
            {
                "name": "Natur Tiere",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "16"
            },
            {
                "name": "Wissen Allgemein",
                "levelCosts": [
                    1,
                    3
                ],
                "id": "28"
            },
            {
                "name": "Natur Umwelt",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "17"
            },
            {
                "name": "Wissen Magisch",
                "levelCosts": [
                    3,
                    6
                ],
                "id": "29"
            },
            {
                "name": "Ruestung Leicht",
                "levelCosts": [
                    3,
                    3,
                    3
                ],
                "id": "18"
            },
            {
                "name": "Wissen Obskur",
                "levelCosts": [
                    3,
                    7
                ],
                "id": "30"
            },
            {
                "name": "Ruestung Mittel",
                "levelCosts": [
                    5,
                    5,
                    5
                ],
                "id": "19"
            },
            {
                "name": "Wissen Technisch",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "31"
            },
            {
                "name": "Ruestung Schwer",
                "levelCosts": [
                    7,
                    7,
                    7
                ],
                "id": "20"
            },
            {
                "name": "Wissenschaft / Analytisch Allgemein",
                "levelCosts": [
                    2,
                    5
                ],
                "id": "32"
            },
            {
                "name": "Selbstkontrolle",
                "levelCosts": [
                    2,
                    6
                ],
                "id": "21"
            },
            {
                "name": "Wissenschaft / Analytisch Spezialisiert",
                "levelCosts": [
                    8
                ],
                "id": "-1"
            },
            {
                "name": "Spezialangriff",
                "levelCosts": [
                    2,
                    8
                ],
                "id": "-1"
            }
        ],
        "se": [
            {
                "name": "Offene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            10
                        ],
                        "costs": [
                            8,
                            8
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            12
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            18
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            25
                        ]
                    }
                ]
            },
            {
                "name": "Geschlossene Liste",
                "progression": [
                    {
                        "levels": [
                            1,
                            5
                        ],
                        "costs": [
                            10,
                            10
                        ]
                    },
                    {
                        "levels": [
                            6,
                            10
                        ],
                        "costs": [
                            12
                        ]
                    },
                    {
                        "levels": [
                            11,
                            15
                        ],
                        "costs": [
                            25
                        ]
                    },
                    {
                        "levels": [
                            16,
                            20
                        ],
                        "costs": [
                            40
                        ]
                    },
                    {
                        "levels": [
                            20
                        ],
                        "costs": [
                            60
                        ]
                    }
                ]
            },
            {
                "name": "Basislisten alle",
                "progression": [
                    {
                        "levels": [],
                        "costs": [
                            6,
                            6,
                            6
                        ]
                    }
                ]
            }
        ],
        "ap": [
            {
                "name": "Abenteurer",
                "levelCosts": [
                    35
                ]
            },
            {
                "name": "Klatschtante",
                "levelCosts": [
                    14
                ]
            },
            {
                "name": "Akademiker",
                "levelCosts": [
                    33
                ]
            },
            {
                "name": "Kraeuterkundiger",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Assassine",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Kriegsakademie",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Athlet",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Meister des Wissens",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Bauer",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Mutter",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Berserker",
                "levelCosts": [
                    38
                ]
            },
            {
                "name": "Philosoph",
                "levelCosts": [
                    37
                ]
            },
            {
                "name": "Bettler",
                "levelCosts": [
                    19
                ]
            },
            {
                "name": "Pirat",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Bibliothekar",
                "levelCosts": [
                    34
                ]
            },
            {
                "name": "Professor",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Detektiv",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Reisender",
                "levelCosts": [
                    13
                ]
            },
            {
                "name": "Diplomat",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Ritter",
                "levelCosts": [
                    46
                ]
            },
            {
                "name": "Doktor",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Schamane",
                "levelCosts": [
                    33
                ]
            },
            {
                "name": "Edelmann",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Schreiber",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Eiferer",
                "levelCosts": [
                    27
                ]
            },
            {
                "name": "Schwindler",
                "levelCosts": [
                    18
                ]
            },
            {
                "name": "Einbrecher",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Scout",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Entdecker",
                "levelCosts": [
                    30
                ]
            },
            {
                "name": "Seemann",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Fechter",
                "levelCosts": [
                    37
                ]
            },
            {
                "name": "Sheriff",
                "levelCosts": [
                    43
                ]
            },
            {
                "name": "Fuehrer",
                "levelCosts": [
                    20
                ]
            },
            {
                "name": "Soldat",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Gefolgsmann",
                "levelCosts": [
                    22
                ]
            },
            {
                "name": "Soeldner",
                "levelCosts": [
                    42
                ]
            },
            {
                "name": "Gildenmitglied",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Spion",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Gladiator",
                "levelCosts": [
                    49
                ]
            },
            {
                "name": "Stadtwache",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Haendler",
                "levelCosts": [
                    23
                ]
            },
            {
                "name": "Strassenraeuber",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Handwerker",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Taschendieb",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Hobby Zauberer",
                "levelCosts": [
                    34
                ]
            },
            {
                "name": "Tierarzt",
                "levelCosts": [
                    25
                ]
            },
            {
                "name": "Hostesse",
                "levelCosts": [
                    18
                ]
            },
            {
                "name": "Tierfreund",
                "levelCosts": [
                    29
                ]
            },
            {
                "name": "Jaeger",
                "levelCosts": [
                    32
                ]
            },
            {
                "name": "Unterhalter",
                "levelCosts": [
                    28
                ]
            },
            {
                "name": "Kaemmerer",
                "levelCosts": [
                    24
                ]
            },
            {
                "name": "Waffenmeister",
                "levelCosts": [
                    53
                ]
            },
            {
                "name": "Kaempe",
                "levelCosts": [
                    26
                ]
            },
            {
                "name": "Wanderer",
                "levelCosts": [
                    31
                ]
            },
            {
                "name": "Kampfsportler",
                "levelCosts": [
                    47
                ]
            },
            {
                "name": "Wirt",
                "levelCosts": [
                    27
                ]
            }
        ]
    }
];
export let groups = [
    {
        "attribute": {
            "id": "0",
            "name": "Athletik-Ausdauer"
        },
        "attributes": [
            {
                "id": "0.0",
                "name": "Schwimmen"
            },
            {
                "id": "0.1",
                "name": "Sprinten"
            }
        ]
    },
    {
        "attribute": {
            "id": "1",
            "name": "Athletik-Gymnastik"
        },
        "attributes": [
            {
                "id": "1.0",
                "name": "Akrobatik"
            },
            {
                "id": "1.1",
                "name": "Entfesselungskuenstler"
            },
            {
                "id": "1.2",
                "name": "Klettern"
            }
        ]
    },
    {
        "attribute": {
            "id": "2",
            "name": "Athletik-Kraft"
        },
        "attributes": [
            {
                "id": "2.0",
                "name": "Springen"
            }
        ]
    },
    {
        "attribute": {
            "id": "3",
            "name": "Einflussnahme"
        },
        "attributes": [
            {
                "id": "3.0",
                "name": "Etikette"
            },
            {
                "id": "3.1",
                "name": "Handeln"
            },
            {
                "id": "3.2",
                "name": "Oeffentliches Reden"
            },
            {
                "id": "3.3",
                "name": "Ueberreden"
            },
            {
                "id": "3.4",
                "name": "Verfuehren"
            }
        ]
    },
    {
        "attribute": {
            "id": "4",
            "name": "Gezielte Sprueche"
        },
        "attributes": [
            {
                "id": "4.0",
                "name": "Blitzschlag"
            },
            {
                "id": "4.1",
                "name": "Eisstrahl"
            },
            {
                "id": "4.2",
                "name": "Feuerstrahl"
            },
            {
                "id": "4.3",
                "name": "Schockstrahl"
            },
            {
                "id": "4.4",
                "name": "Wasserstrahl"
            }
        ]
    },
    {
        "attribute": {
            "id": "5",
            "name": "Handwerk "
        },
        "attributes": [
            {
                "id": "5.0",
                "name": "Haeuten"
            },
            {
                "id": "5.1",
                "name": "Reparieren"
            },
            {
                "id": "5.2",
                "name": "Kochen"
            },
            {
                "id": "5.3",
                "name": "Lederbearbeitung"
            },
            {
                "id": "5.4",
                "name": "Metallbearbeitung"
            },
            {
                "id": "5.5",
                "name": "Pfeile herstellen"
            },
            {
                "id": "5.6",
                "name": "Seilkunst"
            }
        ]
    },
    {
        "attribute": {
            "id": "6",
            "name": "Kampfmanoever"
        },
        "attributes": [
            {
                "id": "6.0",
                "name": "Beeind. Manoever"
            },
            {
                "id": "6.1",
                "name": "Berittener Kampf"
            },
            {
                "id": "6.2",
                "name": "Waffe schnell ziehen"
            },
            {
                "id": "6.3",
                "name": "Pruegeln"
            }
        ]
    },
    {
        "attribute": {
            "id": "7",
            "name": "Kommunikation"
        },
        "attributes": [
            {
                "id": "7.0",
                "name": "Alfanisch"
            },
            {
                "id": "7.1",
                "name": "Azaack"
            },
            {
                "id": "7.2",
                "name": "Gemeinsprache"
            },
            {
                "id": "7.3",
                "name": "Gnogg"
            },
            {
                "id": "7.4",
                "name": "Kenku"
            },
            {
                "id": "7.5",
                "name": "Knossos"
            },
            {
                "id": "7.6",
                "name": "Loxodon"
            },
            {
                "id": "7.7",
                "name": "Nordisch"
            },
            {
                "id": "7.8",
                "name": "Tortoise"
            },
            {
                "id": "7.9",
                "name": "Zwergisch"
            }
        ]
    },
    {
        "attribute": {
            "id": "8",
            "name": "Koerperentwicklung"
        },
        "attributes": []
    },
    {
        "attribute": {
            "id": "9",
            "name": "Kunst-Aktiv"
        },
        "attributes": [
            {
                "id": "9.0",
                "name": "Geraeusche imitieren"
            },
            {
                "id": "9.1",
                "name": "Geschichten erzaehlen"
            },
            {
                "id": "9.2",
                "name": "Instrument spielen"
            },
            {
                "id": "9.3",
                "name": "Schauspielen"
            },
            {
                "id": "9.4",
                "name": "Singen"
            },
            {
                "id": "9.5",
                "name": "Tanzen"
            }
        ]
    },
    {
        "attribute": {
            "id": "10",
            "name": "List-Angriff"
        },
        "attributes": [
            {
                "id": "10.0",
                "name": "Hinterhalt"
            }
        ]
    },
    {
        "attribute": {
            "id": "11",
            "name": "List-Mechanik"
        },
        "attributes": [
            {
                "id": "11.0",
                "name": "Fallen entschaerfen"
            },
            {
                "id": "11.1",
                "name": "Fallen stellen"
            },
            {
                "id": "11.2",
                "name": "Faelschen"
            },
            {
                "id": "11.3",
                "name": "Gegenstand verstecken"
            },
            {
                "id": "11.4",
                "name": "Imitat herstellen"
            },
            {
                "id": "11.5",
                "name": "Schloesser oeffnen"
            }
        ]
    },
    {
        "attribute": {
            "id": "12",
            "name": "List-Tarnung"
        },
        "attributes": [
            {
                "id": "12.0",
                "name": "Fingerfertigkeit"
            },
            {
                "id": "12.1",
                "name": "Schleichen"
            },
            {
                "id": "12.2",
                "name": "Taschendiebstahl"
            },
            {
                "id": "12.3",
                "name": "Verstecken"
            }
        ]
    },
    {
        "attribute": {
            "id": "13",
            "name": "Machtmanipulation"
        },
        "attributes": [
            {
                "id": "13.0",
                "name": "Ruestung ueberwinden"
            }
        ]
    },
    {
        "attribute": {
            "id": "14",
            "name": "Machtwahrnehmung"
        },
        "attributes": [
            {
                "id": "14.0",
                "name": "Mag. Geg. benutzen"
            },
            {
                "id": "14.1",
                "name": "Traumdeutung"
            }
        ]
    },
    {
        "attribute": {
            "id": "15",
            "name": "Magiepunkte entw."
        },
        "attributes": []
    },
    {
        "attribute": {
            "id": "16",
            "name": "Natur-Tiere"
        },
        "attributes": [
            {
                "id": "16.0",
                "name": "Reiten"
            },
            {
                "id": "16.1",
                "name": "Tierheilung "
            },
            {
                "id": "16.2",
                "name": "Tiermeisterschaft"
            },
            {
                "id": "16.3",
                "name": "Wagenlenker"
            }
        ]
    },
    {
        "attribute": {
            "id": "17",
            "name": "Natur-Umwelt"
        },
        "attributes": [
            {
                "id": "17.0",
                "name": "Hoehlenforschung"
            },
            {
                "id": "17.1",
                "name": "Jagen"
            },
            {
                "id": "17.2",
                "name": "Ueberleben"
            },
            {
                "id": "17.3",
                "name": "Wettervorhersage"
            }
        ]
    },
    {
        "attribute": {
            "id": "18",
            "name": "Ruestung-Leicht"
        },
        "attributes": [
            {
                "id": "18.0",
                "name": "Leichtes Leder (RK 5-8)"
            },
            {
                "id": "18.1",
                "name": "Beschl.Leder (RK 9-12)"
            }
        ]
    },
    {
        "attribute": {
            "id": "19",
            "name": "Ruestung-Mittel"
        },
        "attributes": [
            {
                "id": "19.0",
                "name": "Kette (RK 13-16)"
            }
        ]
    },
    {
        "attribute": {
            "id": "20",
            "name": "Ruestung-Schwer"
        },
        "attributes": [
            {
                "id": "20.0",
                "name": "Platte (RK 17-20)"
            }
        ]
    },
    {
        "attribute": {
            "id": "21",
            "name": "Selbstkontrolle"
        },
        "attributes": [
            {
                "id": "21.0",
                "name": "Benommenheit entf."
            },
            {
                "id": "21.1",
                "name": "Manoever unter Benom."
            }
        ]
    },
    {
        "attribute": {
            "id": "22",
            "name": "Staedtisch"
        },
        "attributes": [
            {
                "id": "22.0",
                "name": "Gassenwissen"
            },
            {
                "id": "22.1",
                "name": "Kontaktieren"
            },
            {
                "id": "22.2",
                "name": "Unter Leute mischen"
            }
        ]
    },
    {
        "attribute": {
            "id": "23",
            "name": "Tech./Gewerbe-All."
        },
        "attributes": [
            {
                "id": "23.0",
                "name": "Erste Hilfe"
            },
            {
                "id": "23.1",
                "name": "Orientierung"
            },
            {
                "id": "23.2",
                "name": "Steuermann"
            }
        ]
    },
    {
        "attribute": {
            "id": "24",
            "name": "Tech./Gewerbe-Ber."
        },
        "attributes": [
            {
                "id": "24.0",
                "name": "Kraeuter verarbeiten"
            },
            {
                "id": "24.1",
                "name": "Navigation"
            },
            {
                "id": "24.2",
                "name": "Schaetzen allgemein"
            }
        ]
    },
    {
        "attribute": {
            "id": "25",
            "name": "Tech./Gewerbe-Prof."
        },
        "attributes": [
            {
                "id": "25.0",
                "name": "Bergbau"
            },
            {
                "id": "25.1",
                "name": "Chirurgie"
            },
            {
                "id": "25.2",
                "name": "Krankheitskunde"
            },
            {
                "id": "25.3",
                "name": "Zweite Hilfe"
            }
        ]
    },
    {
        "attribute": {
            "id": "26",
            "name": "Wahrnehmung Sinne"
        },
        "attributes": [
            {
                "id": "26.0",
                "name": "Situationswahrnehmung"
            },
            {
                "id": "26.1",
                "name": "Zeitsinn"
            }
        ]
    },
    {
        "attribute": {
            "id": "27",
            "name": "Wahrnehmung Suche"
        },
        "attributes": [
            {
                "id": "27.0",
                "name": "Beobachten"
            },
            {
                "id": "27.1",
                "name": "Gift entdecken"
            },
            {
                "id": "27.2",
                "name": "Spuren untersuchen"
            },
            {
                "id": "27.3",
                "name": "Spuren verfolgen"
            },
            {
                "id": "27.4",
                "name": "Verstecktes entdecken"
            }
        ]
    },
    {
        "attribute": {
            "id": "28",
            "name": "Wissen-Allgemein"
        },
        "attributes": [
            {
                "id": "28.0",
                "name": "Heraldik"
            },
            {
                "id": "28.1",
                "name": "KK Al Anfa"
            },
            {
                "id": "28.2",
                "name": "KK Azaacks"
            },
            {
                "id": "28.3",
                "name": "KK Bjarvak"
            },
            {
                "id": "28.4",
                "name": "KK Bornlande"
            },
            {
                "id": "28.5",
                "name": "KK Kobolde"
            },
            {
                "id": "28.6",
                "name": "KK Loxodon"
            },
            {
                "id": "28.7",
                "name": "KK Minotaur"
            },
            {
                "id": "28.8",
                "name": "KK Nords"
            },
            {
                "id": "28.9",
                "name": "KK Nostria"
            },
            {
                "id": "28.10",
                "name": "KK Sternenreich"
            },
            {
                "id": "28.11",
                "name": "KK Zwerge"
            },
            {
                "id": "28.12",
                "name": "Pflanzenkunde"
            },
            {
                "id": "28.13",
                "name": "RW Berge"
            },
            {
                "id": "28.14",
                "name": "RW Kuesten"
            },
            {
                "id": "28.15",
                "name": "RW Mittellande"
            },
            {
                "id": "28.16",
                "name": "RW Norden"
            },
            {
                "id": "28.17",
                "name": "RW Wueste"
            },
            {
                "id": "28.18",
                "name": "Religion"
            },
            {
                "id": "28.19",
                "name": "Tierkunde"
            }
        ]
    },
    {
        "attribute": {
            "id": "29",
            "name": "Wissen-Magisch"
        },
        "attributes": [
            {
                "id": "29.0",
                "name": "Artefaktkunde"
            },
            {
                "id": "29.1",
                "name": "Untotenkunde"
            }
        ]
    },
    {
        "attribute": {
            "id": "30",
            "name": "Wissen-Obskur"
        },
        "attributes": [
            {
                "id": "30.0",
                "name": "Daemonenkunde"
            },
            {
                "id": "30.1",
                "name": "Drachenkunde"
            }
        ]
    },
    {
        "attribute": {
            "id": "31",
            "name": "Wissen-Technisch"
        },
        "attributes": [
            {
                "id": "31.0",
                "name": "Giftkunde"
            },
            {
                "id": "31.1",
                "name": "Handelskunde"
            },
            {
                "id": "31.2",
                "name": "Kraeuterkunde"
            },
            {
                "id": "31.3",
                "name": "Metallkunde"
            },
            {
                "id": "31.4",
                "name": "Schloesserkunde"
            },
            {
                "id": "31.5",
                "name": "Steinkunde"
            }
        ]
    },
    {
        "attribute": {
            "id": "32",
            "name": "Wissenschaft/Analy."
        },
        "attributes": [
            {
                "id": "32.0",
                "name": "Mathematik"
            }
        ]
    }
];
